/* js/arrival-touch.js */
// Where this device came from, sent once at signup (dashboard/js/api.js) and
// cleaned by backend/signup/arrival.py. Two records, each
// {v: path, r: referring host, u: utm_source, o: "www" | "app", t}:
//
//   ghd_entry       the first page opened, kept 90 days and never replaced inside them;
//   ghd_last_touch  the latest load that came from another site or carries
//                   ?utm_source=, replaced by each newer one.
//
// From the URL only the path and utm_source: any other parameter can carry an ad id.
// AI apps often send no Referer but ChatGPT appends ?utm_source=chatgpt.com, so
// either one identifies the source.
//
// Runs on both origins. On the app (<html data-origin="app">, which survives the
// build folding this file into app-bundle.js where a tag attribute would not) it covers a
// visitor who opens the app without passing www; www's own records arrive later
// through site/go/, and app.js keeps the earlier entry and the later last touch.
// Keys are spelled out, as in head-init.js; GHD.KEYS is the registry of record.
(function () {
  // Hosts that are a step in our own flows, never a source: our origins and the
  // TWA, and the sign-in and payment pages that send people back to us.
  var NOT_A_SOURCE =
    /(^|\.)(gethumandesign\.com|supabase\.co|stripe\.com|paypal\.com|localhost)$|^(accounts\.google\.com|appleid\.apple\.com|127\.0\.0\.1|com\.gethumandesign\.app)$/;
  var origin;
  var touch;
  var external;
  try {
    origin = document.documentElement.getAttribute("data-origin") === "app" ? "app" : "www";
    var ref = "";
    try {
      ref = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : "";
    } catch (e) {}
    var ours = !!ref && NOT_A_SOURCE.test(ref);
    // On the app, a hop from www, a sign-in return or an email link is a step
    // in a journey that started elsewhere, not an arrival.
    if (
      origin === "app" &&
      (ours ||
        location.hash.indexOf("#ghd_handoff=") === 0 ||
        /(^|[?&])(code|token_hash|error)=/.test(location.search.slice(1)) ||
        /access_token=/.test(location.hash))
    )
      return;
    var utm = String(new URLSearchParams(location.search).get("utm_source") || "")
      .trim()
      .toLowerCase();
    if (!/^[a-z0-9][a-z0-9._-]{0,63}$/.test(utm)) utm = "";
    external = (!!ref && !ours) || !!utm;
    touch = JSON.stringify({ v: location.pathname, r: ref, u: utm, o: origin, t: Date.now() });
  } catch (e) {
    return;
  }
  try {
    var entry = null;
    try {
      entry = JSON.parse(localStorage.getItem("ghd_entry") || "null");
    } catch (e) {}
    if (!entry || !(Date.now() - entry.t < 90 * 24 * 3600 * 1000)) localStorage.setItem("ghd_entry", touch);
  } catch (e) {}
  try {
    if (external) localStorage.setItem("ghd_last_touch", touch);
  } catch (e) {}
})();

;
/* logo.js */
(function () {
  // Canonical "get humandesign" teardrop mark (32-unit design box).
  // Glyph bbox ~ x7..25, y9..25; visual centre (16, 17.05); two-dot channel knockout.
  var PATH = "M 9,9 L 23,9 Q 26,9 24.3,12 L 17.7,23.6 Q 16,26.6 14.3,23.6 L 7.7,12 Q 6,9 9,9 Z";
  var uid = 0;

  function maskDefs(id) {
    return (
      '<defs><mask id="' +
      id +
      '">' +
      '<rect width="40" height="40" fill="white"/>' +
      '<circle cx="16" cy="13" r="1.9" fill="black"/>' +
      '<circle cx="16" cy="18.4" r="1.9" fill="black"/>' +
      '<rect x="15.525" y="13" width="0.95" height="5.4" fill="black"/>' +
      "</mask></defs>"
    );
  }

  // Standalone icon. viewBox crops to the glyph so it sits centred in its box.
  function logoSVG(opts) {
    var fill = opts && opts.fill != null ? opts.fill : "var(--accent)";
    var width = opts && opts.width != null ? opts.width : 26;
    var height = opts && opts.height != null ? opts.height : 26;
    var cls = opts && opts.cls != null ? opts.cls : "";
    var id = "lm-" + uid++;
    var clsAttr = cls ? ' class="' + cls + '"' : "";
    return (
      "<svg" +
      clsAttr +
      ' width="' +
      width +
      '" height="' +
      height +
      '" viewBox="4 5 24 24" fill="none" aria-hidden="true">' +
      maskDefs(id) +
      '<path d="' +
      PATH +
      '" fill="' +
      fill +
      '" mask="url(#' +
      id +
      ')"/>' +
      "</svg>"
    );
  }

  // Wordmark lockup. Icon sized to 4/3 em (~2x cap-height) and shifted so the
  // bottom dot's lower edge sits exactly on the text baseline (y=19); gap = 0.4 em.
  // The text is set at 2x and halved: Safari 15 lays text out at a whole-number
  // font size, and 14.5 widened to 15 pushed the last "n" past the viewBox.
  var VB_W = 147,
    VB_H = 28;
  function logoWithTextSVG(opts) {
    var height = opts && opts.height != null ? opts.height : 28;
    var cls = opts && opts.cls != null ? opts.cls : "";
    var accentFill = opts && opts.accentFill != null ? opts.accentFill : "var(--accent)";
    var textFill = opts && opts.textFill != null ? opts.textFill : "var(--text)";
    var id = "lm-" + uid++;
    var clsAttr = cls ? ' class="' + cls + '"' : "";
    var width = Math.round(height * (VB_W / VB_H));
    return (
      "<svg" +
      clsAttr +
      ' height="' +
      height +
      '" width="' +
      width +
      '" viewBox="0 0 ' +
      VB_W +
      " " +
      VB_H +
      '" fill="none" aria-hidden="true" text-rendering="geometricPrecision">' +
      '<g transform="translate(-5.5185,-5.5285) scale(1.2083)">' +
      maskDefs(id) +
      '<path d="' +
      PATH +
      '" fill="' +
      accentFill +
      '" mask="url(#' +
      id +
      ')"/>' +
      "</g>" +
      '<text transform="scale(0.5)" y="38" font-family="\'DM Sans\', system-ui, sans-serif" font-size="29" letter-spacing="-0.66">' +
      '<tspan x="60.86" fill="' +
      accentFill +
      '" font-weight="500">get</tspan>' +
      '<tspan dx="2" fill="' +
      textFill +
      '" font-weight="700">humandesign</tspan>' +
      "</text>" +
      "</svg>"
    );
  }

  // Greyscale secondary lockup (Option B): same geometry, two-tone grey instead
  // of orange. Mark + "get" use --text-mid (a warm mid-grey defined for both
  // themes); "humandesign" uses --text. Theme-aware via the app's [data-theme].
  function logoGreyWithTextSVG(opts) {
    opts = opts || {};
    return logoWithTextSVG({
      height: opts.height,
      cls: opts.cls,
      accentFill: opts.accentFill != null ? opts.accentFill : "var(--text-mid)",
      textFill: opts.textFill != null ? opts.textFill : "var(--text)",
    });
  }

  window.logoSVG = logoSVG;
  window.logoWithTextSVG = logoWithTextSVG;
  window.logoGreyWithTextSVG = logoGreyWithTextSVG;

  function inject() {
    document.querySelectorAll("[data-logo-header]").forEach(function (el) {
      el.outerHTML = logoSVG({ cls: "logo-icon", width: 34, height: 34 });
    });
    document.querySelectorAll("[data-logo-footer]").forEach(function (el) {
      el.outerHTML = logoSVG({ fill: "var(--text)", width: 64, height: 64 });
    });
    document.querySelectorAll("[data-logo-with-text]").forEach(function (el) {
      var h = el.getAttribute("data-logo-with-text") || "28";
      el.outerHTML = logoWithTextSVG({ height: parseInt(h, 10) });
    });
    document.querySelectorAll("[data-logo-grey-with-text]").forEach(function (el) {
      var h = el.getAttribute("data-logo-grey-with-text") || "22";
      el.outerHTML = logoGreyWithTextSVG({ height: parseInt(h, 10) });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", inject);
  } else {
    inject();
  }
})();

;
/* dashboard/js/error-reporter.js */
/* Browser-side error reporting, through our own backend.
 *
 * Posts uncaught errors, unhandled rejections and GHD.reportClientError calls to
 * `/v1/client-error`. One report per (kind, message) per page session, at most 20
 * per page load, and a failed send is dropped, never re-reported: this file must
 * not be able to cause an error. Off on localhost unless `?report_errors=on`.
 *
 * First in every page's deferred chain and reads nothing as it evaluates, so a
 * throw in any later file is caught; a report raised before `API_BASE_URL` exists
 * waits for DOMContentLoaded. */
(function () {
  window.GHD = window.GHD || {};

  var ENDPOINT = "/v1/client-error";
  var MAX_REPORTS = 20;
  // Mirror the backend schema (ClientErrorIn): over these it answers 422.
  var MAX_MESSAGE = 2000;
  var MAX_STACK = 8000;
  // Replaced by the release stamp at deploy, like every other `__GHD_VERSION__`.
  var VERSION = "__GHD_VERSION__";

  var seen = new Set();
  var sent = 0;
  var pending = [];
  var flushArmed = false;

  var host = location.hostname;
  var isLocal = host === "localhost" || host === "127.0.0.1";
  var forced = /[?&]report_errors=on(?:&|$)/.test(location.search || "");
  var enabled = !isLocal || forced;

  // Two environments, because this file is on both origins. The app shell
  // defines `CONFIG` (dashboard/js/config.js); every www page defines
  // `GHD_APP` (app-config.js) and never loads config.js at all. Reading only
  // `CONFIG` is why www still reported nothing after the reporter was put on
  // its pages: `send` answered false for every report, `queue` held them to
  // DOMContentLoaded, and `flush` dropped the lot — silently, because
  // `reportClientError` reports a queued payload as taken.
  function apiBase() {
    var env = window.CONFIG || window.GHD_APP;
    var base = env && env.API_BASE_URL;
    return typeof base === "string" && base ? base : null;
  }

  function headers() {
    var out = { "Content-Type": "application/json" };
    // The same bearer Api._request sends; optional here, because a report from
    // the login page has no session to carry.
    var app = window.App;
    var token = app && app._session && app._session.access_token;
    if (token) out.Authorization = "Bearer " + token;
    return out;
  }

  /** POST one report; false when the environment it needs is not there yet. */
  function send(payload) {
    var base = apiBase();
    if (!base) return false;
    try {
      var sending = fetch(base + ENDPOINT, {
        method: "POST",
        keepalive: true,
        headers: headers(),
        body: JSON.stringify(payload),
      });
      // A rejected send would otherwise surface as an unhandled rejection —
      // which this file listens for.
      if (sending && typeof sending.catch === "function") sending.catch(function () {});
    } catch (_error) {
      /* never let the reporter be the error */
    }
    return true;
  }

  function flush() {
    var items = pending.splice(0);
    // Still no environment after the whole chain has run: nothing to send with.
    if (!apiBase()) return;
    items.forEach(send);
  }

  // A report raised before config.js and app-config.js have evaluated waits
  // for the end of the deferred chain, which is DOMContentLoaded.
  function queue(payload) {
    pending.push(payload);
    if (flushArmed) return;
    flushArmed = true;
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", flush);
    else setTimeout(flush, 0);
  }

  function isNoise(message, stack) {
    if (/ResizeObserver loop/.test(message)) return true;
    // A cross-origin script's error arrives as exactly this and nothing else.
    if (message === "Script error." || message === "Script error") return true;
    if (/\b(?:chrome|moz|safari|safari-web|ms-browser)-extension:\/\//.test(stack || "")) return true;
    // The WebExtension API, which no page of ours calls. Safari rejects an
    // extension's content script with this and no stack at all, so the
    // origin test above never sees it.
    if (/\bruntime\.(?:sendMessage|connect)\b/.test(message)) return true;
    return false;
  }

  function currentRoute() {
    try {
      var router = GHD.router;
      var path = router && typeof router.current === "function" ? router.current() : location.pathname;
      var segment = String(path || "/")
        .split("?")[0]
        .split("/")
        .filter(Boolean)[0];
      return segment || "root";
    } catch (_error) {
      return "unknown";
    }
  }

  /* Report one error. */
  GHD.reportClientError = function (kind, message, stack, extra) {
    try {
      if (!enabled) return false;
      var text = String(message == null ? "" : message).trim();
      if (extra && extra.context) text = String(extra.context) + ": " + text;
      text = text.slice(0, MAX_MESSAGE);
      if (!text) return false;
      var trace = stack == null ? null : String(stack).slice(0, MAX_STACK);
      if (isNoise(text, trace)) return false;
      var key = kind + "\n" + text;
      if (seen.has(key)) return false;
      if (sent >= MAX_REPORTS) return false;
      seen.add(key);
      sent += 1;
      var payload = {
        message: text,
        stack: trace,
        route: currentRoute(),
        version: VERSION,
        kind: kind,
      };
      if (!send(payload)) queue(payload);
      return true;
    } catch (_error) {
      return false;
    }
  };

  window.addEventListener("error", function (event) {
    var error = event && event.error;
    var message = (error && error.message) || (event && event.message) || "";
    var stack = error && error.stack;
    if (!stack && event && event.filename) {
      stack = message + " (" + event.filename + ":" + event.lineno + ":" + event.colno + ")";
    }
    GHD.reportClientError("error", message, stack, null);
  });

  /* The class an object came from, or "Object" when that is not a class name.
     Taken off the prototype, not `reason.constructor`, which an ordinary object
     can set to any value; the name must also look like an identifier. */
  var CLASS_NAME = /^[A-Za-z_$][A-Za-z0-9_$]{0,39}$/;
  function className(reason) {
    var proto = Object.getPrototypeOf(reason);
    var ctor = proto && Object.prototype.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    var name = ctor && typeof ctor === "function" ? ctor.name : null;
    return typeof name === "string" && CLASS_NAME.test(name) ? name : "Object";
  }

  /* What to call a rejection reason that is not an Error. An object is described
     by its constructor and own key names: never values and never its toString (a
     URL's carries share tokens and OAuth codes). A reason that IS the string
     "[object Object]" is checked for first, so its text is kept. */
  function reasonText(reason) {
    try {
      if (reason === null || typeof reason !== "object") return String(reason);
      return className(reason) + "{" + Object.keys(reason).slice(0, 12).join(",") + "}";
    } catch (_error) {
      // A reason whose constructor or keys cannot be read. It exists, and that
      // it is this strange is the most useful thing left to say about it.
      return "unreadable rejection reason";
    }
  }

  window.addEventListener("unhandledrejection", function (event) {
    var reason = event && event.reason;
    var message = reason && reason.message ? reason.message : reasonText(reason);
    GHD.reportClientError("unhandledrejection", message, reason && reason.stack, null);
  });
})();

;
/* dashboard/i18n/bundles-loader.js */
// Generated by tools/build/i18n_bundle.py — do not edit by hand.
// Fetch the per-locale message bundle. Deferred and first of the app's own
// scripts, so nothing blocks the parser for it; js/i18n.js swaps the table
// in when the bundle lands and js/app.js holds the first paint for
// window.__GHD_BUNDLE_READY__. No page script calls t() as it evaluates.
// Locale resolution must match js/i18n.js.
(function () {
  var SHIPPED = ["en", "nl", "de", "es", "fr", "pt", "it", "hu", "ru", "pl", "id", "tr", "ca", "uk", "el", "cs", "sv", "nb", "ro", "fi", "th", "vi", "bg", "da", "ja", "ko", "zh"];
  function pick(code) {
    if (!code) return null;
    var primary = String(code).replace("_", "-").split("-")[0].toLowerCase();
    return SHIPPED.indexOf(primary) !== -1 ? primary : null;
  }
  // Set by i18n/arrival-locale.js from the ?lang= a localized marketing
  // page named on the link over here. Ahead of storage because on a device
  // that has none it is the only thing carrying the visitor's language.
  var arrival = typeof window !== "undefined" ? window.__GHD_ARRIVAL_LANG__ : null;
  var stored = null;
  var signedOutAuth = null;
  try {
    stored = localStorage.getItem("ghd_ui_lang");
    signedOutAuth = sessionStorage.getItem("ghd_signed_out_auth_locale");
  } catch (e) {}
  var lang =
    pick(arrival) ||
    pick(stored) ||
    pick(signedOutAuth) ||
    pick(typeof navigator !== "undefined" ? navigator.language : null) ||
    "en";
  // The registry the runtime clamps codes against. The bundle carries it
  // too; publishing it here lets js/i18n.js resolve the same locale before
  // the bundle lands.
  window.__GHD_LOCALES__ = window.__GHD_LOCALES__ || [{"code": "en", "native": "English", "english": "English"}, {"code": "nl", "native": "Nederlands", "english": "Dutch"}, {"code": "de", "native": "Deutsch", "english": "German"}, {"code": "es", "native": "Español", "english": "Spanish"}, {"code": "fr", "native": "Français", "english": "French"}, {"code": "pt", "native": "Português", "english": "Portuguese"}, {"code": "it", "native": "Italiano", "english": "Italian"}, {"code": "hu", "native": "Magyar", "english": "Hungarian"}, {"code": "ru", "native": "Русский", "english": "Russian"}, {"code": "pl", "native": "Polski", "english": "Polish"}, {"code": "id", "native": "Bahasa Indonesia", "english": "Indonesian"}, {"code": "tr", "native": "Türkçe", "english": "Turkish"}, {"code": "ca", "native": "Català", "english": "Catalan"}, {"code": "uk", "native": "Українська", "english": "Ukrainian"}, {"code": "el", "native": "Ελληνικά", "english": "Greek"}, {"code": "cs", "native": "Čeština", "english": "Czech"}, {"code": "sv", "native": "Svenska", "english": "Swedish"}, {"code": "nb", "native": "Norsk", "english": "Norwegian"}, {"code": "ro", "native": "Română", "english": "Romanian"}, {"code": "fi", "native": "Suomi", "english": "Finnish"}, {"code": "th", "native": "ไทย", "english": "Thai"}, {"code": "vi", "native": "Tiếng Việt", "english": "Vietnamese"}, {"code": "bg", "native": "Български", "english": "Bulgarian"}, {"code": "da", "native": "Dansk", "english": "Danish"}, {"code": "ja", "native": "日本語", "english": "Japanese"}, {"code": "ko", "native": "한국어", "english": "Korean"}, {"code": "zh", "native": "繁體中文", "english": "Traditional Chinese", "bcp47": "zh-Hant"}];
  // The bundle sits next to this loader, so resolve it against the loader's
  // own URL: then any document in the tree can load the loader from its own
  // path (the app shell at its base, the OAuth consent page two levels down)
  // and the bundle is still fetched from the loader's directory — which, on
  // a built page, is this release's /v/<release>/i18n/ copy (the pages and
  // the service worker name the same URL, so the precached copy is a hit).
  // The literal below is the pre-currentScript fallback: that directory,
  // root-absolute, with the placeholder nginx strips on localhost.
  var bundleSrc = "/v/__GHD_VERSION__/i18n/bundles." + lang + ".js";
  try {
    if (document.currentScript && document.currentScript.src) {
      bundleSrc = new URL("../i18n/bundles." + lang + ".js", document.currentScript.src).href;
    }
  } catch (e) {}
  var el = document.createElement("script");
  el.src = bundleSrc;
  window.__GHD_BUNDLE_READY__ = new Promise(function (resolve) {
    el.onload = function () {
      resolve(true);
    };
    // A bundle that cannot be fetched must not hold the app: the runtime
    // boots on the keys and says so on the console.
    el.onerror = function () {
      resolve(false);
    };
  });
  document.head.appendChild(el);
})();

;
/* dashboard/js/router.js */
/**
 * In-app routing: real paths, not hash fragments.
 *
 * Cloudflare Pages answers every unmatched app path with index.html. The
 * fragment is left free because Supabase OAuth (#access_token=), password
 * recovery and the site->app handoff (#ghd_handoff=) already use it.
 */
(function () {
  "use strict";
  var root = typeof window !== "undefined" ? window : globalThis;
  root.GHD = root.GHD || {};

  // The pure half of this module (base, href, current, isRoute, query) is defined
  // whether or not there is a document; only the wiring at the bottom needs one.
  // That is what lets a test evaluate the real router alongside the rest of the
  // GHD namespace instead of hand-rolling a stub that can drift from it.
  var doc = typeof document !== "undefined" ? document : null;
  // Resolved per call, not captured: in a browser `location` is one live object
  // and either would work, but capturing it makes the module silently ignore a
  // context that swaps the object out — which is exactly what a test does when
  // it moves the sandbox to another route.
  var NO_LOCATION = { pathname: "/", search: "", hash: "", href: "" };
  function loc() {
    return typeof location !== "undefined" && location ? location : NO_LOCATION;
  }

  // There is no base. This shell is served by one origin, at its root, so a
  // route IS a path: href("/people") is "/people" and nothing has to be stripped
  // back off on the way in.
  //
  // It was not always so. www served the same shell under /dashboard/ until
  // Android 1.0.7 aged out, and the base had to be *derived* — from the URL of
  // one of the app's own scripts, with the per-release /v/<sha>/ prefix stripped
  // first, because reading it off location.pathname would have mistaken the
  // legacy *route* "/dashboard" (an old "#/dashboard" link, which App.route
  // redirects to /settings) for the legacy base. That derivation reached
  // production wrong once, and every link in the app pointed at
  // /v/ghd-<sha>/chat. What survives of it is the rule it was got wrong by, and
  // test_dashboard_router_base.py still holds this file to it: a release is how
  // an asset is addressed, never where the app lives.

  /**
   * Every route the app answers — one row per pattern, in match order. App.route
   * and the link allowlist both read this one table. The allowlist matters
   * because the app origin also serves real pages (OAuth consent, manifests,
   * /docs assets, icons) that must never be routed client-side.
   *
   * Fields:
   *   match    RegExp over the path, query included. First match wins, so order
   *            is specificity order. Capture groups are the page's arguments.
   *   prefix   the path this row adds to the link allowlist (isRoute). Omitted on
   *            rows sharing an earlier prefix, and on the legacy "/dashboard".
   *   chunk    the route chunk the page's files live in (GHD.loadRoute).
   *   page     the module App.route calls, by name on `window`.
   *   call     the method on it.
   *   chrome   "shell"    the app shell: no header, no footer, shell classes kept
   *            "auth"     no header, footer kept — the signed-out screens
   *            "full"     no header, no footer — onboarding
   *            "document" header and footer, the centred column
   *   guarded  false for pages a signed-out visitor may see; default bounces to /login.
   *   redirect an alias: given the current path, the route to navigate to instead.
   */
  var ROUTES = [
    {
      match: /^\/login(?:\?|$)/,
      prefix: "/login",
      chunk: "auth",
      page: "Auth",
      call: "renderLogin",
      chrome: "auth",
      guarded: false,
    },
    {
      match: /^\/signup(?:\?|$)/,
      prefix: "/signup",
      chunk: "auth",
      page: "Auth",
      call: "renderSignup",
      chrome: "auth",
      guarded: false,
    },
    {
      match: /^\/reset-password(?:\?|$)/,
      prefix: "/reset-password",
      chunk: "auth",
      page: "Auth",
      call: "renderResetPassword",
      chrome: "auth",
      guarded: false,
    },
    {
      match: /^\/set-password(?:\?|$)/,
      prefix: "/set-password",
      chunk: "auth",
      page: "Auth",
      call: "renderSetPassword",
      chrome: "auth",
      guarded: false,
    },
    {
      match: /^\/settings(?:\?|$)/,
      prefix: "/settings",
      chunk: "settings",
      page: "Settings",
      call: "render",
      chrome: "shell",
    },
    // The signed-in pricing page's buttons: straight on to Stripe Checkout.
    {
      match: /^\/checkout(?:\?|$)/,
      prefix: "/checkout",
      chunk: "settings",
      page: "Settings",
      call: "renderCheckout",
      chrome: "full",
    },
    // "/chart" predates the person page and still arrives from old links and
    // e-mails; its query (?person=…) is the whole payload, so it travels.
    {
      match: /^\/chart(?:\?|$)/,
      prefix: "/chart",
      chrome: "document",
      redirect: function (path) {
        return "/people" + (path.indexOf("?") === -1 ? "" : "?" + path.split("?")[1]);
      },
    },
    // The add form was a panel under the roster, opened by `?action=add`; old
    // links, the AI's and settings' `me=1` among them, still arrive that way.
    {
      match: /^\/people\?(?:[^#]*&)?action=add(?:&|$)/,
      chrome: "shell",
      redirect: function (path) {
        return "/people/new" + (new URLSearchParams(path.split("?")[1]).get("me") === "1" ? "?me=1" : "");
      },
    },
    {
      match: /^\/people\/new(?:\?|$)/,
      chunk: "people",
      page: "People",
      call: "renderNewPerson",
      chrome: "shell",
    },
    {
      match: /^\/people\/temp(?:\?|$)/,
      chunk: "people",
      page: "People",
      call: "renderTempChartDetail",
      chrome: "shell",
    },
    { match: /^\/people(?:\?|$)/, prefix: "/people", chunk: "people", page: "People", call: "render", chrome: "shell" },
    // Query-free spellings of the person page and its PDF, for links printed in
    // MCP tool results: some hosts have shown a link with a query string as a
    // web search. Before the uuid row, which would read /people/<id>/pdf as the
    // plain chart. "me" resolves through ?person=me, as chat cards' links do.
    {
      match: /^\/people\/(me(\/pdf)?|[0-9a-f-]+\/pdf)(?:\?|$)/,
      chrome: "shell",
      redirect: function (path) {
        var m = path.match(/^\/people\/([^/?]+)(\/pdf)?\??(.*)$/);
        var q = new URLSearchParams(m[3]);
        if (m[1] === "me") q.set("person", "me");
        if (m[2]) q.set("action", "download-pdf");
        return (m[1] === "me" ? "/people" : "/people/" + m[1]) + "?" + q;
      },
    },
    { match: /^\/people\/([0-9a-f-]+)/, chunk: "people", page: "People", call: "renderChartDetail", chrome: "shell" },
    // Before the plain /groups row, or the uuid reads as the roster.
    { match: /^\/groups\/([0-9a-f-]+)/, chunk: "groups", page: "Group", call: "render", chrome: "shell" },
    { match: /^\/groups(?:\?|$)/, prefix: "/groups", chunk: "groups", page: "Groups", call: "render", chrome: "shell" },
    // Two saved-person ids (a uuid, or the literal "me"). A deep link may carry
    // a query — /compare/<a>/<b>?from=chat&conv=… — which the ids stop before.
    {
      match: /^\/compare\/([0-9a-f-]+|me)\/([0-9a-f-]+|me)(?:\?|$)/i,
      chunk: "compare",
      page: "Compare",
      call: "render",
      chrome: "shell",
    },
    {
      match: /^\/compare(?:\?|$)/,
      prefix: "/compare",
      chunk: "compare",
      page: "Compare",
      call: "renderPicker",
      chrome: "shell",
    },
    // Before /chat, which is the row every unmatched app path falls towards.
    {
      match: /^\/transits(?:\?|$)/,
      prefix: "/transits",
      chunk: "transits",
      page: "Transits",
      call: "render",
      chrome: "shell",
    },
    // Cycles and returns: one person's lifetime timeline, and the chart of one
    // return read against theirs. Its own chunk; it borrows the painter, the
    // picker and the Pro card by being tagged onto their files.
    {
      match: /^\/cycles(?:\?|$)/,
      prefix: "/cycles",
      chunk: "cycles",
      page: "Cycles",
      call: "render",
      chrome: "shell",
    },
    // One chunk for both: the conversation list page is the chat's own list
    // module on a page of its own, and the shell preloads this chunk, so the
    // landing most sessions make pays no round trip for it.
    { match: /^\/chat(?:\?|$)/, prefix: "/chat", chunk: "chat", page: "Chat", call: "render", chrome: "shell" },
    { match: /^\/chats(?:\?|$)/, prefix: "/chats", chunk: "chat", page: "Chats", call: "render", chrome: "shell" },
    {
      match: /^\/onboarding$/,
      prefix: "/onboarding",
      chunk: "onboarding",
      page: "Onboarding",
      call: "render",
      chrome: "full",
    },
    // Guarded like every route above it, and deliberately not a dead end: a
    // reload re-renders it from the URL, and both of its links go somewhere real.
    {
      match: /^\/connected(?:\?|$)/,
      prefix: "/connected",
      chunk: "connected",
      page: "McpConnected",
      call: "render",
      chrome: "document",
    },
    // The legacy alias, from before the split into /settings. No prefix: it is a
    // route, and must never be read as the base the shell is written for.
    {
      match: /^\/dashboard(?:\?|$)/,
      chrome: "document",
      redirect: function () {
        return "/settings";
      },
    },
  ];

  // Every page module the table names, once each. App.route tears all of them
  // down on every dispatch — most pages live in a chunk this visit may never
  // have loaded, so "the previous page" is not a question worth asking.
  var PAGES = ROUTES.map(function (row) {
    return row.page;
  }).filter(function (name, i, all) {
    return name && all.indexOf(name) === i;
  });

  var PREFIXES = ROUTES.map(function (row) {
    return row.prefix;
  }).filter(Boolean);

  var handler = null;

  var router = {
    ROUTES: ROUTES,
    PAGES: PAGES,

    /**
     * The row that answers this path, and the arguments its page is called
     * with, or null for a path the app does not route.
     */
    match: function (path) {
      var p = String(path || "/");
      for (var i = 0; i < ROUTES.length; i++) {
        var m = ROUTES[i].match.exec(p);
        if (m) return { route: ROUTES[i], params: m.slice(1) };
      }
      return null;
    },

    /** The base path this document is served under. Always "" — see above. */
    base: function () {
      return "";
    },

    /* href for an in-app route: href("/people") -> "/people". A pass-through,
       kept as the one place that guarantees an app-built link is a route this
       router matches. */
    href: function (route) {
      var r = String(route == null ? "/" : route);
      return r.charAt(0) === "/" ? r : "/" + r;
    },

    /** The current route, query included: "/people/123?tab=x". */
    current: function () {
      return (String(loc().pathname || "/") || "/") + (loc().search || "");
    },

    /* The current route's query params. */
    query: function () {
      return new URLSearchParams(loc().search || "");
    },

    /* The fragment when it names a place on the page ("#email"), else "". The
       fragment also carries #access_token=, #ghd_handoff= and legacy "#/route"
       links, which are never a place and must never be carried anywhere. */
    fragment: function () {
      var hash = String(loc().hash || "");
      return /^#[A-Za-z][\w-]*$/.test(hash) ? hash : "";
    },

    /** Is this path one the app routes (vs. a real document)? */
    isRoute: function (path) {
      var p = String(path || "/").split("?")[0];
      if (p === "/" || p === "") return true;
      for (var i = 0; i < PREFIXES.length; i++) {
        if (p === PREFIXES[i] || p.indexOf(PREFIXES[i] + "/") === 0) return true;
      }
      return false;
    },

    /** Navigate: push a history entry and re-render. */
    go: function (route) {
      history.pushState(null, "", this.href(route));
      this._notify();
    },

    /* Rewrite the current URL without re-rendering, for when the page already
       made the change itself; re-routing would rebuild it. */
    replace: function (route) {
      history.replaceState(null, "", this.href(route));
    },

    /** Register the render callback (App.route). Only one; last wins. */
    subscribe: function (fn) {
      handler = fn;
    },

    _notify: function () {
      if (handler) handler();
      // For listeners that must not depend on the app bundle: theme.js is shared
      // with the marketing site and closes the mobile nav on navigation, which it
      // used to do by listening for hashchange — an event a path router never fires.
      if (typeof root.dispatchEvent === "function") root.dispatchEvent(new Event("ghd:navigate"));
    },

    /* Rewrite a legacy "#/route" URL to a path, in place. Permanent: old links
       live on in emails, Stripe return URLs and bookmarks. Runs before the
       router reads the URL, via replaceState. Only "#/..." is touched;
       "#access_token=" and "#ghd_handoff=" belong to others. */
    adoptLegacyHash: function () {
      var hash = loc().hash || "";
      if (hash.indexOf("#/") !== 0) return;
      var legacy = hash.slice(1);
      // The route's own query merges with any already on the URL: a Stripe return
      // lands on "/dashboard/?checkout=success#/settings" and both halves matter.
      var parts = legacy.split("?");
      var merged = new URLSearchParams(loc().search || "");
      if (parts[1]) {
        new URLSearchParams(parts[1]).forEach(function (value, key) {
          merged.set(key, value);
        });
      }
      var qs = merged.toString();
      history.replaceState(null, "", this.href(parts[0]) + (qs ? "?" + qs : ""));
    },
  };

  /* Give every `<a data-route="/chat">` its base-correct href. */
  router.applyRouteLinks = function (scope) {
    (scope || doc).querySelectorAll("a[data-route]").forEach(function (a) {
      a.setAttribute("href", router.href(a.getAttribute("data-route")));
    });
  };

  root.GHD.router = router;

  // Everything below drives a live page, so it runs only when the whole browser
  // surface it needs is actually there. A vm context evaluating this module for
  // its pure helpers has at most a partial DOM, and a half-wired router — links
  // intercepted but never re-rendered — would be worse than none.
  var live =
    doc &&
    typeof doc.addEventListener === "function" &&
    typeof doc.querySelectorAll === "function" &&
    typeof root.addEventListener === "function" &&
    typeof history !== "undefined" &&
    typeof history.pushState === "function";
  if (!live) return;

  // Immediately, not from App.init(): init() runs at DOMContentLoaded, by which
  // time the other deferred scripts have already read the URL. sw-register.js
  // reads ?q= to stash a deep-linked question, and would still have seen the
  // legacy fragment.
  router.adoptLegacyHash();

  // Back/forward. A route that has not actually changed is not re-rendered:
  // kb-panel.js pushes a same-URL history entry so the back button closes the
  // panel instead of leaving the page, and re-rendering the chat underneath it
  // would throw away the transcript the user was reading.
  var lastRoute = router.current();
  // The URL the reader left by the last navigation, as it stood when they left
  // it: a page that rewrites its own query in place (the chat's ?conv=) is
  // returned to as it last read.
  var previousRoute = null;
  // How the route change being rendered now came about ("traverse" for
  // Back/Forward, "push" for go()), for a guard that has to undo it.
  var changing = null;
  root.addEventListener("popstate", function () {
    var next = router.current();
    if (next === lastRoute) return;
    previousRoute = lastRoute;
    lastRoute = next;
    changing = "traverse";
    try {
      router._notify();
    } finally {
      changing = null;
    }
  });
  // go()/replace() move the URL without a popstate, so keep the guard in step.
  ["go", "replace"].forEach(function (name) {
    var original = router[name];
    router[name] = function (route) {
      // Set before the call: go() renders the next page synchronously when its
      // chunk is already loaded, and that page may read previous() at once.
      var before = router.current();
      var prior = previousRoute;
      if (name === "go") previousRoute = before;
      var outer = changing;
      if (name === "go") changing = "push";
      var result;
      try {
        result = original.call(this, route);
      } finally {
        changing = outer;
      }
      lastRoute = router.current();
      if (lastRoute === before) previousRoute = prior;
      return result;
    };
  });
  /* The route the last navigation left, or null on the first page of a visit. */
  router.previous = function () {
    return previousRoute;
  };
  /* "traverse" or "push" while that route change is being rendered, else null
     (a page that replaced the URL and routed itself). */
  router.changing = function () {
    return changing;
  };

  /* Client-side navigation for in-app links, delegated so later-rendered markup
     is covered; without it every path link reloads the SPA. Modified clicks,
     other targets, downloads and cross-origin links go to the browser. */
  if (doc.readyState === "loading") {
    doc.addEventListener("DOMContentLoaded", function () {
      router.applyRouteLinks();
    });
  } else {
    router.applyRouteLinks();
  }

  doc.addEventListener("click", function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest("a");
    if (!link || !link.href) return;
    if (link.hasAttribute("download") || link.hasAttribute("data-native-link")) return;
    if (link.target && link.target !== "_self") return;
    var url;
    try {
      url = new URL(link.href, loc().href);
    } catch (e) {
      return;
    }
    if (url.origin !== loc().origin) return;
    var route = url.pathname || "/";
    if (!router.isRoute(route)) return;
    event.preventDefault();
    router.go(route + url.search + url.hash);
  });
})();

;
/* dashboard/js/storage-keys.js */
/* GHD.KEYS — the registry of every localStorage / sessionStorage key the app uses.
 *
 * The strings are live user data: renaming one orphans what it holds on every
 * device, so the mixed naming conventions stay as stored. New keys use
 * `ghd_snake`. Loaded first (ahead of i18n.js) with no dependencies. Scripts that
 * run before it, and pages with no app script, keep their own literals. */
(function () {
  window.GHD = window.GHD || {};

  GHD.KEYS = Object.freeze({
    // ── localStorage ──────────────────────────────────────────────────────
    // Signup handoff: the homepage / signup form stashes birth details (and the
    // typed email, to prefill a resumed signup) for the post-auth handler in
    // app.js to finish onboarding with. Written by site/js/landing.js and
    // auth.js, read + cleared by app.js and onboarding.js.
    signupBirthData: "ghd_signup_birth_data",
    signupEmail: "ghd_signup_email",
    // The other signup handoff: this one says the signup began at the MCP OAuth
    // consent screen (`/signup?from=mcp`), so it can end on the "you're all set"
    // screen instead of dropping into the chat. Written and spent by
    // js/mcp-signup.js, which is also where the 24-hour TTL and the rules about
    // the untrusted client name live.
    mcpSignup: "ghd_mcp_signup",
    // The third: a "Get Pro" click on the pricing page (`/signup?billing=…`),
    // so the finished signup goes on to Checkout for that period. {billing,
    // savedAt} JSON with a 24-hour TTL, written and spent by app.js.
    proIntent: "ghd_pro_intent",
    // Anonymous per-device id for the logged-out place-autocomplete endpoint's
    // rate limit (auth.js, site/js/landing.js).
    deviceId: "ghd_device_id",
    // The address a settings-page email change is waiting on. Written when the
    // confirmation link is sent (settings.js), spent when a session turns up
    // carrying that address (app.js, _settleEmailChange) — which is how the app
    // recognises the change on the way back in: the confirmation link lands as
    // an ordinary sign-in, with no event of its own to listen for. localStorage
    // rather than session, because confirming means leaving for a mail client
    // and coming back, often in a new tab. Account-owned, so app.js drops it on
    // sign-out.
    pendingEmailChange: "ghd_pending_email_change",
    // Attribution, both {v, t} JSON with a 90-day window, both consumed once at
    // signup by api.js: the Google Ads click id (written by head-init.js) and
    // the share token a visitor arrived through — a shared chart or a shared
    // conversation, written by shared-person/shared-person.js and shared/shared.js.
    // Both are written on the *marketing* origin and read on this one, so they
    // only ever get here through site/go/, which is why both share pages send
    // their signed-out call to action through it (site/js/app-handoff.js).
    gclid: "ghd_gclid",
    shareToken: "ghd_share",
    // Where a signup came from, all {v, t} JSON, all consumed once by api.js:
    // the first page opened and the latest arrival from another site, each with
    // its referring host in `r`, utm_source in `u` and origin in `o`
    // (js/arrival-touch.js, written on www and on this origin), and the page
    // whose signup form was submitted (landing.js). www's copies cross through
    // site/go/ like the two above.
    entryPage: "ghd_entry",
    lastTouch: "ghd_last_touch",
    signupPage: "ghd_signup_page",
    // UI language + who last wrote it ("app" = a deliberate in-app choice,
    // otherwise the locale a landing page seeded). i18n.js, head-init.js,
    // i18n/arrival-locale.js, i18n/bundles-loader.js, i18n/manifest-locale.js.
    // head-init.js seeds these on the marketing origin and arrival-locale.js on
    // this one, from the ?lang= a localized page puts on its links over here —
    // localStorage does not cross an origin, so both are needed to cover one
    // journey. Both keys are per device but chosen per account, so app.js drops
    // them on sign-out.
    uiLang: "ghd_ui_lang",
    uiLangSeed: "ghd_ui_lang_seed",
    // Chat: last opened conversation (chat.js, chat-conversation-list.js), the
    // "is this really your name?" nudge being answered (chat.js, cleared on
    // sign-out by app.js), and the desktop sidebar's open/closed state
    // (app-shell.js).
    chatLastConv: "chat-last-conv",
    nameConfirmed: "ghd_name_confirmed",
    // First-journey card (chat-first-journey.js) already shown on this device.
    // Per account like nameConfirmed, so app.js drops it on sign-out.
    firstJourney: "ghd_first_journey",
    chatSidebar: "chat-sidebar",
    // The Pairs page's saved pairs (compare.js): every connection opened, kept
    // until removed. The name is from its days as a recents strip; the entries
    // never changed shape, so the key stayed.
    recentPairs: "ghd_recent_pairs",
    // The Groups roster's mini Penta glyphs: group id → the defined channel ids
    // plus a fingerprint of the members' birth data, so the entry invalidates
    // itself when the group changes (groups.js).
    pentaGlyphs: "ghd_penta_glyphs",
    // PWA install promo: dismissed flag + the chat-message counter that decides
    // when to show it (pwa.js).
    pwaInstallDismissed: "pwa-install-dismissed",
    pwaChatMsgCount: "pwa-chat-msg-count",
    // Chart view preferences (chart.js): the Channels|Gates sub-tab on the
    // person page, the fullscreen stage's "Show mandala" toggle, and whether
    // the Planets table spells activations out to Color · Tone · Base
    // (`36.6.2.4.1`) rather than gate.line.
    chartInfoTab: "hd-chart-info-tab",
    stageMandala: "ghd_stage_mandala",
    // The transits stage's Sky | Detailed control (chart-stage.js): "true" is
    // the detailed drawing, unset the two-ink default. Remembered where the
    // stage's other view control, Side | Circuit, deliberately is not — which
    // drawing of a transit you read is a habit, like the ring above, while the
    // circuits are a look chosen per visit (decisions.md, "two inks").
    stageSkyDetail: "ghd_stage_sky_detail",
    chartSubstructure: "ghd_chart_substructure",
    // Colour theme (site/theme.js — loaded by every page, dashboard included).
    theme: "hd-theme",
    // Pricing (site/pricing.js): the visitor's explicit currency choice, the
    // currency cached from Cloudflare's geo-IP, and the per-day exchange-rate
    // cache — one `fx2_EUR_<YYYY-MM-DD>` entry, older ones pruned on write,
    // along with any left under the retired `fx_EUR_` prefix (which held a
    // ten-currency table the picker has long outgrown).
    currency: "fx_selected_currency",
    geoCurrency: "fx_geo_currency",
    fxRatesPrefix: "fx2_EUR_",
    fxRatesPrefixRetired: "fx_EUR_",
    // Local-dev auto-login opt-out (dev-autologin.js; never ships to prod).
    devAutoLoginOff: "ghd_dev_autologin_off",
    // The local-dev state switcher (dev-bar.js; never ships to prod): hidden
    // for good by ?dev_bar=off, and the last preset it applied, which it marks
    // as active while the account still looks like it.
    devBarOff: "ghd_dev_bar_off",
    devPreset: "ghd_dev_preset",
    // Retired 2026-08-28. Held a device's opt-in to the person page's Advanced
    // tab while that was hidden in production (`?advanced=on`); the tab is on
    // for everyone now and nothing reads it. Kept so app.js can sweep it out
    // at boot (App._boot), the way pricing.js collects the retired fx prefix.
    advancedTabPreviewRetired: "ghd_advanced_tab",
    // Which Android build this device runs, and the last report we got through
    // to the backend ("<origin>|<version>|<user>|<day>"), so a launch that
    // changes nothing costs no request (android-build.js).
    //
    // localStorage, unlike the `twa` flag below, on purpose: the version only
    // rides the *cold-launch* start URL, so a deep link into the app has to
    // read it from a previous launch. Sharing this origin's localStorage with
    // Chrome is harmless here — both the write and the report are gated on
    // GHD.platform.isTWA, so a browser tab neither stores nor reports one.
    androidAppVersion: "ghd_android_app_version",
    androidBuildReported: "ghd_android_build_reported",
    // Play purchase tokens the backend refused as invalid (400): never posted
    // again from this install (play-billing.js).
    playRefusedTokens: "ghd_play_refused_tokens",
    // Route chunks that once arrived incomplete, each with the
    // `refetch=` token it is asked for under from then on (lazy-libs.js).
    // localStorage: the bad copy may sit in the browser's HTTP cache, which
    // outlives the tab. {url: token} JSON.
    routeRefetch: "ghd_route_refetch",

    // ── sessionStorage ────────────────────────────────────────────────────
    // Where to go after signing in, and a share token to redeem on the way
    // (auth.js sets them, app.js consumes them).
    returnTo: "returnTo",
    pendingShareToken: "pendingShareToken",
    // Language of the signed-out auth flow. app.js captures it before removing
    // the account-owned localStorage language; i18n.js consumes it once the next
    // account's profile is known. Session scope keeps login -> signup localized
    // without making the previous account's choice a device preference.
    signedOutAuthLocale: "ghd_signed_out_auth_locale",
    // A ?q= chat prompt, parked by sw-register.js so it survives the
    // service-worker update reload, consumed by chat.js.
    chatSeedQuery: "chat_q",
    // The ?starter= attribution key riding along with ?q= (same lifecycle).
    chatSeedStarter: "chat_starter",
    // An unsaved chart card being opened full-screen (chat-cards.js, people.js,
    // conversations.js).
    tempChart: "tempChartPending",
    // The Play card states this tab has already counted, as "<user>:<state>"
    // (play-billing.js reportState).
    playStatesReported: "ghd_play_states_reported",
    // Running inside the Play Store TWA (platform.js). sessionStorage: the
    // TWA and Chrome share this origin's localStorage, so on its own a
    // persistent flag would mislabel real browser tabs.
    twa: "ghd_twa",
    // The Play Store app has launched on this device before (platform.js).
    // localStorage, because Android resumes a killed app on its last URL —
    // no launch signal, empty sessionStorage. Only ever written on Android,
    // and only believed alongside an app-like display mode, which is what
    // keeps it off ordinary Chrome tabs.
    twaInstalled: "ghd_twa_installed",
    // Legacy-PWA → Play Store migration nudge, re-offered each launch (pwa.js).
    twaMigrateDismissed: "twa-migrate-dismissed",
    // Home-screen web app on iPhone/iPad → App Store note, once per device:
    // set by its × or its badge, and never shown again here (pwa.js).
    iosAppNoteDismissed: "ios-app-note-dismissed",
    // Service-worker update handling, all keyed to the app version so a stale
    // entry from a previous release is ignored (sw-register.js).
    swRefreshPending: "ghd-sw-refresh-pending",
    swReloadAttempted: "ghd-sw-reload-attempted",
    swPurged: "ghd-sw-purged",
    // OAuth consent screen hand-off (oauth/consent/consent.js — its own page):
    // the request being approved, and the redirect a setup screen must resume
    // to after a reload.
    oauthConsentContext: "oauth_authorization_context",
    oauthConsentSetup: "oauth_setup_context",
    // How far ahead the transits forecast reaches, in days (transits.js). A
    // preference and not a cache: a reader who wants three weeks wants them
    // every visit. `?days=` on the URL still wins, so a shared or pinned link
    // shows the window it names.
    transitDays: "ghd_transit_days",
    // The local-dev state switcher rolled up to a dot (dev-bar.js; never ships
    // to prod). Session-scoped: "get out of my way for a minute", not a
    // preference.
    devBarCollapsed: "ghd_dev_bar_collapsed",

    // ── Parameterized localStorage keys ──────────────────────────────────
    /** Unsent composer text for a conversation ("new" before it has an id). */
    draft(conversationId) {
      return "ghd_draft:" + conversationId;
    },

    /** Remembered reading position within a conversation's transcript. */
    scrollPos(conversationId) {
      return "ghd_scrollpos:" + conversationId;
    },

    /* An unfinished rewrite of a conversation's last user message. */
    editDraft(conversationId) {
      return "ghd_edit_draft:" + conversationId;
    },

    /** Unsent product feedback, isolated per signed-in account. */
    feedbackDraft(userId) {
      return "ghd_feedback_draft:" + userId;
    },

    /* The person page's "we checked the whole day" band, closed for this chart
     * (chart.js `_renderTimeContext`). The value is the window it was closed for,
     * so a corrected birth time brings the note back. */
    chartTimeNote(personRef) {
      return "ghd_chart_time_note:" + personRef;
    },

    /* Drop everything stored per-conversation. The draft goes through
     * GHD.drafts, which may hold an in-page copy or a pending write. */
    pruneConversation(conversationId) {
      if (!conversationId) return;
      GHD.drafts?.clear(GHD.KEYS.draft(conversationId));
      GHD.drafts?.clear(GHD.KEYS.editDraft(conversationId));
      GHD.storage.remove(GHD.KEYS.draft(conversationId));
      GHD.storage.remove(GHD.KEYS.editDraft(conversationId));
      GHD.storage.remove(GHD.KEYS.scrollPos(conversationId));
    },

    // The Supabase session key is deliberately not here: it belongs to
    // GHD_APP.sessionKey() in /app-config.js, which the marketing origin and the
    // /go/ handoff load too — and this file is on neither of them.
  });

  /* GHD.storage — localStorage and sessionStorage that cannot throw.
   * Blocked site data and a full quota make the raw APIs throw. Reads answer
   * null, writes and removals do nothing. Not a cache: a failed write is not
   * kept in memory. */
  function safeStorage(pick) {
    return {
      /** The stored string, or null — absent, unreadable, it reads the same. */
      get(key) {
        try {
          return pick().getItem(key);
        } catch (e) {
          return null;
        }
      },
      /** Best-effort write. Returns whether it actually landed. */
      set(key, value) {
        try {
          pick().setItem(key, String(value));
          return true;
        } catch (e) {
          return false;
        }
      },
      remove(key) {
        try {
          pick().removeItem(key);
        } catch (e) {
          /* nothing stored is nothing to remove */
        }
      },
    };
  }

  // Resolved per call, not captured: in a blocked context touching the global
  // can itself throw, and that must happen inside the try above.
  GHD.storage = safeStorage(() => localStorage);
  GHD.storage.session = safeStorage(() => sessionStorage);
  Object.freeze(GHD.storage);
})();

;
/* dashboard/js/mcp-signup.js */
// The `?from=mcp` signup, carried from the consent screen to the end of signup.
// No served page emits that link today; the module stays armed in case the exit
// returns (mcp-signup-handoff.test.js fails the day one does). The flag lives in
// localStorage to survive the OAuth provider round trip. The client name is
// untrusted and usually absent, so it is sanitised, capped and escaped; the flag
// expires so an unrelated later signup never ends on the connect screen.
(function () {
  window.GHD = window.GHD || {};

  // How long a captured `from=mcp` may still end a signup: the backend's same
  // 24h first-seen window, covering the provider round trip and a same-day email.
  var TTL_MS = 24 * 60 * 60 * 1000;

  /* Longest client name we will render. Escaping is the security boundary; the
     cap only stops a huge "name" taking over a heading. */
  var MAX_CLIENT_CHARS = 40;

  // Characters that are invisible, reorder what follows them, or break a line
  // where the layout expects none: C0/C1 controls, the zero-width family, the
  // bidi marks, overrides and isolates, the Unicode line/paragraph separators,
  // the blank fillers, variation selectors and the tag block (as surrogates,
  // since the class has no `u` flag).
  // Replaced with a space rather than dropped, so two words separated by one
  // cannot silently become one word.
  //
  // The control and combining characters are the point of the class, so the
  // rules that warn about them have nothing to tell us here.
  var UNSAFE_CHARS =
    // eslint-disable-next-line no-control-regex, no-misleading-character-class
    /[\u0000-\u001f\u007f-\u009f\u00ad\u034f\u061c\u115f\u1160\u180e\u200b-\u200f\u2028\u2029\u202a-\u202e\u2060-\u2064\u2066-\u2069\u3164\ufe00-\ufe0f\ufeff\uffa0]|\udb40[\udc00-\udc7f]/g;

  /* A client display name we are willing to show, or "" for "no name".
     Never throws; anything that sanitises to nothing counts as no name. */
  function clientName(raw) {
    return String(raw == null ? "" : raw)
      .replace(UNSAFE_CHARS, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, MAX_CLIENT_CHARS)
      .trim();
  }

  function read() {
    var stored;
    try {
      stored = JSON.parse(GHD.storage.get(GHD.KEYS.mcpSignup) || "null");
    } catch (e) {
      return null;
    }
    if (!stored || typeof stored !== "object") return null;
    // A non-numeric savedAt has to be rejected outright, not compared: every
    // comparison against NaN is false, so a record stamped "soon" would read as
    // permanently fresh — a flag with no TTL, which is the one thing it must not
    // be able to become.
    if (typeof stored.savedAt !== "number" || Date.now() - stored.savedAt > TTL_MS) return null;
    // Sanitised again on the way out, not only on the way in: what is in storage
    // is a string, and anything on this origin could have written it.
    return { client: clientName(stored.client) };
  }

  function clear() {
    GHD.storage.remove(GHD.KEYS.mcpSignup);
  }

  /* Whether the client that connected is ChatGPT — the only one we name a rule for
     (its connector must be named in the message). Matched on the registered name
     with non-alphanumerics stripped; shared by the consent hand-back and /connected. */
  function isChatGPT(client) {
    return String(client || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "")
      .includes("chatgpt");
  }

  // Arm the flag if this load is the exit from the consent screen. Only
  // `from=mcp` arms it; re-capturing on a reload deliberately restamps the TTL.
  function capture(params) {
    if (!params || params.get("from") !== "mcp") return false;
    var record = { client: clientName(params.get("client")), savedAt: Date.now() };
    // Blocked storage, or full. The signup itself is unaffected — it just ends
    // where every other signup ends.
    if (!GHD.storage.set(GHD.KEYS.mcpSignup, JSON.stringify(record))) return false;
    return true;
  }

  GHD.mcpSignup = {
    TTL_MS: TTL_MS,
    MAX_CLIENT_CHARS: MAX_CLIENT_CHARS,
    // How a ChatGPT user addresses the connector in a message. Not translatable
    // and not a URL — it is the connector's name, the same one /mcp-docs and the
    // welcome letter print.
    CHATGPT_MENTION: "@gethumandesign.com",
    clientName: clientName,
    capture: capture,
    read: read,
    clear: clear,
    isChatGPT: isChatGPT,
  };
})();

;
/* dashboard/js/drafts.js */
/**
 * GHD.drafts — text the user has typed but not yet sent.
 *
 * Three rules make a lost draft impossible:
 * 1. Every write is mirrored to memory first, synchronously, so in-page
 *    navigation is lossless even where storage is denied.
 * 2. Storage is always wrapped: `setItem` throws in a Safari private window and
 *    over quota, and an uncaught throw in a debounce timer stops all later saves.
 * 3. A queued write is flushed before the document can go away (`init()`).
 *
 * The disk write is debounced because `localStorage.setItem` is synchronous and
 * composers call this on every keystroke. Keys come from GHD.KEYS; this module
 * knows nothing about what a draft is for. Load after storage-keys.js.
 */
(function () {
  window.GHD = window.GHD || {};

  // Long enough that a fast typist writes one entry per pause rather than one
  // per keystroke, short enough that an unflushed window is never a real amount
  // of writing. Nothing depends on the exact value — flush() is what makes the
  // draft safe, this only decides how often we write when nothing is wrong.
  const SAVE_DEBOUNCE_MS = 300;

  /** key → the newest text this page has seen, whether or not storage took it. */
  const memory = new Map();
  /** key → text still owed to localStorage. */
  const pending = new Map();
  /* Keys this page has genuinely handled — read, or written with real text. */
  const claimed = new Set();
  let timer = null;
  // init() is idempotent: a second boot must not double the flush listeners.
  let wired = false;

  function persist(key, text) {
    // Storage unavailable or full: the memory mirror is all we get, which is
    // why GHD.storage never throwing is the right shape here.
    if (text) GHD.storage.set(key, text);
    else GHD.storage.remove(key);
  }

  function flush() {
    clearTimeout(timer);
    timer = null;
    if (!pending.size) return;
    pending.forEach((text, key) => persist(key, text));
    pending.clear();
  }

  GHD.drafts = {
    /* The draft held for `key`, or "". */
    read(key) {
      if (memory.has(key)) {
        claimed.add(key);
        return memory.get(key);
      }
      // Storage unavailable: an unhandled key is simply empty.
      const stored = GHD.storage.get(key) || "";
      memory.set(key, stored);
      claimed.add(key);
      return stored;
    },

    /* Whether this page has already read `key`, or written real text to it. */
    seen(key) {
      return claimed.has(key);
    },

    /** Remember `text` now, write it out at the next pause. For `input` handlers. */
    queue(key, text) {
      memory.set(key, text);
      if (text) claimed.add(key);
      pending.set(key, text);
      clearTimeout(timer);
      timer = setTimeout(flush, SAVE_DEBOUNCE_MS);
    },

    /** Remember `text` and write it out immediately. For deliberate boundaries. */
    save(key, text) {
      memory.set(key, text);
      if (text) claimed.add(key);
      pending.delete(key);
      persist(key, text);
    },

    /** Forget the draft — it was sent, or whatever held it no longer exists. */
    clear(key) {
      // Recorded as empty rather than dropped: this page has decided the key
      // holds nothing, and re-reading storage for it would only risk resurrecting
      // a write we could not complete.
      memory.set(key, "");
      pending.delete(key);
      persist(key, "");
    },

    /** Whether `key` holds unsent text. A pure question — it does not mark the key seen. */
    has(key) {
      if (memory.has(key)) return Boolean(memory.get(key));
      return Boolean(GHD.storage.get(key));
    },

    flush,

    /* Listen for every way the document can go away without our teardown
     * running: tab discard, app switch, bfcache, and our own SW update reload
     * (sw-register.js). Idempotent, and guarded for test contexts with no DOM. */
    init() {
      if (wired) return;
      wired = true;
      if (typeof window !== "undefined" && window.addEventListener) {
        window.addEventListener("pagehide", flush);
      }
      if (typeof document !== "undefined" && document.addEventListener) {
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "hidden") flush();
        });
      }
    },
  };
})();

;
/* js/i18n-core.js */
/**
 * The parts of runtime i18n that are the same everywhere.
 *
 * Two runtimes sit on top of this — dashboard/js/i18n.js for the signed-in app
 * and site/js/public-i18n.js for the share pages and the OAuth consent screen —
 * and they differ in exactly one thing: how the locale is chosen. The app also
 * weighs the arrival language and the signed-out auth locale, and reconciles
 * against the account's `profiles.ui_language`; the public pages ask the browser
 * and offer a picker. Everything under that decision — which locales exist, how
 * a code is clamped to one, where a bundle lives, what t() does with `{vars}`,
 * how `data-i18n` markup is filled in — was written twice and drifted.
 *
 * So it is written once here, and each runtime keeps only its own chain.
 *
 * Also `GHD.trOr(key, fallback, vars)`: t() with an English literal for when
 * there is no translation. Four files had a copy of it and one had drifted into
 * printing the raw key.
 *
 * Extends the `window.GHD` namespace. Load after the generated bundle loader
 * (which defines `__GHD_LOCALES__` and the message globals) and before the
 * runtime that uses it.
 */
(function () {
  window.GHD = window.GHD || {};

  var DEFAULT = "en";

  /**
   * The shipped UI locales, from the generated bundle (i18n/locales.json).
   *
   * Read on every call rather than captured at load: this file has no way to
   * insist it evaluates after the bundle loader on every page, and a captured
   * `["en"]` would silently clamp every other language away.
   */
  function locales() {
    return window.__GHD_LOCALES__ || [{ code: DEFAULT, native: "English", english: "English" }];
  }

  /** The message globals the per-locale bundle defines, or null. */
  function bundle(loc) {
    return window["__GHD_MSG_" + String(loc).toUpperCase() + "__"] || null;
  }

  /** Fill `{name}` placeholders from `vars`; an unknown one is left as written. */
  function interpolate(text, vars) {
    if (!vars) return text;
    return String(text).replace(/\{(\w+)\}/g, function (whole, name) {
      return Object.prototype.hasOwnProperty.call(vars, name) ? vars[name] : whole;
    });
  }

  /**
   * Map any language code — including the ~50 a chat reply can be written in —
   * to a shipped UI locale, or null.
   */
  function toSupported(code) {
    if (!code) return null;
    var primary = String(code).replace("_", "-").split("-")[0].toLowerCase();
    var supported = locales().map(function (entry) {
      return entry.code;
    });
    return supported.indexOf(primary) !== -1 ? primary : null;
  }

  /**
   * The public tag a locale is written under — `<html lang>` and every Intl
   * call. The code itself unless the registry names one (`zh` → `zh-Hant`: a
   * bare "zh" lets the browser and Intl fall back to Simplified).
   */
  function bcp47(code) {
    var list = locales();
    for (var i = 0; i < list.length; i++) {
      if (list[i].code === code) return list[i].bcp47 || code;
    }
    return code;
  }

  /**
   * The tag an Intl date formatter is handed: a public tag, on the Gregorian
   * calendar. Thai's default is the Buddhist one, which prints 1990 as 2533, and
   * a birth year has to read as the year the reader typed. A tag already on the
   * Gregorian calendar comes back as it was.
   */
  function intlTag(tag) {
    try {
      if (tag && new Intl.DateTimeFormat(tag).resolvedOptions().calendar !== "gregory") return tag + "-u-ca-gregory";
    } catch (e) {
      /* a tag Intl refuses is the caller's to handle, unchanged */
    }
    return tag;
  }

  /**
   * The active message table for a locale.
   *
   * Each bundle is already merged over the English base at build time; the
   * English one is laid down first anyway, to cover a bundle that failed to
   * load or a loader that disagrees with the runtime about the locale.
   */
  function messagesFor(loc) {
    return Object.assign({}, bundle(DEFAULT) || {}, bundle(loc) || {});
  }

  /**
   * A `t(key, vars)` over a table the caller can swap under it.
   *
   * A missing key answers with the key itself: a visible signal, and what lets
   * GHD.trOr tell a miss from a translation. `t.setMessages(next)` replaces the
   * table in place, so the language switch the dashboard does without reloading
   * reaches every reference already handed out — `window.t` included.
   */
  function makeT(messages) {
    var table = messages || {};
    function t(key, vars) {
      var text = Object.prototype.hasOwnProperty.call(table, key) ? table[key] : key;
      return interpolate(text, vars);
    }
    t.setMessages = function (next) {
      table = next || {};
    };
    return t;
  }

  /**
   * Translate static markup: `data-i18n` (innerHTML) and
   * `data-i18n-attr="attr:key;attr2:key2"` (attribute values). Call after
   * rendering, with the runtime's own `t`.
   */
  function applyTranslations(root, t) {
    var scope = root || document;
    scope.querySelectorAll("[data-i18n]").forEach(function (el) {
      el.innerHTML = t(el.getAttribute("data-i18n"));
    });
    scope.querySelectorAll("[data-i18n-attr]").forEach(function (el) {
      el.getAttribute("data-i18n-attr")
        .split(";")
        .forEach(function (pair) {
          var at = pair.indexOf(":");
          if (at === -1) return;
          el.setAttribute(pair.slice(0, at).trim(), t(pair.slice(at + 1).trim()));
        });
    });
  }

  GHD.i18n = {
    DEFAULT: DEFAULT,
    // Marks `ghd_ui_lang` as a deliberate choice rather than a value a localized
    // landing page seeded in passing (site/js/head-init.js leaves ours alone).
    // Both pickers write it, and they mean the same thing by it.
    SEED_APP: "app",
    locales: locales,
    bundle: bundle,
    toSupported: toSupported,
    bcp47: bcp47,
    intlTag: intlTag,
    messagesFor: messagesFor,
    makeT: makeT,
    applyTranslations: applyTranslations,
    interpolate: interpolate,
  };

  /**
   * t(), with the English words to print when there is no translation.
   *
   * Two cases produce the same answer here: a page that carries no i18n runtime
   * at all (the shared conversation view loads cards.js without one), and a key
   * the catalog has not got. t() answers a miss with the key, so that is what
   * this watches for — and the fallback gets the same `{var}` interpolation the
   * translation would have had.
   *
   * A fallback is a safety net, never the copy: the catalog wins wherever it has
   * an entry, so an edit to the English wording belongs in i18n/en/*.json.
   */
  GHD.trOr = function (key, fallback, vars) {
    if (typeof window.t === "function") {
      var translated = window.t(key, vars);
      if (translated !== key) return translated;
    }
    return interpolate(fallback == null ? key : fallback, vars);
  };
})();

;
/* dashboard/js/i18n.js */
// Runtime i18n for the dashboard SPA.
//
// UI strings are globals (window.__GHD_MSG_<LOC>__) defined by the generated
// per-locale bundle (dashboard/i18n/bundles.<code>.js). The generated
// bundles-loader.js — a deferred script ahead of this one — appends that bundle
// as a <script> and publishes window.__GHD_BUNDLE_READY__ for it. Usually the
// bundle is here by the time this file runs (the shell preloads the English one,
// the service worker holds them all); when it is still in flight, t() answers
// keys until it lands, the table is swapped in the moment it does, and the two
// readers that must not paint keys — the static markup below and App.init —
// wait on `GHD_I18N.ready`. No app script calls t() as it evaluates. Each bundle
// ships only its own locale, pre-merged over the English base.
//
// Language resolution (synchronous, on load — so storage-keys.js loads first):
//   localStorage GHD.KEYS.uiLang  ->  sessionStorage GHD.KEYS.signedOutAuthLocale
//   -> navigator.language -> 'en'
// clamped to SUPPORTED. The server-side setting (profiles.ui_language — THE language,
// driving UI, chat replies and emails alike) is reconciled after the profile loads via
// GHD_I18N.reconcile(code), which swaps the active bundle in place if it differs —
// without booting the whole app twice.
(function () {
  "use strict";

  // Which locales exist, how a code is clamped to one, what t() does with
  // `{vars}` and how `data-i18n` markup is filled in are all /js/i18n-core.js's
  // (GHD.i18n) — the same code the public runtime sits on. What is left here is
  // this side's own resolution chain: the arrival language, the signed-out auth
  // locale, and reconciling against the account.
  const core = GHD.i18n;
  const LOCALES = core.locales();
  const SUPPORTED = LOCALES.map(function (l) {
    return l.code;
  });
  const DEFAULT = core.DEFAULT;
  // GHD.KEYS.uiLangSeed marks GHD.KEYS.uiLang as a deliberate choice rather than a
  // value a localized landing page seeded in passing — see site/js/head-init.js,
  // which leaves our writes alone. The share pages' header picker (site/js/
  // public-i18n.js) writes the same sentinel, for the same reason.
  const SEED_APP = core.SEED_APP;
  const bundle = core.bundle;
  // Maps any language code (incl. the ~50 chat-reply codes) to a shipped UI
  // locale, or null.
  const toSupported = core.toSupported;

  // The previous account's language is allowed to color only the signed-out auth
  // journey. Keeping it in sessionStorage preserves login -> signup and OAuth
  // round-trips, while reconcile() removes it as soon as the next profile answers.
  function getSignedOutAuthLocale() {
    return toSupported(GHD.storage.session.get(GHD.KEYS.signedOutAuthLocale));
  }

  function clearSignedOutAuthLocale() {
    GHD.storage.session.remove(GHD.KEYS.signedOutAuthLocale);
  }

  function resolveLocale() {
    const stored = GHD.storage.get(GHD.KEYS.uiLang);
    return (
      // The language a localized marketing page named in the ?lang= of the link it
      // sent this visitor over by, adopted by i18n/arrival-locale.js before the
      // page's first script ran. Normally the same value `stored` already holds —
      // it wrote that too — and ahead of it for the one case where it could not:
      // a device with no usable localStorage, where the URL is the only carrier.
      toSupported(window.__GHD_ARRIVAL_LANG__) ||
      toSupported(stored) ||
      getSignedOutAuthLocale() ||
      toSupported(typeof navigator !== "undefined" ? navigator.language : null) ||
      DEFAULT
    );
  }

  // Reassigned by the in-place switch in reconcile(); the message table behind
  // t() is swapped with it, so every reference already handed out — window.t
  // included — picks up the new language on its own.
  let locale = resolveLocale();
  // Keep the document's declared language in sync with the SPA locale
  // (screen readers, translation prompts, hyphenation all key off it).
  // The registry's public tag, not the code: `zh` is written `zh-Hant`.
  if (typeof document !== "undefined") document.documentElement.lang = core.bcp47(locale);
  const t = core.makeT(core.messagesFor(locale));

  function applyTranslations(root) {
    core.applyTranslations(root, t);
  }

  // Store the choice for the next boot, flagged as ours so a localized landing page
  // won't seed over it (site/js/head-init.js).
  function persist(code) {
    GHD.storage.set(GHD.KEYS.uiLang, code);
    GHD.storage.set(GHD.KEYS.uiLangSeed, SEED_APP);
  }

  // Preserve the language already on screen across the hard reload that follows
  // sign-out. app.js calls this before removing the account-owned localStorage key.
  function rememberSignedOutAuthLocale() {
    GHD.storage.session.set(GHD.KEYS.signedOutAuthLocale, locale);
  }

  // Whether a live language switch would cost the reader something.
  //
  // A reply being written counts — for this page or for one the reader has
  // left, which is why the turn module answers rather than the page: switchTo()
  // re-renders the route, and reconcile's no-router fallback is a
  // location.reload(), which is the one thing that still ends a turn early. So
  // does a private transcript, which lives only in memory. persist() still
  // runs either way, so the next boot is in the new language.
  //
  function isSending() {
    if (GHD.chatTurn && GHD.chatTurn.isSending()) return true;
    if (!window.Chat) return false;
    return Chat.hasUnsavedPrivateChat();
  }

  // Inject a locale's message bundle: same-origin <script src>, which is what the CSP
  // (script-src 'self') allows — an inline eval of the fetched text would be blocked.
  // Mirrors the parser-blocking injection in dashboard/i18n/bundles-loader.js, right
  // down to the /v/<release>/ path, so the service worker's precached copy is a hit.
  let bundleWarned = false;
  function loadBundle(loc, done) {
    if (bundle(loc)) return done(true);
    const el = document.createElement("script");
    el.src = "/v/__GHD_VERSION__/i18n/bundles." + loc + ".js";
    el.onload = function () {
      done(!!bundle(loc));
    };
    el.onerror = function () {
      done(false);
    };
    document.head.appendChild(el);
  }

  // Adopt an already-loaded bundle without reloading the page. Messages swap first, so
  // any t() call still to come — including one from a render that is mid-flight —
  // already speaks the new language; then the markup that is already on screen is
  // re-translated and the current route re-rendered for the strings JS built.
  function switchTo(next) {
    locale = next;
    t.setMessages(core.messagesFor(next));
    window.GHD_I18N.locale = next;
    document.documentElement.lang = core.bcp47(next);
    applyTranslations(document);
    App._updateNav(App._session);
    App.route();
  }

  // Switch UI language: persist + reload so every view re-renders in the new locale.
  // Used by the settings picker, where a deliberate choice makes a clean reload the
  // simplest correct answer — except while a reply is being written. A reload discards
  // the document, and that is the one thing that still ends a turn early, including one
  // running for a page the reader has already left (GHD.chatTurn). So swap in place
  // instead: the route re-render hands a live turn over rather than killing it. Only if
  // the bundle cannot be fetched does the reload stand — the user asked for this, and a
  // picker that visibly does nothing is worse than one resumable partial reply.
  // Defined below its three helpers, which it calls at once rather than on an event.
  function setLocale(code) {
    const next = toSupported(code);
    if (!next || next === locale) return;
    persist(next);
    if (!isSending()) return location.reload();
    loadBundle(next, function (ok) {
      if (ok) switchTo(next);
      else location.reload();
    });
  }

  // What "Auto" — no saved preference — resolves to. It cannot mean "keep whatever is
  // stored": GHD.KEYS.uiLang is per *device* while the choice is per *account*, so on a
  // shared device the stored locale may be the previous account's deliberate pick, and
  // an account that never opened the picker (ui_language null, the default) would
  // silently inherit it for good. Only a value the app itself wrote can be one of those.
  // A landing-seeded value is this visit's own context, still outranks the device
  // default, and is left alone — that is the /nl/ → dashboard bridge (site/js/head-init.js).
  function autoLocale() {
    // A signed-out auth locale belongs to the previous account, so it may render
    // login/signup but must never become the next account's "Auto" preference.
    if (getSignedOutAuthLocale()) {
      return toSupported(typeof navigator !== "undefined" ? navigator.language : null) || DEFAULT;
    }

    if (GHD.storage.get(GHD.KEYS.uiLangSeed) !== SEED_APP) return null;
    return toSupported(typeof navigator !== "undefined" ? navigator.language : null) || DEFAULT;
  }

  // Reconcile the synchronously-resolved UI locale with the server preference once the
  // profile is known. Only acts when it maps to a different supported locale. Called
  // only on a successful profile read (chat.js), so a failed request never moves the
  // language; a null preference is a real answer — "follow the device" — not a no-op.
  function reconcile(preferredCode) {
    const preferred = toSupported(preferredCode);
    const hadSignedOutAuthLocale = !!getSignedOutAuthLocale();
    const mapped = preferred || autoLocale();
    clearSignedOutAuthLocale();

    if (!mapped) return;
    if (mapped === locale) {
      // The auth page already spoke this explicit preference, so no visual switch
      // is needed; it still becomes the next account's persistent locale.
      if (preferred && hadSignedOutAuthLocale) persist(preferred);
      return;
    }

    // Whatever happens below, the next boot starts in the right language — and that
    // alone is the fallback for every path that declines to switch now.
    persist(mapped);

    // Never pull the UI out from under an in-flight send: re-rendering the route tears
    // down the chat page and kills the stream the user is waiting on.
    if (isSending()) return;
    // No router (script order changed, app.js failed to evaluate) — no way to re-render
    // in place, so degrade to the reload this used to do.
    if (typeof window.App?.route !== "function") return location.reload();

    loadBundle(mapped, function (ok) {
      if (!ok) {
        // Offline, or a bundle missing from the deploy: stay in the booted locale, which
        // is intact and complete. Once is enough — this is not the user's problem.
        if (!bundleWarned) {
          bundleWarned = true;
          console.warn("[i18n] could not load the", mapped, "bundle; staying on", locale);
        }
        return;
      }
      // Re-check: a seeded auto-send (/chat?q=…) can start while the bundle is in
      // flight. Same call as above — switching now would abort it.
      if (isSending()) return;
      switchTo(mapped);
    });
  }

  // Whether the booted locale's messages are in hand. They usually are; when the
  // loader's bundle is still on its way, `ready` settles as it lands (or fails,
  // which leaves the keys on screen rather than nothing) and the table behind
  // t() is swapped in first, so a render waiting on `ready` never sees a key.
  let bundleReady = Boolean(bundle(locale));
  const pendingBundle = !bundleReady && window.__GHD_BUNDLE_READY__;
  const ready = pendingBundle
    ? pendingBundle.then(function (ok) {
        t.setMessages(core.messagesFor(locale));
        bundleReady = true;
        if (!ok && !bundleWarned) {
          bundleWarned = true;
          console.warn("[i18n] could not load the", locale, "bundle; showing message keys");
        }
      })
    : Promise.resolve();

  // Run `fn` with the messages in hand — at once when they are, which keeps the
  // common path synchronous.
  function whenReady(fn) {
    if (bundleReady) fn();
    else ready.then(fn);
  }

  window.GHD_I18N = {
    t: t,
    applyTranslations: applyTranslations,
    rememberSignedOutAuthLocale: rememberSignedOutAuthLocale,
    setLocale: setLocale,
    reconcile: reconcile,
    locale: locale,
    supported: SUPPORTED.slice(),
    locales: LOCALES.slice(),
    ready: ready,
    isReady: function () {
      return bundleReady;
    },
  };
  // Short global alias used throughout the app.
  window.t = t;

  function translateStaticMarkup() {
    whenReady(function () {
      applyTranslations(document);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", translateStaticMarkup);
  } else {
    translateStaticMarkup();
  }
})();

;
/* dashboard/js/config.js */
/* The dashboard's name for the shared environment.
 *
 * The values live in /app-config.js (window.GHD_APP), which every page on both
 * origins loads — one Supabase project, one API base, one release stamp. This
 * file is the alias that keeps the ~40 `CONFIG.…` call sites in the app reading
 * the way they always have.
 *
 * Read through, not copied, for two reasons. Load order stops mattering: the
 * shell happens to load this script just before app-config.js, and a snapshot
 * taken here would be a snapshot of nothing. And nothing can drift: there is no
 * second copy of a value to fall behind.
 *
 * The last line is not decoration. `const CONFIG` at the top level of a classic
 * script is a lexical global and never a property of `window` — the trap that
 * silently broke the open-in-browser link (see platform.js
 * openSettingsInBrowserHref). Publishing it is what lets the public share pages,
 * which load this file for `CONFIG.versionedAsset`, reach it at all.
 */
const CONFIG = {
  get SUPABASE_URL() {
    return GHD_APP.SUPABASE_URL;
  },
  get SUPABASE_ANON_KEY() {
    return GHD_APP.SUPABASE_ANON_KEY;
  },
  get API_BASE_URL() {
    return GHD_APP.API_BASE_URL;
  },
  // "dev" where no release stamped the shell, as this has always answered.
  get APP_VERSION() {
    return GHD_APP.appVersion() || "dev";
  },
  versionedAsset(path) {
    return GHD_APP.versionedAsset(path);
  },
};
window.CONFIG = CONFIG;

;
/* app-config.js */
/* The environment every page runs in — loaded by the landing site, the app SPA,
 * the share pages, the knowledge base, the consent screen and the /go/ handoff.
 *
 * One copy of the things that used to be spelled out per file: the two origins,
 * the API base, the Supabase project, and the one reader of the stored session.
 * They were duplicated across a dozen files, so a change of project or host had
 * to be found by grep and was silently half-done when a copy was missed.
 *
 * Dependency-free and safe to run first: it touches nothing but `location` at
 * load, because several pages load it in the head before anything else.
 *
 * It also carries the store-app facts. The app is on Google Play and in the App
 * Store, so on Android and on iPhone and iPad the store app replaces the PWA
 * everywhere we used to promote installing: the landing page shows that
 * store's badge instead of the install button, and the dashboard sends
 * "Download app" taps to the store. Only desktop still gets the PWA. */
(function () {
  // Both hostnames reach the local dev stack — docker publishes nginx on the two
  // ports for either name, and developers type both. One definition, so a page
  // opened on 127.0.0.1 does not get local API calls and production links.
  var isLocal = ["localhost", "127.0.0.1"].indexOf(location.hostname) !== -1;

  // Local dev on a local Supabase (`make serve SUPABASE=local`, which starts
  // one with tools/dev/local_supabase.py). The backend is switched by its
  // environment; the browser is switched here, once per browser, by visiting
  // any local page with ?supabase=local — sticky until ?supabase=prod — the
  // way ?dev_login=off works. A flag rather than a build step because this file
  // is served straight from the source tree and has to decide before anything
  // else runs; localStorage directly rather than GHD.storage because nothing
  // else is loaded yet. Never true off localhost.
  var localSupabase = false;
  if (isLocal) {
    try {
      var wanted = new URLSearchParams(location.search).get("supabase");
      if (wanted === "local") localStorage.setItem("ghd_supabase", "local");
      if (wanted === "prod") localStorage.removeItem("ghd_supabase");
      localSupabase = localStorage.getItem("ghd_supabase") === "local";
    } catch (e) {
      /* storage blocked: production project, as before */
    }
  }

  window.GHD_APP = {
    isLocal: isLocal,
    // Which Supabase the browser talks to. Shown by the dev bar so a session
    // on the wrong project is visible at a glance.
    localSupabase: localSupabase,

    // --- Origins -------------------------------------------------------------
    // The marketing site and the app SPA are separate origins: the site is served
    // from www.gethumandesign.com, the app from app.gethumandesign.com. Anything
    // that links from one to the other must use an absolute URL built from these
    // — a bare "/privacy" inside the app resolves to the *app* origin and 404s.
    //
    // They are separate hosts (not just paths) because the Android TWA claims one
    // host wholesale: while the app's scope covered the marketing site, Android
    // opened gethumandesign.com inside the app, where Play's payments policy
    // forces the pricing UI to stay hidden — so signed-in users could not reach a
    // price at all. A distinct app host is what makes "the website" and "the app"
    // separable to Android, to Play, and to link handling in general.
    //
    // Local dev mirrors the same two-origin shape on two ports (docker-compose.yml
    // + frontend_web/nginx.conf), so cross-origin bugs surface locally rather than
    // in production.
    SITE_ORIGIN: isLocal ? "http://localhost:8080" : "https://www.gethumandesign.com",
    APP_ORIGIN: isLocal ? "http://localhost:8081" : "https://app.gethumandesign.com",
    // The marketing host as it is written down, whatever is serving this page.
    // kb-links.json carries these absolute URLs in every environment, because the
    // MCP clients that read the same map have no origin to resolve a path against
    // — so anything recognising a knowledge-base URL has to know this name too.
    SITE_CANONICAL: "https://www.gethumandesign.com",
    // Absolute URL for a path on the marketing site, e.g. siteUrl("/privacy/").
    siteUrl: function (path) {
      return this.SITE_ORIGIN + (path || "/");
    },
    // Absolute URL for a path/route in the app, e.g. appUrl("//settings").
    appUrl: function (path) {
      return this.APP_ORIGIN + (path || "/");
    },

    // --- The API ---------------------------------------------------------------
    // Local dev proxies /api/ on whichever origin the page came from → the
    // backend_api container (docker-compose.yml + frontend_web/nginx.conf).
    // Everywhere else calls the live API host directly, cross-origin.
    API_BASE_URL: isLocal ? "/api" : "https://api.gethumandesign.com",

    // --- Supabase --------------------------------------------------------------
    // The project the browser talks to. The anon key is public by design — it
    // carries no privilege of its own; row-level security and the user's JWT
    // decide what it may read. It is in the page source of every deployed page.
    // (Replaced below when the browser is switched to the local stack.)
    SUPABASE_REF: "esxruozvqtkmjspwwwkx",
    SUPABASE_URL: "https://esxruozvqtkmjspwwwkx.supabase.co",
    SUPABASE_ANON_KEY:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVzeHJ1b3p2cXRrbWpzcHd3d2t4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE3ODE0MTQsImV4cCI6MjA4NzM1NzQxNH0.pbkrWH8vU3o2zBEbMIfrpHxM0DDUYIJUYtnSi1swVcM",

    // Where the Supabase SDK keeps the session for this project. Pages read it
    // directly rather than waiting on the SDK's async init, which can take
    // seconds when a token refresh is due — first paint would wait with it.
    sessionKey: function () {
      return "sb-" + this.SUPABASE_REF + "-auth-token";
    },

    /**
     * The stored session if it is usable right now, else null.
     *
     * "Usable" means a token with a user attached that is still valid in 30
     * seconds — the margin keeps a request that is about to be sent from going
     * out with a token that expires in flight.
     *
     * Not every reader wants this question: /go/ and the app's own boot path
     * deliberately accept an expired access_token, because api.js refreshes and
     * retries on a 401 and bouncing to /login on expiry logs out people coming
     * back from a long redirect. Those read sessionKey() and judge for
     * themselves; everyone asking "is someone signed in" asks here.
     */
    readSession: function () {
      try {
        var raw = localStorage.getItem(this.sessionKey());
        var stored = raw ? JSON.parse(raw) : null;
        var notExpired = stored && stored.expires_at && stored.expires_at > Date.now() / 1000 + 30;
        if (stored && stored.access_token && stored.user && notExpired) return stored;
      } catch (e) {
        /* malformed token, or storage blocked entirely */
      }
      return null;
    },

    // --- Release ---------------------------------------------------------------
    // The release the shell was served with. Only the app shell stamps one
    // (dashboard/index.html); the public pages carry no <meta name="version">.
    // Read on demand, not at load: this file runs in the head of most pages,
    // before the parser has reached the meta.
    appVersion: function () {
      var meta = document.querySelector('meta[name="version"]');
      return (meta && meta.content) || "";
    },

    // An asset URL that changes when the release does, so a year-long immutable
    // cache entry can never outlive its content. On a page with no release stamp
    // the path is returned untouched: a "?v=" of nothing would only mint a second
    // cache entry for the same bytes (the share pages, which draw the bodygraph
    // SVG, are the pages that need this).
    versionedAsset: function (path) {
      var version = this.appVersion();
      if (!version) return path;
      var url = new URL(path, window.location.origin);
      url.searchParams.set("v", version);
      return url.toString();
    },

    PLAY_STORE_URL: "https://play.google.com/store/apps/details?id=com.gethumandesign.app",
    // The App Store listing (iPhone and iPad). The id is also the Smart App
    // Banner's `app-id` in every page head that carries one, and backend
    // email/letters.py spells the same URL; site-app-store.test.js pins all three.
    APP_STORE_ID: "6819655533",
    APP_STORE_URL: "https://apps.apple.com/app/id6819655533",
    // The App Store launch switch. Off until Apple approves the iOS app, because
    // the listing above does not exist publicly before then: off, nothing outside
    // the iOS app points at it (badges, Smart App Banner, the Home Screen note,
    // the FAQ answer, the letters' badge) and iPhone keeps Add to Home Screen.
    // The build reads this line too (tools/lib/app_store_switch.py), and the
    // backend's copy, config.APP_STORE_LIVE, is held equal to it by a test. Flip
    // both at go-live, then delete the switch (docs/plans/ios-app.md, "Launch").
    APP_STORE_LIVE: false,
    // Where an App Store subscription is managed from any browser: the web's
    // answer for an account Apple bills, which no Stripe portal can touch.
    APP_STORE_SUBSCRIPTIONS_URL: "https://apps.apple.com/account/subscriptions",
    // Sign in with Apple on every login and signup surface. Turning it off hides
    // the buttons without touching accounts that already sign in with Apple.
    APPLE_SIGN_IN: true,
    // Must match `packageId` in frontend_android/twa-manifest.json and
    // `package_name` in .well-known/assetlinks.json. Named separately from the
    // store URL because an intent:// link addresses the package, not the listing.
    ANDROID_PACKAGE: "com.gethumandesign.app",
    // Locales we ship an official "Get it on Google Play" badge for. To add a
    // language, download its official badge (see i18n/README.md) and drop the SVG
    // at assets/google-play-badge-<locale>.svg, then add the locale here.
    PLAY_BADGE_LOCALES: [
      "en",
      "nl",
      "de",
      "es",
      "fr",
      "it",
      "pt",
      "hu",
      "ru",
      "pl",
      "id",
      "tr",
      "ca",
      "uk",
      "el",
      "cs",
      "sv",
      "nb",
      "ro",
      "fi",
      "th",
      "vi",
      "bg",
      "da",
      "zh",
      "ko",
      "ja",
    ],
    // Locales whose official badge we hold only as a raster. The SVGs come from
    // Google's Partner Marketing Hub, which serves them behind a sign-in; the
    // badge is outlined text, so it cannot be retyped into an existing SVG
    // without stopping being Google's artwork. Hungarian and Russian therefore
    // ship the official PNG Google itself serves at
    // play.google.com/intl/<code>/badges/ — 646x250 into a ~135px slot is a 4.8x
    // source, so it is not soft. Swap either for the SVG (and drop the entry) the
    // next time someone is signed in to the hub. `footer.play_badge` in that
    // locale's common.json holds the same path for the footer partial and must be
    // changed with it. zh is Google's zh-TW badge (立即下載, Traditional), from
    // play.google.com/intl/en_us/badges/static/images/badges/zh-tw_badge_web_generic.png
    // — the same source tr's file is byte-identical to. sv, nb, ro, fi, th, vi, bg, da,
    // ko and ja are sv_, no_, ro_, fi_, th_, vi_, bg_, da_, ko_ and ja_badge_web_generic.png
    // from the same directory (Google has no nb file; its Norwegian badge is "no").
    PLAY_BADGE_PNG: [
      "hu",
      "ru",
      "pl",
      "id",
      "tr",
      "ca",
      "uk",
      "el",
      "cs",
      "sv",
      "nb",
      "ro",
      "fi",
      "th",
      "vi",
      "bg",
      "da",
      "zh",
      "ko",
      "ja",
    ],
    // Locales Apple publishes a localized "Download on the App Store" badge in,
    // saved from its Marketing Tools (tools.applemediaservices.com/api/badges/
    // download-on-the-app-store/black/<lang-region>) as assets/app-store-badge-
    // <locale>.svg, with a 3x PNG beside it for the letters (mail clients do not
    // draw SVG). Always the black badge: Apple asks for it whenever another
    // store's badge shares the layout, and it carries its own grey rule for dark
    // pages. Ukrainian is missing because Apple's tool serves the English badge
    // for it, so uk falls back to en. `footer.app_store_badge` in each
    // common.json names the same file for the footer partial.
    APP_STORE_BADGE_LOCALES: [
      "en",
      "nl",
      "de",
      "es",
      "fr",
      "it",
      "pt",
      "hu",
      "ru",
      "pl",
      "id",
      "tr",
      "ca",
      "el",
      "cs",
      "sv",
      "nb",
      "ro",
      "fi",
      "th",
      "vi",
      "bg",
      "da",
      "zh",
      "ko",
      "ja",
    ],
    // Locales the knowledge base is actually translated into — i.e. the ones with
    // a docs/knowledge-base/<locale> tree. The app has to know: it links into the
    // docs from chat replies and group pages, and a /<locale>/docs/… URL for a
    // language that was never built is a 404, which is worse than the English
    // page. Pinned to the trees on disk by tools/gate/i18n_check.py, so it
    // cannot drift.
    DOCS_LOCALES: [
      "en",
      "nl",
      "de",
      "es",
      "fr",
      "pt",
      "it",
      "hu",
      "ru",
      "pl",
      "id",
      "tr",
      "ca",
      "uk",
      "el",
      "cs",
      "sv",
      "nb",
      "ro",
      "fi",
      "th",
      "vi",
      "bg",
      "da",
      "ko",
      "ja",
      "zh",
    ],
    // The knowledge-base location for a UI locale: /docs/… in English,
    // /<locale>/docs/… where that language exists, and English for anything else.
    // Accepts either a root-relative path or an absolute URL on SITE_ORIGIN because
    // kb-links.json deliberately serves absolute canonical URLs for the MCP clients
    // that share it with the browser.
    docsPath: function (pathOrUrl, locale) {
      var p = String(pathOrUrl || "/");
      var l = (locale || "en").slice(0, 2).toLowerCase();
      if (l === "en" || this.DOCS_LOCALES.indexOf(l) === -1) return p;
      if (p.indexOf("/docs/") === 0) return "/" + l + p;
      // An absolute URL is localized under the host it already names, ours or not
      // yet resolved: kb-links.json is written with SITE_CANONICAL everywhere, so
      // matching only against this environment's SITE_ORIGIN left every
      // translated link on localhost and on preview deploys pointing at the
      // English tree — production behaviour that local dev could never surface.
      var absolute = /^(https?:\/\/[^/]+)(\/docs\/.*)$/.exec(p);
      if (absolute && (absolute[1] === this.SITE_ORIGIN || absolute[1] === this.SITE_CANONICAL)) {
        return absolute[1] + "/" + l + absolute[2];
      }
      return p;
    },
    // URL of the official localized Play badge for a given UI locale (falls back to en).
    // Absolute, not root-relative: /assets/ only exists on the marketing origin, and
    // the dashboard — which shows this badge in its "Download app" row — is served
    // from the app origin, where a bare "/assets/…" would 404.
    playBadge: function (locale) {
      var l = (locale || "en").slice(0, 2).toLowerCase();
      if (this.PLAY_BADGE_LOCALES.indexOf(l) === -1) l = "en";
      var ext = this.PLAY_BADGE_PNG.indexOf(l) === -1 ? ".svg" : ".png";
      return this.siteUrl("/assets/google-play-badge-" + l + ext);
    },
    // The official localized App Store badge for a UI locale (falls back to en).
    // Absolute for the same reason as playBadge.
    appStoreBadge: function (locale) {
      var l = (locale || "en").slice(0, 2).toLowerCase();
      if (this.APP_STORE_BADGE_LOCALES.indexOf(l) === -1) l = "en";
      return this.siteUrl("/assets/app-store-badge-" + l + ".svg");
    },
  };

  if (localSupabase) {
    // The Supabase CLI's demo project, identical on every machine — the same
    // strings tools/dev/local_supabase.py prints. The ref is what supabase-js
    // derives from the host ("127"), and sessionKey() follows it, so a local
    // session is never read as a production one or the other way round.
    window.GHD_APP.SUPABASE_REF = "127";
    window.GHD_APP.SUPABASE_URL = "http://127.0.0.1:54321";
    window.GHD_APP.SUPABASE_ANON_KEY =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0";
  }
})();

// Local dev only: cross-origin links between the two origins are baked into the
// markup as absolute production URLs, so they are correct in production without
// depending on JS at all. On localhost that would send a developer to the live
// site, so re-point them at the matching local origin. Matching on the production
// prefix means no marker attribute is needed in the markup.
//
// Only rewrites links present at DOMContentLoaded. Anything built later in JS
// reads its origin off GHD_APP above, which is already the local one here.
(function () {
  if (!window.GHD_APP.isLocal) return;
  var MAP = [
    ["https://www.gethumandesign.com", window.GHD_APP.SITE_ORIGIN],
    ["https://app.gethumandesign.com", window.GHD_APP.APP_ORIGIN],
  ];
  var fix = function () {
    MAP.forEach(function (pair) {
      document.querySelectorAll('a[href^="' + pair[0] + '"]').forEach(function (a) {
        a.href = pair[1] + a.getAttribute("href").slice(pair[0].length);
      });
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fix);
  else fix();
})();

;
/* dashboard/js/lazy-libs.js */
/* Lazy loaders for heavyweight CDN libraries that only a few pages need.
   The CSP disallows inline scripts, so only external <script> tags are injected
   (CDN ones with their SRI hashes; same-origin js/vendor/ files without). */
(function () {
  "use strict";

  window.GHD = window.GHD || {};

  const _pending = {};

  // `ordered` marks a script that must run after the scripts injected before it
  // (async=false puts it in the browser's in-order list; the default for a
  // dynamically created script is async, which would run whichever downloads
  // first). Route chunks depend on each other, so they all set it.
  function injectScript(src, integrity, ordered) {
    return new Promise(function (resolve, reject) {
      const s = document.createElement("script");
      s.src = src;
      if (ordered) s.async = false;
      if (integrity) {
        s.integrity = integrity;
        s.crossOrigin = "anonymous";
      }
      s.onload = function () {
        resolve(s);
      };
      s.onerror = function () {
        s.remove();
        reject(new Error("Failed to load " + src));
      };
      document.head.appendChild(s);
    });
  }

  function injectStylesheet(href) {
    return new Promise(function (resolve, reject) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = function () {
        link.remove();
        reject(new Error("Failed to load " + href));
      };
      document.head.appendChild(link);
    });
  }

  // ── A file this release's tree no longer serves ───────────────────────────
  //
  // Every URL a loader here asks for is pinned to the release the shell was
  // built as: the route tags carry /v/<release>/ from the build, the loaders
  // below spell /v/__GHD_VERSION__/ and the deploy stamps it. Cloudflare Pages
  // serves one upload at a time, which carries this release's tree and the last
  // three before it (deploy/carry_releases.py), so a few deploys later an older
  // release's /v/ paths answer 404 —
  // and a tab still running that release finds out the first time it opens a
  // page it has not opened yet. A 404 is not a network error: the service
  // worker's offline fallback never sees it, and the router's Retry asks for
  // the same dead URL. The shell itself is served no-cache, so a reload is the
  // fix, and sw-register.js already knows when one is safe.
  //
  // So a failed load asks the app origin for its shell and reads which release
  // it references. A different one means a deploy landed: the reload goes
  // through the update flow — one attempt per release, never mid-reply. The
  // same one (a real network failure, or an edge that has not received the
  // deploy, where the shell and the asset agree), a check that cannot answer,
  // or a reload the update flow refuses all leave the failure to the caller,
  // whose retry runs the check again.
  //
  // Stamped by the deploy like every other `__GHD_VERSION__`; on localhost the
  // placeholder stays, and so does the one the source shell references.
  var RELEASE = "__GHD_VERSION__";

  // The release a shell's assets are pinned to, spelled either way a versioned
  // URL is: the /v/<release>/ path segment the build writes, or the ?v=<release>
  // query the source tree keeps (sw.js's releaseOf reads a request the same
  // way). The first reference is the one the shell was built as.
  function releaseReferencedBy(html) {
    var m = /\/v\/([A-Za-z0-9_.-]+)\//.exec(html) || /[?&]v=([A-Za-z0-9_.-]+)/.exec(html);
    return m ? m[1] : "";
  }

  var _releaseCheck = null; // one shell fetch shared by the loads failing together

  /* Whether the page is reloading because a newer release is live. Resolves false
     whenever the caller should keep its failure; never rejects, since the
     caller's own error is the one worth reporting. */
  function reloadIfReleaseMoved() {
    if (!_releaseCheck) {
      _releaseCheck = Promise.resolve()
        .then(function () {
          // Bounded: a stalled connection must end in the caller's failure
          // screen, not a page that waits for this forever.
          return fetch("/", { cache: "no-store", signal: AbortSignal.timeout?.(8000) });
        })
        .then(function (res) {
          return res.ok ? res.text() : "";
        })
        .then(function (html) {
          var live = releaseReferencedBy(html);
          if (!live || live === RELEASE) return false;
          var reloading = Boolean(
            GHD.swRegister && GHD.swRegister.reloadForNewRelease && GHD.swRegister.reloadForNewRelease(),
          );
          // Counts the tabs a deploy left without their code; the carried
          // trees should keep it near zero.
          GHD.reportClientError?.("reported", reloading ? "reloading" : "reload refused", null, {
            context: "Stale release",
          });
          return reloading;
        })
        .catch(function () {
          return false;
        })
        .then(function (reloading) {
          _releaseCheck = null;
          return reloading;
        });
    }
    return _releaseCheck;
  }

  // Run `loader` once; cache the promise so concurrent/repeat calls share it.
  // A failed load clears the cache so the next attempt can retry — unless the
  // failure means this release is gone (above), in which case the page is
  // reloading and the promise stays open: a rejection now would paint the
  // caller's failure state over a document that is about to be replaced
  // (location.reload() only takes effect after the current task).
  function loadOnce(key, loader) {
    if (!_pending[key]) {
      _pending[key] = loader().catch(function (err) {
        delete _pending[key];
        return reloadIfReleaseMoved().then(function (reloading) {
          if (reloading) return new Promise(function () {});
          throw err;
        });
      });
    }
    return _pending[key];
  }

  // ── Route chunks ───────────────────────────────────────────────────────────
  //
  // Every page is a route chunk. The shell's eager chain is what every page
  // needs before it can route — the router, the store, the API client, the
  // shell; each page's own files — the chat and its extensions, the person
  // page, groups, compare, settings, the auth screens, onboarding — wait in
  // dashboard/index.html as an inert tag (`<script type="text/x-route">` /
  // `<link rel="x-route-style">`) and are fetched here the first time
  // App.route() opens a page that needs them. Three names are not pages: "pdf"
  // (the export sheets, awaited by every Download PDF button), "stage" (the
  // fullscreen mandala, awaited by Chart.openStage) and "feedback" (the feedback
  // composer, awaited by the click that opens it or the QR dialog). The built shell preloads
  // the chat chunks, since that is where most sessions land.
  //
  // `data-route` on each tag lists the routes that want the file, so one file
  // can serve several pages without being downloaded twice. The production
  // build (tools/build/build_site.py) concatenates the files that share a route
  // list into one chunk and leaves a single tag behind, so this reads the same
  // markup either way and dev and production load the same code at the same
  // moment.
  //
  // Ordering is the document's: the tags sit where their <script defer> tags
  // used to, and the browser runs `async = false` scripts in the order they
  // were inserted — including across two loadRoute() calls, so a chunk added
  // while an earlier one is still in flight still waits for it.
  //
  // Caching is per URL, not per route: two routes sharing a chunk must not
  // evaluate it twice, or the second copy throws on `const People` already
  // being declared.

  function routeTags(name) {
    const selector = '[data-route~="' + name + '"]';
    return Array.prototype.slice.call(
      document.querySelectorAll('script[type="text/x-route"]' + selector + ", link[rel=x-route-style]" + selector),
    );
  }

  const _routeAssetsHere = new Set();

  /* Whether the named route's files have all run already — from an earlier
     visit, or because the page has no chunk of its own. The router asks before
     awaiting, so a page already in memory renders without a blank frame. */
  GHD.routeLoaded = function (name) {
    return routeTags(name).every(function (tag) {
      return _routeAssetsHere.has(tag.dataset.src || tag.dataset.href);
    });
  };

  // ── A chunk that fired `load` without running to its end ───────────────────
  //
  // A built chunk's last statement marks its own <script> (`data-sealed` on the
  // tag says it has one; build_site.write_route_chunks writes both). A body cut
  // short in transit still fires `load` — a syntax error, or an empty file, runs
  // nothing — and a cache that kept that copy replays it on every reload, since a
  // /v/ URL is immutable to the service worker and to the browser alike. So an
  // unsealed chunk is a failed load: its copy is dropped from the worker's cache,
  // and every later load of it asks under a fresh `refetch=` query, which no
  // cache on the way has seen. Tokens are kept by URL, which names its release.
  function refetchTokens() {
    try {
      return JSON.parse(GHD.storage.get(GHD.KEYS.routeRefetch)) || {};
    } catch (_error) {
      return {};
    }
  }

  function injectRouteScript(tag, url) {
    const sealed = tag.dataset.sealed !== undefined;
    const tokens = refetchTokens();
    const token = sealed && tokens[url];
    const src = token ? url + (url.indexOf("?") < 0 ? "?" : "&") + "refetch=" + token : url;
    return injectScript(src, null, true).then(function (script) {
      if (!sealed || script.dataset.ran) return;
      script.remove();
      tokens[url] = Date.now();
      GHD.storage.set(GHD.KEYS.routeRefetch, JSON.stringify(tokens));
      // The service worker's copy, under whatever query it was stored with.
      const href = new URL(url, location.href).href;
      return Promise.resolve(typeof caches === "undefined" ? [] : caches.keys())
        .then(function (names) {
          return Promise.all(
            names.map(function (name) {
              return caches.open(name).then(function (cache) {
                return cache.delete(href, { ignoreSearch: true, ignoreVary: true });
              });
            }),
          );
        })
        .catch(function () {})
        .then(function () {
          throw new Error("incomplete");
        });
    });
  }

  /**
   * Load everything the named route needs. A second call is a no-op, a failed
   * one can be retried, and the promise resolves only once every file has run.
   */
  GHD.loadRoute = function (name) {
    const jobs = routeTags(name).map(function (tag) {
      const url = tag.dataset.src || tag.dataset.href;
      return loadOnce("route-asset:" + url, function () {
        return (tag.dataset.src ? injectRouteScript(tag, url) : injectStylesheet(url)).then(function () {
          _routeAssetsHere.add(url);
        });
      });
    });
    return Promise.all(jobs);
  };

  // The Supabase SDK, off the boot path.
  //
  // A signed-in load reads its session straight out of localStorage and every
  // data call is a raw fetch with that access token (js/api.js), so the SDK is
  // 43 KB gzipped that the common load never touches. App.ensureSupabase()
  // (js/app.js) is what pages call — it also creates the client and subscribes
  // the auth listener; this only fetches the library.
  GHD.loadSupabase = function () {
    return loadOnce("supabase", function () {
      // Vendored from npm (package.json pins the version), so sign-in never
      // depends on a third-party CDN being reachable.
      return injectScript("/v/__GHD_VERSION__/js/vendor/supabase.min.js");
    });
  };

  // qrcode-generator (vendored, MIT) — "get the app" QR codes. Exposes window.qrcode.
  //
  // Root-absolute under this release's /v/ tree, like every URL a script builds
  // here. The shell is served from the app origin's root alone now (www stopped
  // serving it when Android 1.0.7 aged out), and the per-release path is what
  // stops an edge that has not received the deploy from answering with the
  // previous release's copy under an immutable URL (tools/build/build_site.py,
  // "The per-release asset tree"). On localhost the placeholder stays in the
  // path and nginx strips the prefix.
  GHD.loadQrLib = function () {
    return loadOnce("qr", function () {
      return injectScript("/v/__GHD_VERSION__/js/vendor/qrcode-generator.min.js");
    });
  };

  // The knowledge base's own bodygraph painter (docs/docs-bodygraph.js), for
  // articles opened in the in-app panel — 155 of the 209 pages embed one, and a
  // gate page without its bodygraph is the part that explains the gate. Only
  // fetched when a panel actually opens on such a page. Exposes GHD.docsBodygraph.
  GHD.loadDocsBodygraph = function () {
    return loadOnce("docs-bodygraph", function () {
      return injectScript("/v/__GHD_VERSION__/docs/docs-bodygraph.js");
    });
  };

  // The files one of the knowledge base's interactive figures needs, fetched
  // once (kb-panel.js names them): stylesheets, then scripts in order. A script
  // is a path or { src, integrity }.
  GHD.loadDocsWidget = function (name, css, js) {
    return loadOnce("docs-widget-" + name, function () {
      return Promise.all(
        css.map(injectStylesheet).concat(
          js.map(function (entry) {
            return injectScript(entry.src || entry, entry.integrity, true);
          }),
        ),
      );
    });
  };

  // The words that painter draws: the knowledge base's own string catalog
  // (/docs/i18n/<lang>.js, written by build_docs). A doc page loads it for
  // itself; the panel lifts the article out of that page and left the catalog
  // behind, so a Dutch article arrived with its chart labelled Head / Ajna /
  // Throat while every word around it read Hoofd / Ajna / Keel.
  //
  // Keyed by the language of the ARTICLE, not the reader's app language: the
  // two usually agree, but a link can point into the English tree when the
  // reader's language has no translated page, and the labels have to match the
  // prose beside them. Switching between two languages is a swap of
  // window.GHD_DOCS_I18N rather than a second request — GHD_DOCS_T reads that
  // global on every lookup, so each catalog is downloaded at most once.
  var catalogs = { en: null }; // language -> its catalog (en: the built-in fallbacks)

  GHD.loadDocsI18n = function (locale) {
    var lang = String(locale || "en")
      .slice(0, 2)
      .toLowerCase();
    var built = (window.GHD_APP && window.GHD_APP.DOCS_LOCALES) || ["en"];
    // A language the docs were never built in reads the English article, so it
    // wants the English labels — never a catalog URL that would 404.
    if (built.indexOf(lang) === -1) lang = "en";
    if (Object.prototype.hasOwnProperty.call(catalogs, lang)) {
      // English costs no request in either direction: the fallback every docs
      // script passes at its call site *is* the English string, so dropping the
      // catalog is what puts the labels back into English.
      window.GHD_DOCS_I18N = catalogs[lang];
      return Promise.resolve();
    }
    return loadOnce("docs-i18n-" + lang, function () {
      // Root-absolute on the app's own origin, exactly like docs-bodygraph.js
      // above: build_site.py copies the catalogs into dist_app/, so the app's
      // CSP never has to trust script from the marketing host.
      return injectScript("/v/__GHD_VERSION__/docs/i18n/" + lang + ".js");
    }).then(function () {
      catalogs[lang] = window.GHD_DOCS_I18N || null;
    });
  };

  // jsPDF + svg2pdf.js (bodygraph PDF export). Exposes window.jspdf.
  GHD.loadPdfLibs = function () {
    return loadOnce("pdf", async function () {
      await injectScript(
        "https://cdn.jsdelivr.net/npm/jspdf@2.5.2/dist/jspdf.umd.min.js",
        "sha384-en/ztfPSRkGfME4KIm05joYXynqzUgbsG5nMrj/xEFAHXkeZfO3yMK8QQ+mP7p1/",
      );
      // svg2pdf registers doc.svg() on the global jsPDF, so it must load second.
      await injectScript(
        "https://cdn.jsdelivr.net/npm/svg2pdf.js@2.3.0/dist/svg2pdf.umd.min.js",
        "sha384-sRb188NXE8ku8ZbRRZ1zljRWe+ze/QW/jKHA8UembL/MxZQEDjtv0C2jbKzEzjj1",
      );
    });
  };
})();

;
/* js/html-escape.js */
/**
 * HTML escaping — the single definition site for the whole site.
 *
 * Every page that builds markup by string concatenation loads this first and
 * calls `GHD.escapeHtml`. Do not hand-roll a local escape helper: the
 * `textContent` → `innerHTML` trick that reads as equivalent does NOT escape
 * double quotes, so its output breaks out of a quoted attribute.
 *
 * Extends the `window.GHD` namespace. Load before every other GHD file and
 * before any page script that renders user-supplied values.
 */
(function () {
  window.GHD = window.GHD || {};

  // Escape a value for safe insertion into innerHTML *or* a quoted attribute
  // (quotes are escaped too, so it is safe in both positions). Null and
  // undefined become the empty string; non-strings are coerced.
  GHD.escapeHtml = function (value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  };
})();

;
/* js/api-error.js */
/**
 * Reading an error body our API sent — the single definition site for the
 * whole site.
 *
 * A FastAPI `detail` is a string when *we* raised the HTTPException, and a list
 * of `{loc, msg, …}` objects when Pydantic rejected the request body before our
 * code ran. Callers put the result straight into `textContent`, so a list used
 * to reach the user as the literal "[object Object]" — which is how a signup
 * that left the birth time blank became an unreadable dead end people retried
 * nine times. Every page that shows what an API call said therefore reads it
 * through here rather than touching `body.detail`.
 *
 * Pydantic's own `msg` is written for whoever sent the request (often an LLM),
 * so it is a fallback, not a substitute for a form checking its own fields.
 *
 * Extends the `window.GHD` namespace and depends on nothing.
 */
(function () {
  window.GHD = window.GHD || {};

  /**
   * The sentence in a failed response's parsed JSON body, or "".
   *
   * FastAPI errors carry `detail`, PostgREST errors carry `message`; a caller
   * that wants its own wording writes `GHD.detailText(body) || fallback`.
   *
   * The object shape below (`{code, message}`) has a sentence too, and used to
   * come back empty: a reader who hit the chat wall was shown "Error 429" while
   * the wording naming their reset date sat unread in the body. Branching on the
   * code (`detailCode`) and reading the sentence are two questions, and the
   * answer to the second is the same field it is on every other shape.
   */
  GHD.detailText = function (body) {
    var detail = body && typeof body === "object" ? body.detail : null;
    if (typeof detail === "string" && detail) return detail;
    if (detail && typeof detail === "object" && !Array.isArray(detail)) {
      return typeof detail.message === "string" ? detail.message : "";
    }
    if (Array.isArray(detail)) {
      var joined = detail
        .map(function (entry) {
          return typeof entry === "string" ? entry : (entry && entry.msg) || "";
        })
        .filter(Boolean)
        .join(" ");
      if (joined) return joined;
    }
    var message = body && typeof body === "object" ? body.message : null;
    return typeof message === "string" ? message : "";
  };

  /**
   * The machine-readable `code` in a failed response's `detail`, or "".
   *
   * A few of our errors raise `detail` as an *object* — `{code, message, …}` —
   * so a client can branch on the reason instead of on the sentence: the chat
   * quota wall (`RATE_LIMITED`) and the duplicate-turn refusal
   * (`TURN_IN_FLIGHT`), which the chat swallows without a word. Reading it here
   * keeps the rule that nothing else touches `.detail` at all, since its three
   * shapes are the whole reason that rule exists.
   */
  GHD.detailCode = function (body) {
    var detail = body && typeof body === "object" ? body.detail : null;
    if (!detail || typeof detail !== "object" || Array.isArray(detail)) return "";
    return typeof detail.code === "string" ? detail.code : "";
  };

  /** Another field of an object `detail` (the data export's `export`, `retry_at`), or null. */
  GHD.detailField = function (body, key) {
    var detail = body && typeof body === "object" ? body.detail : null;
    if (!detail || typeof detail !== "object" || Array.isArray(detail)) return null;
    return Object.prototype.hasOwnProperty.call(detail, key) ? detail[key] : null;
  };
})();

;
/* js/signup-seed.js */
/**
 * Signup details shared across origins; keep the stored fields compatible.
 *
 *     { firstName?, birthDate, birthTime, birthPlace, noTime, timezone, savedAt, aiConsent? }
 *
 * `birthTime` may be empty; `noTime` distinguishes an unknown time from noon.
 * `aiConsent` is true only when the iOS app's signup consent box was ticked.
 */
(function () {
  window.GHD = window.GHD || {};

  var KEY = "ghd_signup_birth_data";
  var EMAIL_KEY = "ghd_signup_email";

  /**
   * Email confirmation links may be opened days after signup.
   */
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;

  var DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

  function text(value) {
    return typeof value === "string" ? value : "";
  }

  /**
   * Reject invalid timestamps explicitly; comparisons with NaN would bypass the TTL.
   */
  function read() {
    var stored;
    try {
      stored = JSON.parse(localStorage.getItem(KEY) || "null");
    } catch (e) {
      return null;
    }
    if (!stored || typeof stored !== "object") return null;
    if (typeof stored.savedAt !== "number" || Date.now() - stored.savedAt > TTL_MS) return null;
    if (!DATE_RE.test(text(stored.birthDate))) return null;
    if (!text(stored.birthPlace).trim()) return null;
    return {
      firstName: text(stored.firstName),
      birthDate: stored.birthDate,
      birthTime: text(stored.birthTime),
      birthPlace: stored.birthPlace,
      noTime: stored.noTime === true,
      timezone: text(stored.timezone),
      savedAt: stored.savedAt,
      aiConsent: stored.aiConsent === true,
    };
  }

  /**
   * Store the seed and its email; the email outlives the seed to prefill signup.
   */
  function write(seed, email) {
    var record = {
      firstName: text(seed && seed.firstName),
      birthDate: text(seed && seed.birthDate),
      birthTime: text(seed && seed.birthTime),
      birthPlace: text(seed && seed.birthPlace),
      noTime: !!(seed && seed.noTime),
      timezone: text(seed && seed.timezone),
      savedAt: seed && typeof seed.savedAt === "number" ? seed.savedAt : Date.now(),
      aiConsent: !!(seed && seed.aiConsent === true),
    };
    try {
      localStorage.setItem(KEY, JSON.stringify(record));
      if (email) localStorage.setItem(EMAIL_KEY, email);
    } catch (e) {
      /* private mode or full storage — onboarding falls back to asking again */
    }
    return record;
  }

  /** Both halves: a leftover email prefills the next signup on this device. */
  function clear() {
    try {
      localStorage.removeItem(KEY);
      localStorage.removeItem(EMAIL_KEY);
    } catch (e) {
      /* private mode */
    }
  }

  function readEmail() {
    try {
      return localStorage.getItem(EMAIL_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function writeEmail(email) {
    try {
      if (email) localStorage.setItem(EMAIL_KEY, email);
    } catch (e) {
      /* the field itself is already corrected */
    }
  }

  GHD.signupSeed = {
    KEY: KEY,
    EMAIL_KEY: EMAIL_KEY,
    TTL_MS: TTL_MS,
    read: read,
    write: write,
    clear: clear,
    readEmail: readEmail,
    writeEmail: writeEmail,
  };
})();

;
/* dashboard/js/icons.js */
/* The app's inline SVG glyphs: every drawing more than one page needs, once. */
(function () {
  window.GHD = window.GHD || {};

  // The glyphs drawn by more than one page. Each entry is a finished SVG
  // string, ready to drop into markup; a call site that wants another box, a
  // heavier stroke or a CSS class of its own asks GHD.icon() for it (below).
  // A CSS `width`/`height` on the parent still beats the attributes here, so
  // most hosts need neither.
  //
  // Keep an icon in its own file only when exactly one file draws it; the
  // moment a second file wants the same glyph it belongs here, or the two
  // copies drift (which is how the app ended up with two trash cans).
  //
  // Sizes are the ones the shared call sites already rendered at, so adopting
  // an entry never changes what is on screen.
  GHD.icons = {
    // "Add" buttons: .people-add-btn on People / Groups / Chats and the empty
    // states that repeat the same CTA.
    plus: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
    // List-filter box on People / Groups / Chats / the people picker. Sized and
    // positioned by .people-search-icon.
    search:
      '<svg class="people-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
    // .people-back-btn on every detail page (chart, group, pair).
    back: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>',
    // "Talk about this in chat" CTAs on the group + pair pages.
    chat: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>',
    // Small "remove this chip" x (group members, pair slots).
    close:
      '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    // Opens the large bodygraph stage from both person and connection charts.
    expand:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3"/><path d="M21 8V5a2 2 0 0 0-2-2h-3"/><path d="M3 16v3a2 2 0 0 0 2 2h3"/><path d="M16 21h3a2 2 0 0 0 2-2v-3"/></svg>',
    // Pro-gate empty states.
    lock: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>',
    // "Download PDF" in the group + pair topbars — a document, not a download
    // arrow (People's row menu still uses the arrow, see _PDF_ICON there).
    pdf: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M5 12V5a2 2 0 0 1 2-2h7l5 5v4"/><path d="M5 18h1.5a1.5 1.5 0 0 0 0-3H5v6"/><path d="M11 15v6h1a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-1z"/><path d="M20 15h-3v6"/><path d="M17 18h2"/></svg>',
    // Destructive actions on People + the group page.
    trash:
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>',
    // A conversation's actions menu: the sidebar rows and the Chats page rows.
    moreVertical:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><circle cx="12" cy="5" r="1.7"/><circle cx="12" cy="12" r="1.7"/><circle cx="12" cy="19" r="1.7"/></svg>',
    // Rename, on the group topbar + the Chats rows.
    pencil:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>',
    // "People" everywhere it is a destination: shell rail, sidebar, mobile tab,
    // chat header, chat context line, group cards. Every one of those containers
    // pins its own size in CSS, so the 15px here only applies where none does.
    users:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    // "Add person" in the sidebar, under "New chat": a figure, so the two rows
    // do not read as one ("Neuer Chat" was read as "neues Chart").
    userPlus:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>',
    // "There is a date behind this" — the transits page's moment pill, which is
    // the control that moves the whole page to another day. Distinct from
    // `clock`, which never opens anything: it marks a birth time as uncertain.
    calendar:
      '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 11h18"/></svg>',
    // "Back to now" — the counter-clockwise arrow on the transits page's moment
    // bar, which drops the `?at=` pin. A circle, not a `back` chevron: the
    // chevron means "up one level" everywhere else in the app, and this control
    // does not leave the page, it un-winds the clock on it.
    rewind:
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="2 5 2 11 8 11"/><path d="M4.6 15a9 9 0 1 0 2.1-9.4L2 11"/></svg>',
    // "This birth time isn't pinned down yet" — the chat context nudge, the
    // People roster row pill and the chart-detail pill all wear the same clock.
    clock:
      '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    // "This link leaves the app for a browser" — the box-and-arrow-out. Worn by
    // the Play app's "manage or cancel on the web" link, where the whole point of
    // the control is that it lands somewhere the app itself cannot go.
    externalLink:
      '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>',
    // "Shared via link" marker on a conversation row / a person's chart.
    globe:
      '<svg class="shared-globe" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>',
    // "Done" — a saved card's button, the birth-time explorer's stable rows,
    // the copy-link confirmation.
    check:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>',
    // "Put this on the clipboard" — a chat message's copy action and the
    // connect-an-assistant card's setup prompt. No size: each host sizes its
    // own button.
    copy: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>',
    // "Share this" — the conversation header and the People row menu. No size:
    // both hosts style their own button, and the stroke attributes are inline
    // because the per-message action buttons set no svg CSS of their own.
    share:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>',
    // "Report this reply" — the per-message action row.
    flag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/><line x1="4" y1="22" x2="4" y2="15"/></svg>',
    // "This row opens something" — the People roster rows and the compare picker.
    chevronRight:
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>',
    // "There is a menu behind this" — the conversation title, the birth-time
    // bands' expander.
    chevronDown:
      '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>',
    // "Ask the assistant this" — the chat's starter chips and the knowledge
    // base panel's ask button, which starts the same kind of question.
    spark:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v3M12 18v3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M3 12h3M18 12h3M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/></svg>',
    // "Both charts, one beside the other" — the fourth tab over the pair page's
    // bodygraph (js/compare.js). The only glyph here that is not a stroke
    // drawing: it is two filled panels in the two people's own colours, because
    // the tab beside three named ones has to say WHICH pair of charts without a
    // label of its own. The fills come from .cmp-view-tab-icon in compare-views.css,
    // the one sheet that owns --m1/--m2 as person colours.
    duoPanels:
      '<svg class="cmp-view-tab-icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><rect class="cmp-view-tab-icon-a" x="2.5" y="4.5" width="8.5" height="15" rx="2.5"/><rect class="cmp-view-tab-icon-b" x="13" y="4.5" width="8.5" height="15" rx="2.5"/></svg>',
    // The rounded speech bubble that stands for the assistant itself — the
    // mobile Chat tab and the "ask the AI about this" hints. Distinct from
    // `chat` above, which labels a "talk about this in chat" CTA.
    messageCircle:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
    // Transits: the shell rail, the mobile tab and the page itself. The sky's
    // own body stands for the sky — a planet glyph would name one planet, and
    // a clock already means "this birth time is the open question" elsewhere.
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="4.5"/><path d="M12 2v2M12 20v2M4.2 4.2l1.5 1.5M18.3 18.3l1.5 1.5M2 12h2M20 12h2M4.2 19.8l1.5-1.5M18.3 5.7l1.5-1.5"/></svg>',
    // The footer's theme button offers the dark theme with it, beside `sun`.
    // Both footers (partials/footer.html, dashboard/index.html) carry the two
    // drawings inline, since www loads no icons.js; theme-toggle.test.js holds
    // them to these entries.
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>',
    // Cycles and returns: the /cycles page, the person page's ⋯ menu and the
    // transits page's moment bar. An orbit with its body back at the start —
    // the return — rather than a circular arrow, which reads as "refresh".
    cycles:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5a8.5 8.5 0 1 1-6 2.5"/><circle cx="12" cy="3.5" r="1.6" fill="currentColor"/><circle cx="12" cy="12" r="2.2"/></svg>',
    // The knowledge base: the shell's rail and sidebar entry, and the mark on a
    // row that opens an article rather than the chat (js/chart-advanced.js).
    book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>',
  };

  /* One of the glyphs above, wearing a different frame. Only the opening <svg>
     tag's attributes change; a null or false value removes an attribute:
       GHD.icon("chevronDown", { width: null, height: null }) */
  GHD.icon = function (name, attrs) {
    var svg = (GHD.icons && GHD.icons[name]) || "";
    if (!svg || !attrs) return svg;
    return svg.replace(/<svg\b([^>]*)>/, function (_whole, open) {
      Object.keys(attrs).forEach(function (key) {
        var existing = new RegExp("\\s" + key + '="[^"]*"');
        var value = attrs[key];
        if (value == null || value === false) open = open.replace(existing, "");
        else if (existing.test(open)) open = open.replace(existing, " " + key + '="' + value + '"');
        else open += " " + key + '="' + value + '"';
      });
      return "<svg" + open + ">";
    });
  };
})();

;
/* dashboard/js/hd-names.js */
/* The names in a chart, and the name of the person it belongs to. */
(function () {
  window.GHD = window.GHD || {};

  // The 13 bodies a chart activates, named once.
  //
  // This lives in the shared namespace rather than on Chart because three
  // separate surfaces now print a planet's name — the Planets table and the
  // fullscreen stage (chart.js), the PDF (pdf.js) and the Advanced tab's Fixing
  // rows (chart-advanced.js) — and the app has already been bitten once by a
  // second copy of these names drifting out of step with the first. There is
  // deliberately NO display name in the code: planet names are ordinary
  // astronomy words that translate, so every one a reader sees comes out of the
  // `chart.planet.*` catalog through label().
  GHD.planets = {
    /** Row order of every planet table, in ENGINE names (what the payload keys). */
    ORDER: [
      "Sun",
      "Earth",
      "North Node",
      "South Node",
      "Moon",
      "Mercury",
      "Venus",
      "Mars",
      "Jupiter",
      "Saturn",
      "Uranus",
      "Neptune",
      "Pluto",
    ],

    /** Catalog key: "North Node", "NorthNode" and "northnode" all → "northnode". */
    key: function (planet) {
      return String(planet == null ? "" : planet)
        .toLowerCase()
        .replace(/[^a-z]/g, "");
    },

    /* The astronomical glyph, by any spelling of the name. */
    SYMBOLS: {
      sun: "☉",
      earth: "⊕",
      northnode: "☊",
      southnode: "☋",
      moon: "☾",
      mercury: "☿",
      venus: "♀",
      mars: "♂",
      jupiter: "♃",
      saturn: "♄",
      uranus: "♅",
      neptune: "♆",
      pluto: "♇",
    },

    /** The glyph for a planet, or "" for a body that has none (Lilith, Chiron
     *  — the astrology overlay, which only the Advanced tab draws). */
    symbol: function (planet) {
      return GHD.planets.SYMBOLS[GHD.planets.key(planet)] || "";
    },

    /** The id a chart payload's `data-planet` and the catalog are keyed by:
     *  "North Node" → "NorthNode". */
    id: function (planet) {
      return String(planet == null ? "" : planet).replace(/ /g, "");
    },

    /* One activation as the shape every drawing wants: glyph and short label
     * added, the rest left intact. `null` for a body this app does not chart.
     * Here rather than on Chart because the transits page has no chart.js. */
    fromActivation: function (act) {
      if (!act || !GHD.planets.SYMBOLS[GHD.planets.key(act.planet)]) return null;
      return Object.assign({}, act, {
        id: GHD.planets.id(act.planet),
        symbol: GHD.planets.symbol(act.planet),
        // Abbreviated: this label is drawn into the mandala ring, where every
        // extra character pushes its neighbour further out of place.
        label: GHD.planets.label(act.planet, { short: true }),
      });
    },

    /* The localized display name, by id ("NorthNode"), lower-cased id
     * ("northnode") or engine name ("North Node"). `short` is only defined
     * for the two lunar nodes; every other planet falls through to its full name. */
    label: function (planet, opts) {
      var key = GHD.planets.key(planet);
      if (!key) return "";
      var translate = typeof t === "function" ? t : null;
      if (!translate) return String(planet);
      if (opts && opts.short) {
        var abbrKey = "chart.planet." + key + "_short";
        var abbr = translate(abbrKey);
        if (abbr && abbr !== abbrKey) return abbr;
      }
      var fullKey = "chart.planet." + key;
      var full = translate(fullKey);
      // t() echoes the key when it is missing; show the caller's own name instead.
      return full === fullKey ? String(planet) : full;
    },
  };

  // The nine centers, named once — the same two-vocabulary split as GHD.planets.
  //
  // The engine name ("Solar Plexus") keys the payload and the bodygraph SVG, so
  // it stays English forever; what a reader sees comes out of the
  // `chart.center.*` catalog, because centers are one of the terms i18n/README
  // says the product translates. `key()` is also what a center's chat topic is
  // built from (`center-solarplexus`), which is why it must not depend on the
  // reader's language: the link travels, the sentence is rebuilt per locale.
  GHD.centers = {
    /** Top-to-bottom order of the bodygraph, in ENGINE names. */
    ORDER: ["Head", "Ajna", "Throat", "G", "Heart", "Spleen", "Solar Plexus", "Sacral", "Root"],

    /** Catalog key: "Solar Plexus", "solar-plexus" and "solarplexus" all → "solarplexus". */
    key: function (center) {
      return String(center == null ? "" : center)
        .toLowerCase()
        .replace(/[^a-z]/g, "");
    },

    /** The localized display name, by engine name or key. */
    label: function (center) {
      var key = GHD.centers.key(center);
      if (!key) return "";
      var translate = typeof t === "function" ? t : null;
      if (!translate) return String(center);
      var fullKey = "chart.center." + key;
      var full = translate(fullKey);
      // t() echoes the key when it is missing; show the caller's own name instead.
      return full === fullKey ? String(center) : full;
    },

    /** The engine name for a key ("solarplexus" → "Solar Plexus"), or null. */
    apiName: function (center) {
      var key = GHD.centers.key(center);
      if (!key) return null;
      for (var i = 0; i < GHD.centers.ORDER.length; i++) {
        if (GHD.centers.key(GHD.centers.ORDER[i]) === key) return GHD.centers.ORDER[i];
      }
      return null;
    },

    /* A definition's areas (`definition_groups`), each in bodygraph order:
     * `[["Ajna","Throat","G","Sacral"],["Spleen","Root"]]`. Older stored payloads
     * sorted alphabetically, so re-order (idempotent); unknown names go last. */
    areas: function (groups) {
      var order = GHD.centers.ORDER;
      var rank = function (name) {
        var i = order.indexOf(GHD.centers.apiName(name) || name);
        return i === -1 ? order.length : i;
      };
      return (Array.isArray(groups) ? groups : [])
        .filter(function (group) {
          return Array.isArray(group) && group.length > 0;
        })
        .map(function (group) {
          return group.slice().sort(function (a, b) {
            return rank(a) - rank(b);
          });
        })
        .sort(function (a, b) {
          return rank(a[0]) - rank(b[0]);
        })
        .map(function (group) {
          return group.map(GHD.centers.label);
        });
    },

    /* — "Ajna–Throat–G–Sacral · Spleen–Root". */
    areasText: function (groups) {
      return GHD.centers
        .areas(groups)
        .map(function (area) {
          return area.join("–");
        })
        .join(" · ");
    },
  };

  // ── Circuits ───────────────────────────────────────────────────────────────
  //
  // The engine names a channel's circuit group ("Individual") and its circuit
  // ("Knowing") in English, and both key the payload, the `data-circuit`
  // attribute the stylesheet colours by, and the `circuit-<group>` topic a
  // heading links through — so they stay English. What a reader sees comes out
  // of `chart.circuit_*`, the same words the docs build prints in a channel
  // page's circuit box (`i18n/<locale>/docs.json` `circuit.*`), because the
  // README says circuits translate and a page and the article it opens must
  // agree. Each branch is a literal `t("…")` so i18n-keys-exist.test.js can see
  // every key; a value neither table knows comes back as the engine's own word,
  // so a circuit the engine invents later renders as a word rather than a key.
  GHD.circuits = {
    /** The localized name of a circuit GROUP ("Individual" → "Individueel"). */
    groupLabel: function (group) {
      var raw = String(group == null ? "" : group);
      if (typeof t !== "function") return raw;
      var key = raw.toLowerCase();
      if (key === "integration") return t("chart.circuit_group_integration");
      if (key === "individual") return t("chart.circuit_group_individual");
      if (key === "collective") return t("chart.circuit_group_collective");
      if (key === "tribal") return t("chart.circuit_group_tribal");
      return raw;
    },

    /** The localized name of a CIRCUIT ("Knowing" → "Weten"). Integration is
     *  its own group and its own circuit, so it answers the group's word. */
    label: function (circuit) {
      var raw = String(circuit == null ? "" : circuit);
      if (typeof t !== "function") return raw;
      var key = raw.toLowerCase();
      if (key === "knowing") return t("chart.circuit_knowing");
      if (key === "centering") return t("chart.circuit_centering");
      if (key === "understanding") return t("chart.circuit_understanding");
      if (key === "sensing") return t("chart.circuit_sensing");
      if (key === "ego") return t("chart.circuit_ego");
      if (key === "defense") return t("chart.circuit_defense");
      if (key === "integration") return t("chart.circuit_group_integration");
      return raw;
    },
  };

  // ── The incarnation cross ─────────────────────────────────────────────────

  // The cross's name, angle and Godhead as the reader's locale writes them.
  // The payload keeps English (`description`, `angle`, `godhead`) and adds the
  // catalog keys (`name_key`, `godhead_key`); German, Spanish, Russian and the
  // other locales whose practitioners translate cross names get their own, the
  // rest carry the English in their catalog (decisions.md, 2026-09-23). A key
  // the catalog does not know comes back as the English, never as the key.
  function catalogOr(key, fallback) {
    if (typeof t !== "function") return fallback;
    var text = t(key);
    return text === key ? fallback : text;
  }

  GHD.cross = {
    /** "Rechtwinkliges Kreuz der Sphinx", or the English description. */
    name: function (cross) {
      if (!cross) return "";
      var english = cross.description || "";
      return cross.name_key ? catalogOr("chart.cross_name." + cross.name_key, english) : english;
    },
    /** The English name when the reader's differs from it, else "". */
    englishIfTranslated: function (cross) {
      var english = (cross && cross.description) || "";
      return english && GHD.cross.name(cross) !== english ? english : "";
    },
    /** "Rechter Winkel" for "Right Angle". */
    angle: function (angle) {
      var raw = String(angle == null ? "" : angle);
      var slug = raw.toLowerCase().replace(/\s+/g, "_");
      return slug ? catalogOr("chart.cross_angle." + slug, raw) : raw;
    },
    /** The Godhead as a row value: "Kali", "The Keepers of the Wheel". */
    godhead: function (cross) {
      if (!cross || !cross.godhead) return "";
      var text = cross.godhead_key ? catalogOr("chart.godhead." + cross.godhead_key, cross.godhead) : cross.godhead;
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
  };

  // ── Type, authority, profile and the other chart facts ────────────────────
  //
  // The engine states a chart's facts in English ("Projector", "Emotional",
  // "Investigator / Martyr"), and those strings key the payload, `data-type`
  // and the chat topics, so they stay English. What a reader sees is the term
  // their locale's Human Design community uses, from the catalog: the facts
  // that follow from the type (strategy, not-self theme, signature) are keyed
  // by the type, because a locale may give the Manifesting Generator words of
  // its own; the rest by the value's own slug. A value the catalog does not
  // know comes back as the engine's English, never as a key.
  function termSlug(value) {
    return String(value == null ? "" : value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  }

  function termOr(prefix, value, fallback) {
    var english = fallback == null ? String(value == null ? "" : value) : String(fallback);
    var key = termSlug(value);
    return key ? catalogOr(prefix + key, english) : english;
  }

  GHD.hdTerms = {
    slug: termSlug,
    /** "Manifesting Generator" → the reader's name for the type. */
    type: function (type) {
      return termOr("chart.type_name.", type);
    },
    /** "Emotional" (or "Emotional Authority") → the reader's authority name. */
    authority: function (authority) {
      var raw = String(authority == null ? "" : authority);
      return termOr("chart.authority_name.", raw.replace(/\s+Authority$/i, ""), raw);
    },
    /** "Split Definition" → the reader's definition type. */
    definition: function (definition) {
      return termOr("chart.definition_name.", definition);
    },
    /** The strategy of `type`, else the engine's `strategy` as given. */
    strategy: function (type, strategy) {
      return termOr("chart.strategy_name.", type, strategy);
    },
    /** The not-self theme of `type`, else the engine's `theme`. */
    notSelf: function (type, theme) {
      return termOr("chart.not_self_name.", type, theme);
    },
    /** The signature of `type`, else the engine's `signature`. */
    signature: function (type, signature) {
      return termOr("chart.signature_name.", type, signature);
    },
    /** One profile line's name: 1 → "Investigator". */
    line: function (line, fallback) {
      return termOr("chart.profile_line.", line, fallback == null ? "" : fallback);
    },
    /** "1/3" → "Investigator / Martyr" in the reader's words; `englishName`
     *  (the payload's `profile_name`) when the profile is not two lines 1–6. */
    profileName: function (profile, englishName) {
      var english = englishName == null ? "" : String(englishName);
      var m = /^\s*([1-6])\s*\/\s*([1-6])\s*$/.exec(String(profile == null ? "" : profile));
      if (!m || typeof t !== "function") return english;
      var first = GHD.hdTerms.line(m[1]);
      var second = GHD.hdTerms.line(m[2]);
      if (!first || !second) return english;
      var pair = t("chart.profile_name_pair", { first: first, second: second });
      return pair === "chart.profile_name_pair" ? first + " / " + second : pair;
    },
    /** "Initiation" → the reader's name for the cross's quarter. */
    quarter: function (quarter) {
      return termOr("chart.quarter_name.", quarter);
    },
    /** A swept attribute's value by the attribute's name ("authority",
     *  "Emotional"); a value of any other attribute comes back unchanged. */
    value: function (attribute, value) {
      var raw = String(value == null ? "" : value);
      if (!raw) return raw;
      if (attribute === "type") return GHD.hdTerms.type(raw);
      if (attribute === "authority") return GHD.hdTerms.authority(raw);
      if (attribute === "definition") return GHD.hdTerms.definition(raw);
      if (attribute === "quarter") return GHD.hdTerms.quarter(raw);
      return raw;
    },
  };

  // ── Channels ──────────────────────────────────────────────────────────────
  //
  // The engine names a channel in English, and that name travels in payloads and
  // chat topics. What a reader sees is `chart.channel.<a>-<b>`: the Latin-script
  // locales and Greek carry the English there, ru, uk and zh their glossary's
  // name (i18n/glossaries/<locale>.md, "The 36 channels").
  GHD.channels = {
    /** "10-20" for either gate order. */
    key: function (a, b) {
      var x = Number(a);
      var y = Number(b);
      return x < y ? x + "-" + y : y + "-" + x;
    },
    /** The reader's name for channel a–b, else `fallback` (the engine's). */
    label: function (a, b, fallback) {
      var english = fallback == null ? "" : String(fallback);
      if (!Number.isFinite(Number(a)) || !Number.isFinite(Number(b))) return english;
      return catalogOr("chart.channel." + GHD.channels.key(a, b), english);
    },
  };

  // ── Capitals ───────────────────────────────────────────────────────────────

  // Greek letters whose accents a capital drops. Monotonic tonos is U+0301
  // once decomposed; the polytonic marks go too (grave, breathings,
  // perispomeni), since a capital carries none of them. U+0308, the diaeresis,
  // is NOT an accent: it says two vowels are not a diphthong, and so the
  // dialytika-tonos letter keeps it (U+0390 capitalises to U+03AA).
  var GREEK_ACCENTS = /[\u0300\u0301\u0313\u0314\u0342]/g;
  var GREEK_ACCENT = /[\u0300\u0301\u0313\u0314\u0342]/;
  var GREEK_LETTER = /[Ͱ-Ͽἀ-῿]/;
  var GREEK_VOWEL_CAPITAL = /[ΑΕΗΙΟΥΩ]/;
  var CLUSTER = /\P{M}\p{M}*/gu;
  // The disjunctive eta, "or", keeps its accent in capitals so it is not read
  // as the article; a lone accented eta is always that word.
  var DISJUNCTIVE_ETA = /(^|[^\p{L}\p{M}])ή(?=$|[^\p{L}\p{M}])/gu;
  var HELD = "\ue000"; // a private-use stand-in for it while the rest is capitalised

  /* `text` in capitals, the way the reader's language writes them. */
  GHD.upper = function (text, lang) {
    var code = String(
      lang || (typeof document !== "undefined" && document.documentElement && document.documentElement.lang) || "en",
    );
    var s = String(text == null ? "" : text);
    if (!/^el\b/i.test(code)) return s.toLocaleUpperCase(code);
    var lostTonos = false;
    s = s
      .normalize("NFC")
      .replace(DISJUNCTIVE_ETA, "$1" + HELD)
      .normalize("NFD")
      .replace(CLUSTER, function (cluster) {
        var base = cluster.charAt(0);
        if (base === HELD) {
          lostTonos = false;
          return "Ή";
        }
        if (!GREEK_LETTER.test(base)) {
          lostTonos = false;
          return cluster.toLocaleUpperCase(code);
        }
        var marks = cluster.slice(1);
        var hadAccent = GREEK_ACCENT.test(marks);
        marks = marks.replace(GREEK_ACCENTS, "");
        var upper = base.toLocaleUpperCase(code);
        var hasDiaeresis = marks.indexOf("\u0308") !== -1;
        if (lostTonos && !hadAccent && !hasDiaeresis && (upper === "Ι" || upper === "Υ")) {
          marks += "\u0308";
          hasDiaeresis = true;
        }
        lostTonos = hadAccent && !hasDiaeresis && GREEK_VOWEL_CAPITAL.test(upper);
        return upper + marks;
      });
    return s.normalize("NFC");
  };

  // ── Names ──────────────────────────────────────────────────────────────────

  // Everything the app derives from a person's name. One family, one fallback:
  // where a name yields no letter at all, every avatar shows "?" rather than an
  // empty circle. `[...word][0]` takes the first *code point*, so an emoji or a
  // non-BMP script survives instead of being split into half a surrogate pair.
  // A word's first letter for an avatar. Thai writes the vowels เ แ โ ใ ไ before
  // the consonant they follow in speech, and an initial is that consonant:
  // "ใจดี" is จ, as Thai abbreviations write it, not a vowel sign alone.
  function firstLetter(word) {
    var letters = [...word];
    return (
      letters.find(function (ch) {
        return !/[\u0e40-\u0e44]/.test(ch);
      }) ||
      letters[0] ||
      ""
    );
  }

  GHD.names = {
    // "Tim Vink" → "Tim". The label for a person anywhere space is tight.
    first: function (name) {
      return (
        String(name || "")
          .trim()
          .split(/\s+/)[0] || ""
      );
    },
    // "Tim Vink" → "T". Single-letter avatars (group members, chat context).
    initial: function (name) {
      // GHD.upper, not toUpperCase(): an avatar is a capital, and a Greek
      // capital drops its tonos ("Άννα" is "Α").
      return GHD.upper(firstLetter(GHD.names.first(name)) || "?");
    },
    // "Tim Vink" → "TV", "Prince" → "P". Two-letter avatars (People roster, the
    // person picker, the pair page).
    initials: function (name) {
      var text = String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(firstLetter)
        .join("");
      return GHD.upper(text) || "?";
    },
  };
})();

;
/* dashboard/js/platform.js */
/**
 * What this page is running in — and the one way out of it.
 *
 * OS and browser, the launch surface, whether this is our Play Store app, the
 * link that hands a route to a real browser, IME keydowns, and the reader's
 * time zone. Reads GHD.storage / GHD.KEYS as it evaluates, so it loads after
 * storage-keys.js and before android-build.js and api.js. App only.
 */
(function () {
  window.GHD = window.GHD || {};

  // Platform detection — computed once at load time, read everywhere.
  // - isApple: macOS / iOS (Cmd as the platform modifier).
  // - isIOS:   iPhone/iPad/iPod specifically, iPadOS's Mac UA included (used for
  //            install-instructions).
  // - isFirefox: Firefox (also wants special install-instruction text).
  // (Guarded for headless test environments where `navigator` is absent.)
  var _nav = typeof navigator !== "undefined" ? navigator : {};
  var _platformStr = _nav.platform || (_nav.userAgentData && _nav.userAgentData.platform) || "";
  var _ua = _nav.userAgent || "";
  // Launch surface: installed PWA (standalone) vs regular browser tab. Can only be
  // known client-side — the User-Agent is identical either way. Sent to the backend
  // (header X-Client-Surface) for usage attribution.
  // Read live, not once: a TWA can still report a non-standalone display mode
  // while origin verification is in flight (see pwa.js), so a value frozen at
  // load time can be wrong for the first few hundred milliseconds of a launch.
  // `fullscreen`/`minimal-ui` count too — a TWA is free to choose either, and
  // none of them is a browser tab.
  function _standaloneNow() {
    if (_nav.standalone === true) return true;
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return ["standalone", "fullscreen", "minimal-ui"].some(function (mode) {
      return window.matchMedia("(display-mode: " + mode + ")").matches;
    });
  }
  var _isAndroid = /Android/.test(_ua);
  // Our Bubblewrap TWA launches /?platform=twa on the app host with an
  // android-app:// referrer. The detection keys off the query parameter and the
  // referrer, not the path, so it survives the app moving between bases.
  // Detect the launch itself independently from storage: browsers may
  // deny storage, and that must not turn an authoritative launch URL/referrer
  // into a legacy-PWA false positive.
  //
  // Getting this wrong is not cosmetic. Google Play forbids any in-app purchase
  // UI, so `isTWA` is what keeps Stripe out of the app (upgrade-card.js) and the
  // store promos off it (pwa.js). It must fail *towards* "this is the app".
  var _twaSignal = false;
  try {
    var _qp = typeof location !== "undefined" && location.search ? new URLSearchParams(location.search) : null;
    _twaSignal = !!(_qp && _qp.get("platform") === "twa");
  } catch (e) {
    /* no URL API / malformed query — the Android referrer can still identify it */
  }
  // Package id must match `packageId` in frontend_android/twa-manifest.json and
  // `package_name` in .well-known/assetlinks.json.
  if (
    typeof document !== "undefined" &&
    document.referrer &&
    document.referrer.indexOf("android-app://com.gethumandesign.app") === 0
  ) {
    _twaSignal = true;
  }

  // Remembered within the session, so SPA routes and reloads that no longer
  // carry the launch URL still know where they are.
  if (_twaSignal) GHD.storage.session.set(GHD.KEYS.twa, "1");
  var _twaSession = GHD.storage.session.get(GHD.KEYS.twa) === "1";

  // ...and remembered across sessions, because the launch signals are not
  // guaranteed to be there at all. Android may kill the app's process and, when
  // the user returns to it from Recents, Chrome restores the *last visited* URL
  // rather than re-running the start URL: no ?platform=twa, no android-app://
  // referrer, and a brand-new (empty) sessionStorage. That resumed page looked
  // exactly like a legacy Android PWA, which is how a Stripe button came back
  // inside the Play app.
  //
  // localStorage is shared between the TWA and Chrome on this origin (that is
  // what makes auth seamless across them), so on its own it would mislabel real
  // browser tabs — including the one the upgrade emails deliberately open in
  // Chrome so that people *can* pay. Two guards make it safe to lean on:
  //   - only written from Android, so no desktop profile can ever hold it;
  //   - only believed when the display mode is app-like, and a Chrome tab never
  //     is. What it can still catch is a legacy Android PWA on a device that
  //     once launched the Play app — which is the harmless direction: that user
  //     is pointed at the website instead of Checkout.
  var _twaInstalled = false;
  if (_isAndroid) {
    if (_twaSignal) GHD.storage.set(GHD.KEYS.twaInstalled, "1");
    _twaInstalled = GHD.storage.get(GHD.KEYS.twaInstalled) === "1";
  }

  // Our App Store app: the shell appends `GHDiOS/<version>` to WKWebView's
  // User-Agent (`applicationNameForUserAgent`). The UA rides every load and
  // reload, so unlike the TWA's launch signals this needs no storage. Like
  // `isTWA`, it is what keeps Stripe and the store promos out of the app.
  var _isIOSApp = /GHDiOS\//.test(_ua);
  // iPadOS Safari, and our app's web view on an iPad, send the desktop Mac UA
  // ("Macintosh", platform "MacIntel"); only the touch points tell them apart.
  var _isIPadOS = /Macintosh/.test(_ua) && (_nav.maxTouchPoints || 0) > 1;

  GHD.platform = {
    isIOSApp: _isIOSApp,
    isApple: _isIOSApp || /Mac|iPhone|iPad/.test(_platformStr),
    isIOS: _isIOSApp || _isIPadOS || /iPad|iPhone|iPod/.test(_ua),
    isFirefox: /Firefox/.test(_ua),
    isAndroid: _isAndroid,
    // A getter, not a snapshot: the resumed-launch branch depends on the display
    // mode, which is not reliably settled at load time.
    get isTWA() {
      return _twaSignal || _twaSession || (_twaInstalled && _standaloneNow());
    },
    // ios = our App Store app; twa = our Play Store app; pwa = installed web app
    // (iOS/Android); web = browser tab.
    get surface() {
      if (this.isIOSApp) return "ios";
      return this.isTWA ? "twa" : _standaloneNow() ? "pwa" : "web";
    },
    // Where the app wears its phone shell: bottom tab bar, mobile header, the
    // sidebar as a drawer. A narrow window, or a phone turned on its side —
    // which is 667–956px wide but never taller than 440, while a landscape
    // tablet is at least 768 tall, so 500 splits them. `pointer: coarse` keeps
    // a short desktop window out. Every stylesheet block at the shell line
    // carries this string BYTE-IDENTICALLY (the `@media` blocks at 768px), so
    // a script and a stylesheet can never disagree about which layout is on;
    // decisions.md, "A phone on its side is a phone".
    PHONE_QUERY:
      "(max-width: 639px), (max-width: 768px) and (max-height: 799px), (max-height: 500px) and (orientation: landscape) and (pointer: coarse)",
    isPhoneLayout: function () {
      return (
        typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(GHD.platform.PHONE_QUERY).matches
      );
    },
    // The 900px line: where the person page, compare and group fold into one
    // column (the person page gains a Bodygraph tab). Same landscape clause, so
    // a 932px-wide Max phone on its side folds with the rest; every
    // `@media (max-width: 900px)` block carries it byte-identically.
    COMPACT_QUERY: "(max-width: 900px), (max-height: 500px) and (orientation: landscape) and (pointer: coarse)",
    isCompactLayout: function () {
      return (
        typeof window !== "undefined" && !!window.matchMedia && window.matchMedia(GHD.platform.COMPACT_QUERY).matches
      );
    },
    // tokens.css stops CSS motion; script-driven motion (a smooth scroll, a
    // canvas animation) asks here.
    prefersReducedMotion: function () {
      return (
        typeof window !== "undefined" &&
        !!window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      );
    },
    // The `behavior` for scrollTo/scrollIntoView: CSS `scroll-behavior` does not
    // reach an explicit "smooth".
    scrollBehavior: function () {
      return GHD.platform.prefersReducedMotion() ? "auto" : "smooth";
    },
  };
  GHD.modKey = function () {
    return GHD.platform.isApple ? "⌘" : "Ctrl";
  };

  // An IME Enter picks a candidate, so don't send. keyCode 229 too: Safari
  // reports the committing Enter with isComposing already false. Desktop only
  // (fine pointer, and never Android, which covers DeX): an enterkeyhint="send"
  // tap mid-word also reports isComposing there, and must send.
  GHD.isComposingKey = function (e) {
    if (GHD.platform.isAndroid) return false;
    return (
      (e.isComposing || e.keyCode === 229) && window.matchMedia?.("(hover: hover) and (pointer: fine)").matches === true
    );
  };

  // Enter sends only where there is a hardware keyboard to type Shift+Enter on.
  // A touch keyboard has no Shift+Enter, so there Enter is the newline and the
  // send button sends, as in every other chat app.
  GHD.enterSends = function () {
    return window.matchMedia?.("(hover: hover) and (pointer: fine)").matches === true;
  };

  // ── The way out of the Play app, to a real browser ──────────────────────────
  //
  // Inside the Play app a *link* can never get the user to a browser, whatever it
  // points at. Everything here is web content rendered by Chrome, and Chrome
  // resolves navigations itself instead of handing them to Android: a URL on this
  // origin stays immersive, a URL anywhere else only grows the Custom Tab's URL
  // bar, and an http(s) navigation that would resolve to a browser — or to Chrome,
  // which is hosting us — is kept in place ("Navigation to self", Chromium's
  // ExternalNavigationHandler). This link used to be `api./v1/open/settings`, on
  // the one origin the app does not claim, in the belief that Android would pick a
  // browser for it the way it does for the same link tapped in Gmail. It doesn't:
  // no tap outside the app means no intent resolution at all, and the endpoint's
  // 303 to app./settings landed straight back inside the app. The button looked
  // like it reloaded Settings — which is exactly what it did.
  //
  // Only an app can leave an app, so the app is given a scheme of its own and asked
  // to do it: `OpenInBrowserActivity` in frontend_android/patch_generated_project.py
  // resolves the route against this origin and hands it to a browser (the one
  // rendering the app first, so the user is already signed in there). Chrome hands
  // an unknown scheme straight to Android, and `package=` makes Android resolve it
  // against *that package's* filters, so an install that predates the activity
  // matches nothing and quietly follows `browser_fallback_url` instead — the old
  // no-op rather than an error page.
  var BROWSER_ESCAPE_SCHEME = "ghd-browser";

  /* Where "manage your plan on the web" should point, for this surface. */
  GHD.openSettingsInBrowserHref = function () {
    // `typeof CONFIG`, not `window.CONFIG`: config.js declares `const CONFIG = {…}`
    // at the top level of a classic script, which is a global *lexical* binding and
    // never a property of `window` (same trap as `Api` — see kb-panel.js). Reading it
    // off `window` returned undefined in every browser, so `apiBase` was always "",
    // the absolute-URL guard below always tripped, and the intent branch never ran
    // once in production: the button navigated to the relative "/v1/open/settings",
    // which is not a route, so the SPA fell through to its default one and the app
    // looked like it jumped to a new chat.
    var apiBase = (window.CONFIG && window.CONFIG.API_BASE_URL) || "";
    var viaApiHost = apiBase + "/v1/open/settings";
    var appPackage = (window.GHD_APP && window.GHD_APP.ANDROID_PACKAGE) || "";
    // The fallback has to be an absolute URL for Android to parse it, which rules
    // out local dev, where API_BASE_URL is the nginx-proxied "/api". A developer
    // forcing ?platform=twa on localhost gets the plain link and can still click it.
    if (!GHD.platform.isTWA || !appPackage || apiBase.indexOf("https://") !== 0) return viaApiHost;
    return (
      "intent://settings#Intent;scheme=" +
      BROWSER_ESCAPE_SCHEME +
      ";package=" +
      appPackage +
      ";S.browser_fallback_url=" +
      encodeURIComponent(viaApiHost) +
      ";end"
    );
  };

  /* The IANA zone this browser is in, e.g. "Europe/Amsterdam": the only thing
   * that knows where the reader is (stored zones are birth places). Read live,
   * since it can change mid-session. "" where the runtime cannot answer, and
   * the backend then falls back to the stored zone. */
  GHD.readerTimezone = function () {
    try {
      return (Intl.DateTimeFormat().resolvedOptions().timeZone || "").trim();
    } catch (err) {
      return "";
    }
  };
})();

;
/* dashboard/js/site-links.js */
/* Links that leave the app for the marketing site — most of them into the
 * knowledge base. The app and www are different origins, so a root-relative path
 * inside the app resolves to the wrong one. */
(function () {
  window.GHD = window.GHD || {};

  /* Absolute URL for a path on the marketing site. Already-absolute URLs and
   * non-site paths pass through, so it is safe to apply twice. */
  GHD.siteUrl = function (path) {
    var p = String(path || "");
    if (/^[a-z]+:\/\//i.test(p)) return p;
    if (p.charAt(0) !== "/") return p;
    var origin = (window.GHD_APP && window.GHD_APP.SITE_ORIGIN) || "";
    return origin + p;
  };

  // ── The knowledge base ─────────────────────────────────────────────────────

  // The docs slug of a planet, from any spelling of its name. The planet pages
  // are kebab-case ("north-node") while a row's topic id carries the app's own
  // collapsed id ("planet-northnode"), so the engine name is the bridge: it is
  // the one spelling both sides can be derived from.
  function _planetSlug(planet) {
    var key = GHD.planets.key(planet);
    if (!key) return "";
    for (var i = 0; i < GHD.planets.ORDER.length; i++) {
      var name = GHD.planets.ORDER[i];
      if (GHD.planets.key(name) === key) return name.toLowerCase().replace(/\s+/g, "-");
    }
    return "";
  }

  /**
   * The release this shell was built as, or "" when it was never built.
   *
   * The deploy's build (tools/build/build_site.py, run by deploy/frontend.sh)
   * stamps every __GHD_VERSION__ in dist/ to `ghd-<sha>`, so a deployed page
   * carries a real release and the source tree — which local dev serves as-is
   * — still carries the placeholder. The `ghd-` prefix is what separates them:
   * the placeholder cannot be compared against literally, because that same
   * blanket substitution would rewrite the comparison too.
   *
   * Anything that uses this as a cache-buster has to know the difference. The
   * placeholder is a constant, so a URL built from it never changes and can
   * never bust anything.
   */
  function _release() {
    var meta = typeof document !== "undefined" ? document.querySelector('meta[name="version"]') : null;
    var ver = (meta && meta.content) || "";
    return ver.indexOf("ghd-") === 0 ? ver : "";
  }

  // Knowledge-base links — shared by the chat's in-reply links (chat-doc-links.js)
  // and the Penta viz (group.js). A /docs page is a static page outside the SPA,
  // so nothing there knows where the reader came from; without that, following a
  // link to "what gate 34 means" left people stranded on the docs site with no
  // route back to the conversation they were reading. Both sides of the fix live
  // here: the origin travels in the query, and /docs/docs.js turns it back into a
  // "back to your chat" control.
  GHD.kb = {
    /* The parsed /docs/kb-links.json map, or null when it cannot be had.
     * The promise is the cache; a failure drops it so the next caller retries. */
    _linksPromise: null,

    links: function () {
      if (GHD.kb._linksPromise) return GHD.kb._linksPromise;
      if (typeof fetch !== "function") return Promise.resolve(null);
      // Version the URL with the app release so a new deploy fetches a fresh map
      // rather than a service-worker-cached old-shape payload (the SW caches
      // /docs/* under its bare pathname). A non-ok response throws so the .catch
      // resets the promise.
      //
      // The cache mode follows the buster, and must: force-cache serves a hit
      // without revalidating it, whatever Cache-Control said, so it is only safe
      // while the URL itself changes per release. Unbuilt — local dev — there is
      // no release and therefore no buster, and force-cache pinned the first copy
      // the browser ever fetched for the life of the profile. That is how a map
      // predating the `topics` block outlived the feature that reads it: every
      // aspect row on the person page fell back to its chat link, in a checkout
      // whose own dist/ had been correct for hours. Revalidate instead — a 304
      // is cheap, and being wrong here is silent.
      //
      // Don't collapse the branch: force-cache is load-bearing where it stays.
      // A released page fetches this release's copy under /v/<release>/ — the
      // one path the app origin's _headers caches immutable (it drops www's
      // /docs/ rules) — and left on the default mode would still revalidate
      // 23 KB on every boot.
      var ver = _release();
      var url = ver ? "/v/" + encodeURIComponent(ver) + "/docs/kb-links.json" : "/docs/kb-links.json";
      GHD.kb._linksPromise = fetch(url, { cache: ver ? "force-cache" : "no-cache" })
        .then(function (response) {
          if (!response.ok) throw new Error("kb-links.json HTTP " + response.status);
          return response.json();
        })
        .then(function (map) {
          // A payload without gates is an old or truncated shape; treat it as no
          // map at all rather than letting half of it reach the callers.
          return map && map.gates ? map : null;
        })
        .catch(function () {
          GHD.kb._linksPromise = null; // allow a retry on a later call
          return null;
        });
      return GHD.kb._linksPromise;
    },

    /* The article that explains one aspect row, or "" when there is no page for
     * it (the row then leads into chat). Pure and DOM-free, so it is testable in
     * node. */
    topicUrl: function (topic, chart, map) {
      if (!topic || !map) return "";
      var data = chart || {};
      var topics = map.topics || {};
      var pick = function (table, key) {
        return (table && key && table[key]) || "";
      };

      // Signature and not-self are read off the type, and so is their page.
      if (topic === "type" || topic === "signature" || topic === "not-self") return pick(topics.type, data.type);
      if (topic === "profile") return pick(map.profiles, String(data.profile || "").replace("/", "-"));
      // The engine sends the bare name ("Emotional"), which is how the map is
      // keyed; a payload carrying the surface phrase resolves to the same page.
      if (topic === "authority") {
        return pick(topics.authority, String(data.authority || "").replace(/\s+Authority$/i, ""));
      }
      if (topic === "strategy") return topics.strategy || "";
      if (topic === "definition") return pick(topics.definition, data.definition);
      if (topic === "cross") return topics.cross || "";
      if (topic === "bridging-gates") return topics.bridging_gates || "";

      var channel = /^channel-(\d+)-(\d+)$/.exec(topic);
      if (channel) {
        // The map is keyed in the engine's canonical order; a row names the
        // gates in the order the chart lists them, which is not always the same.
        return pick(map.channels, channel[1] + "-" + channel[2]) || pick(map.channels, channel[2] + "-" + channel[1]);
      }
      var gate = /^gate-(\d+)$/.exec(topic);
      if (gate) return pick(map.gates, gate[1]);
      var center = /^center-([a-z]+)-(?:defined|undefined)$/.exec(topic);
      // apiName() answers null for an unknown key, which pick() reads as no page
      // — the same guard Chat._topicBody applies before naming a centre.
      if (center) return pick(topics.centers, GHD.centers.apiName(center[1]));
      // A channel list's group heading, keyed by the engine's group value
      // ("Individual"), which is what the heading carries in `data-circuit`.
      var circuit = /^circuit-(.+)$/.exec(topic);
      if (circuit) return pick(topics.circuits, circuit[1]);
      var planet = /^planet-(.+)$/.exec(topic);
      if (planet) return pick(topics.planets, _planetSlug(planet[1]));
      // A mark on the Transits page — the red R — rather than a row on a chart.
      // Its own namespace because `adv-` means the Advanced tab's value rows,
      // and a test on the backend pins that set exactly.
      var transit = /^transits-(.+)$/.exec(topic);
      if (transit) return pick(topics.transits, transit[1]);
      // Fixing and the astrology overlay have no page of their own; they fall
      // through to "" like any other topic the map does not carry.
      var advanced = /^adv-(.+)$/.exec(topic);
      if (advanced) return pick(topics.advanced, advanced[1]);
      return "";
    },

    /* True where a second tab is a bad place to send someone: an installed PWA */
    opensInPlace: function () {
      // Guarded rather than assumed: this module is also loaded into a bare
      // Node VM by the frontend tests, where neither global exists.
      if (typeof navigator !== "undefined" && navigator.standalone) return true; // iOS home-screen PWA
      if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
      return window.matchMedia("(display-mode: standalone)").matches || window.matchMedia("(pointer: coarse)").matches;
    },

    /* `url` with the reader's origin appended as query params, following the
     * app's ?from=/&conv= convention. Returns `url` untouched without an origin. */
    href: function (url, origin) {
      if (!url) return "";
      // Every knowledge-base link in the app comes through here — chat replies,
      // the group page's channel links, the in-app panel's fetch and its "open
      // full page" — so this is where the reader's language is applied. The
      // English tree is the fallback: docsPath only prefixes a locale the docs
      // were actually built in, because a /<locale>/docs/… 404 is worse than an
      // English page that answers the question.
      url = String(url);
      if (typeof window !== "undefined" && window.GHD_APP && window.GHD_I18N) {
        url = window.GHD_APP.docsPath(url, window.GHD_I18N.locale);
      }
      // The knowledge base is served from the marketing origin, and the app from
      // its own — so a root-relative "/docs/…" here would resolve to the app,
      // which has no doc pages. Absolute before anything else touches it, since
      // this value is used both as an <a href> and as a full navigation.
      url = GHD.siteUrl(url);
      if (!origin || !origin.from) return url;
      var hashAt = String(url).indexOf("#");
      var hash = hashAt === -1 ? "" : String(url).slice(hashAt);
      var path = hashAt === -1 ? String(url) : String(url).slice(0, hashAt);
      var parts = path.split("?");
      var params = new URLSearchParams(parts[1] || "");
      Object.keys(origin).forEach(function (key) {
        if (origin[key]) params.set(key, origin[key]);
      });
      return parts[0] + "?" + params.toString() + hash;
    },
  };
})();

;
/* dashboard/js/ui-toast.js */
/* Transient messages, and the one rule for showing a failed request. */
(function () {
  window.GHD = window.GHD || {};

  // Show a transient toast (e.g. "Copied!") inside a copy button.
  GHD.showCopyToast = function (btn, message) {
    var existing = btn.querySelector(".chat-copy-toast");
    if (existing) existing.remove();
    var toast = document.createElement("span");
    toast.className = "chat-copy-toast";
    toast.textContent = message;
    btn.appendChild(toast);
    setTimeout(function () {
      toast.remove();
    }, 1500);
  };

  // Show a non-blocking toast at the bottom of the screen. Replaces native
  // alert() across the app. Only one toast is visible at a time.
  //
  // An error (the default) is announced assertively and stays until it is
  // closed or the next toast replaces it. A `kind` of "status" is for
  // confirmations and notices: announced politely, gone after a time that
  // grows with its length, and held while the pointer is on it.
  GHD.toast = function (message, kind) {
    var isError = kind !== "status";
    var existing = document.querySelector(".ghd-toast");
    if (existing) existing.remove();
    var el = document.createElement("div");
    el.className = "ghd-toast";
    el.setAttribute("role", isError ? "alert" : "status");
    el.textContent =
      message ||
      (typeof t === "function" ? t("people.something_went_wrong") : "Something went wrong. Please try again.");
    var timer;
    var hide = function () {
      el.classList.remove("visible");
      // Outlasts the leaving transition (--toast-dur off .ghd-toast in
      // ui.css, 250ms) so the toast finishes sinking before it is removed.
      setTimeout(function () {
        el.remove();
      }, 300);
    };
    // About 15 characters a second, never under 5 s.
    var arm = function () {
      timer = setTimeout(hide, Math.max(5000, el.textContent.length * 65));
    };
    if (isError) {
      // The PWA banner's close style (dashboard.css) keeps the eager
      // stylesheet under its ceiling.
      var close = document.createElement("button");
      close.className = "pwa-banner-close";
      close.setAttribute("aria-label", typeof t === "function" ? t("action.close") : "Close");
      close.textContent = "\u00d7";
      close.addEventListener("click", hide);
      el.appendChild(close);
    } else {
      el.addEventListener("mouseenter", function () {
        clearTimeout(timer);
      });
      el.addEventListener("mouseleave", arm);
      arm();
    }
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      el.classList.add("visible");
    });
    return el;
  };

  // ── Error reporting ────────────────────────────────────────────────────────

  /* Log a failure once and tell the user about it in their own language. */
  GHD.reportError = function (err, opts) {
    opts = opts || {};
    console.warn(opts.context ? opts.context + " failed:" : "Request failed:", err);
    var userFacing = GHD.userFacingError(err);
    // Developer text is a fault worth an app_errors row (js/error-reporter.js);
    // a 4xx written for the user — "Group name already taken" — is the app
    // working as designed, and reporting it would file every duplicate name
    // anyone ever types as a fault.
    if (!userFacing && GHD.reportClientError) {
      GHD.reportClientError("reported", err && err.message ? err.message : String(err), err && err.stack, {
        context: opts.context,
      });
    }
    GHD.toast(GHD.errorText(err, opts.fallbackKey));
  };

  // The sentence to show for `err` in the reader's language: the server's own
  // words for a 4xx, a plain account of a network failure, a timeout or a 5xx,
  // and otherwise the caller's fallback. Never the browser's "Failed to fetch"
  // or "API error 500". `forUser` marks an Error the app wrote for the reader.
  GHD.errorText = function (err, fallbackKey) {
    if (err && err.forUser && err.message) return err.message;
    var shown = GHD.userFacingError(err);
    if (shown) return shown;
    var status = err && err.status;
    var key = fallbackKey || "people.something_went_wrong";
    if (err && err.timedOut) key = "app.error_timeout";
    else if (status >= 500) key = "app.error_server";
    else if (!status && GHD.isNetworkError(err)) key = "app.error_network";
    return typeof t === "function" ? t(key) : "";
  };

  // A request that got no answer at all: the browser's "Failed to fetch" /
  // "Load failed", supabase-js's AuthRetryableFetchError, or a device that says
  // it is offline.
  GHD.isNetworkError = function (err) {
    if (err && err.status) return false;
    if (typeof navigator !== "undefined" && navigator.onLine === false) return true;
    if (err && err.name === "AuthRetryableFetchError") return true;
    return /fetch|load failed|network/i.test((err && err.message) || "");
  };

  // The part of `err` that is safe to show, or "" when there is none. Split out
  // of reportError so callers that surface errors somewhere other than a toast
  // (inline under a form field, in a transcript) can apply the same rule.
  GHD.userFacingError = function (err) {
    var status = err && err.status;
    if (typeof status !== "number" || status < 400 || status >= 500) return "";
    var message = err.message;
    // A 422 hands back FastAPI's array of validation dicts, which stringifies to
    // "[object Object]"; and a detail-less 4xx falls back to "API error <n>".
    if (typeof message !== "string" || !message.trim()) return "";
    if (/^API error \d+$/.test(message) || message.indexOf("[object ") === 0) return "";
    return message;
  };
})();

;
/* dashboard/js/ui-list.js */
/* What every filterable list in the app shares. */
(function () {
  window.GHD = window.GHD || {};

  // ── Search helpers (shared by every filterable list) ───────────────────────

  // Lists shorter than this don't get a search box — People, Chats and Groups
  // all use the same threshold so the pages feel like one app.
  GHD.LIST_SEARCH_MIN = 8;

  // Lowercase + strip diacritics, so "Rene" finds "René" and "Ελενη" finds
  // "Ελένη". One fold for every list search (People roster, Chats, Groups).
  // Greek's final sigma folds to σ: toLowerCase() writes ς at a word's end, so
  // "ΚΩΣΤΑΣ" and a "κωστασ" typed with the other key would otherwise differ.
  // Vietnamese đ is a letter of its own, not d with a mark, so NFD keeps it;
  // "Dung" must still find "Đũng". ß and Turkish dotless ı fold to ss and i,
  // as the server's message search (search_fold, migration 189) does.
  GHD.normalizeForSearch = function (value) {
    var text = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/ς/g, "σ")
      .replace(/đ/g, "d")
      .replace(/ß/g, "ss")
      .replace(/ı/g, "i");
    // NFC after the fold puts Hangul back together: a syllable is one letter to
    // the one-typo search, or 민서 would find 민수.
    return text.normalize
      ? text
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .normalize("NFC")
      : text;
  };

  // ── Empty state ────────────────────────────────────────────────────────────

  // Markup for the shared "nothing here yet" block (.empty-state in ui.css):
  // a centred column with an optional icon, a title, optional sub-copy and an
  // optional CTA. `title`/`sub` are escaped; `iconHtml`/`actionHtml` are trusted
  // (callers pass their own inline SVG / button markup).
  // opts: { title, sub?, iconHtml?, actionHtml?, className? }
  GHD.emptyStateHtml = function (opts) {
    opts = opts || {};
    return (
      '<div class="empty-state' +
      (opts.className ? " " + opts.className : "") +
      '">' +
      (opts.iconHtml ? '<div class="empty-state-icon" aria-hidden="true">' + opts.iconHtml + "</div>" : "") +
      '<p class="empty-state-title">' +
      GHD.escapeHtml(opts.title || "") +
      "</p>" +
      (opts.sub ? '<p class="empty-state-sub">' + GHD.escapeHtml(opts.sub) + "</p>" : "") +
      (opts.actionHtml ? '<div class="empty-state-action">' + opts.actionHtml + "</div>" : "") +
      "</div>"
    );
  };
})();

;
/* dashboard/js/ui-menu.js */
/* Popovers and context menus: how they open, and how they go away.
   Extends the `window.GHD` namespace. The app only. */
(function () {
  window.GHD = window.GHD || {};

  /* Wire the "click somewhere else and this goes away" behaviour every popover
     and context menu in the app needs, and hand back the teardown for it.

     The listeners live on `document`/`window`, so removing the popover node does
     NOT stop them: every close path must call the returned (idempotent) teardown.

     opts: triggerEl (Element or selector; its clicks are ignored so it can toggle),
     onDismiss (called after teardown; remove the node there), esc (default true),
     scroll (dismiss on scroll, default false; for viewport-pinned menus), capture
     (default false; wins over handlers that stop propagation).
     Listening starts on the next tick, or the opening click would close it. */
  GHD.dismissOn = function (el, opts) {
    opts = opts || {};
    var onDismiss = opts.onDismiss || null;
    var triggerEl = opts.triggerEl || null;
    var wantEsc = opts.esc !== false;
    var wantScroll = !!opts.scroll;
    var capture = !!opts.capture;
    // The armed handlers, so teardown can detach exactly what was attached.
    // Null until the arming tick below, and null again once torn down.
    var handlers = null;
    var torn = false;

    function isTrigger(target) {
      if (!triggerEl || !target) return false;
      if (typeof triggerEl === "string") {
        return !!(target.matches?.(triggerEl) || target.closest?.(triggerEl));
      }
      return triggerEl === target || !!triggerEl.contains?.(target);
    }

    function teardown() {
      if (torn) return;
      torn = true;
      if (!handlers) return;
      document.removeEventListener("click", handlers.outside, capture);
      document.removeEventListener("touchstart", handlers.outside, capture);
      if (wantEsc) document.removeEventListener("keydown", handlers.key, true);
      if (wantScroll) window.removeEventListener("scroll", handlers.scroll, true);
      handlers = null;
    }

    // Dismissal always tears down first, so a caller whose onDismiss forgets to
    // (they all used to) still ends up with the listeners gone.
    function dismiss() {
      teardown();
      if (onDismiss) onDismiss();
    }

    function onOutside(e) {
      if (el.contains(e.target) || isTrigger(e.target)) return;
      dismiss();
    }
    function onKey(e) {
      if (e.key === "Escape") dismiss();
    }
    function onScroll() {
      dismiss();
    }

    setTimeout(function () {
      // Torn down (or already gone) before we ever armed — nothing to listen for.
      if (torn || !el.isConnected) {
        torn = true;
        return;
      }
      handlers = { outside: onOutside, key: onKey, scroll: onScroll };
      document.addEventListener("click", onOutside, capture);
      document.addEventListener("touchstart", onOutside, capture);
      if (wantEsc) document.addEventListener("keydown", onKey, true);
      if (wantScroll) window.addEventListener("scroll", onScroll, true);
    }, 0);

    return teardown;
  };

  // ── Long-press → context menu ──────────────────────────────────────────────

  /* Fire `onFire(x, y)` on a long press of `el`, and on a desktop
     right-click. Callers suppress the row's own click themselves. Timer state is
     per element so two rows arm independently. */
  GHD.attachLongPress = function (el, onFire) {
    var LONG_PRESS_MS = 500;
    var MOVE_TOLERANCE = 100; // squared px (~10px)
    var timer = null;
    var start = null;

    function cancel() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    el.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) return;
      var touch = e.touches[0];
      start = { x: touch.clientX, y: touch.clientY };
      timer = setTimeout(function () {
        timer = null;
        try {
          navigator.vibrate?.(15);
        } catch {
          /* not everywhere, never fatal */
        }
        onFire(start.x, start.y);
      }, LONG_PRESS_MS);
    });

    el.addEventListener("touchmove", function (e) {
      if (!timer || !start) return;
      var touch = e.touches[0];
      var dx = touch.clientX - start.x;
      var dy = touch.clientY - start.y;
      if (dx * dx + dy * dy > MOVE_TOLERANCE) cancel();
    });

    el.addEventListener("touchend", cancel);
    el.addEventListener("touchcancel", cancel);

    // Desktop right-click opens the same menu.
    el.addEventListener("contextmenu", function (e) {
      e.preventDefault();
      onFire(e.clientX, e.clientY);
    });
  };

  // The one live context menu, so opening a second closes the first and every
  // caller has a single close path. Same contract as the share popover above.
  var _contextMenuDismiss = null;
  // The button that opened it, when a button did (see `trigger` below).
  var _contextMenuTrigger = null;

  /* A menu at viewport (x, y). With `trigger` it is a keyboard menu that hands
     focus back to the trigger on close. */
  GHD.contextMenu = function (opts) {
    GHD.closeContextMenu();

    var pop = document.createElement("div");
    pop.id = "ghdContextMenu";
    pop.className = "more-popover ghd-context-menu";
    pop.setAttribute("role", "menu");
    pop.innerHTML = opts.items
      .map(function (it) {
        return (
          '<button type="button" role="menuitem" class="more-popover-item' +
          (it.danger ? " more-popover-item-danger" : "") +
          '" data-action="' +
          it.action +
          '">' +
          it.icon +
          "<span>" +
          GHD.escapeHtml(it.label) +
          "</span></button>"
        );
      })
      .join("");
    if (opts.note)
      pop.insertAdjacentHTML("beforeend", '<p class="more-popover-note">' + GHD.escapeHtml(opts.note) + "</p>");
    document.body.appendChild(pop);

    var margin = 8;
    var rect = pop.getBoundingClientRect();
    var left = opts.x - rect.width / 2;
    var top = opts.y + 12;
    if (left + rect.width > window.innerWidth - margin) left = window.innerWidth - rect.width - margin;
    if (left < margin) left = margin;
    if (top + rect.height > window.innerHeight - margin) top = opts.y - rect.height - 12;
    if (top < margin) top = margin;
    pop.style.left = left + "px";
    pop.style.top = top + "px";

    pop.addEventListener("click", function (e) {
      var btn = e.target.closest(".more-popover-item");
      if (!btn) return;
      var action = btn.dataset.action;
      GHD.closeContextMenu();
      if (opts.onPick) opts.onPick(action);
    });

    _contextMenuDismiss = GHD.dismissOn(pop, {
      // The button that opened the menu toggles it itself; dismissing on its
      // press first would make that press reopen the menu.
      triggerEl: opts.trigger || null,
      onDismiss: function () {
        GHD.closeContextMenu();
      },
      scroll: true,
      capture: true,
    });

    if (opts.trigger) {
      _contextMenuTrigger = opts.trigger;
      opts.trigger.setAttribute("aria-expanded", "true");
      pop.addEventListener("keydown", function (e) {
        var items = Array.prototype.slice.call(pop.querySelectorAll(".more-popover-item"));
        var at = items.indexOf(document.activeElement);
        var next = null;
        if (e.key === "ArrowDown") next = items[(at + 1) % items.length];
        else if (e.key === "ArrowUp") next = items[(at - 1 + items.length) % items.length];
        else if (e.key === "Home") next = items[0];
        else if (e.key === "End") next = items[items.length - 1];
        else if (e.key === "Tab") GHD.closeContextMenu();
        if (next) {
          e.preventDefault();
          next.focus();
        }
      });
      pop.querySelector(".more-popover-item")?.focus();
    }
    return pop;
  };

  /** The one way the context menu disappears — its dismisser lives on
   *  `document`/`window`, so item clicks, re-renders and route changes all have
   *  to come through here. Idempotent. */
  GHD.closeContextMenu = function () {
    var pop = document.getElementById("ghdContextMenu");
    var trigger = _contextMenuTrigger;
    _contextMenuTrigger = null;
    // Focus goes back to the trigger only when it was inside the menu: a click
    // elsewhere has already put it where the reader wanted it.
    var hadFocus = !!(pop && pop.contains(document.activeElement));
    pop?.remove();
    if (_contextMenuDismiss) {
      _contextMenuDismiss();
      _contextMenuDismiss = null;
    }
    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
      if (hadFocus && trigger.isConnected) trigger.focus();
    }
  };
})();

;
/* dashboard/js/ui-dialog.js */
/**
 * The app's one modal: confirmations, single-input prompts, and the surfaces
 * that bring their own insides (the feedback composer, the install QR).
 * Escape, overlay click and Cancel dismiss it; focus moves in on open and back
 * to the trigger on close; only one is ever on screen.
 */
(function () {
  window.GHD = window.GHD || {};

  // The app's one modal: confirmations, single-input rename/create prompts and
  // free-form bodies all render through here (skin: .ghd-dialog-* in ui.css).
  // Escape, a click on the overlay and Cancel all dismiss; focus moves into the
  // dialog on open and returns to the trigger on close.
  //
  // opts:
  //   title         optional heading (escaped)
  //   message       body paragraph (escaped)
  //   messageHtml   body paragraph as trusted HTML — wins over `message`
  //   subMessage    secondary line under the body (escaped) — or an array of
  //                 them, one paragraph each, for a confirmation that has to
  //                 say what is lost *and* what is kept without running the two
  //                 together into one grey blob
  //   field         { label?, value?, placeholder?, maxLength?, requiredMessage? }
  //                 → one text input, focused on open (and selected when it
  //                   starts with a value); Enter confirms. An empty value never
  //                   confirms: it re-focuses the input and shows
  //                   `requiredMessage` inline when one is given.
  //   confirmLabel / cancelLabel / busyLabel
  //   destructive   confirm button is .btn-danger instead of .btn-primary
  //   onConfirm     optional async (value) => void; the confirm button shows
  //                 `busyLabel` while it runs. Throw to keep the dialog open and
  //                 surface err.message inline.
  //
  // A surface whose insides are its own — the feedback composer, the install QR
  // — passes `bodyHtml` instead of the fields above and gets only what makes a
  // modal a modal: the overlay, Escape, the backdrop click, focus in and focus
  // back, and one-at-a-time. Those take:
  //   bodyHtml      the overlay's entire contents, as trusted HTML — the card
  //                 element included, so the body owns its own skin. Wins over
  //                 title/message/field/buttons, none of which are then drawn.
  //   onMount       (overlay, close) => teardown? — wire the body's own
  //                 controls. `close(value)` resolves the promise with `value`.
  //   canDismiss    () => boolean; false refuses Escape and the backdrop (a
  //                 send in flight). Never refuses `close()` or closeDialog().
  //   initialFocus  selector inside the overlay to focus on open.
  //   id            the overlay's element id (default "ghdDialog").
  //   overlayClass  extra classes on the overlay.
  //   dialogClass   extra classes on the built-in card (no `bodyHtml`).
  //   labelledBy / describedBy   ids for the overlay's aria attributes.
  //
  // Resolves false when dismissed, otherwise the field's trimmed value (or true
  // when there is no field).
  var _closeActiveDialog = null;

  // Force-close whatever dialog is open (page teardown). Its promise resolves false.
  GHD.closeDialog = function () {
    if (_closeActiveDialog) _closeActiveDialog();
  };

  // ── Open / close motion ────────────────────────────────────────────────────
  // The skin is ui.css (.ghd-dialog-overlay.is-open / .is-closing): the scrim
  // fades and the card scales, and the class the overlay is wearing also picks
  // which clock it does that on. What is here is the timing the DOM needs — a
  // reflow between "on the page" and "open" so there is a closed state to
  // animate out of, and a wait after "closing" so the card is gone before the
  // overlay is.
  //
  // Only one dialog is ever open, so at most one can be on its way out.
  var _fading = null;
  var _fadingTimer = null;

  // The close duration, read off the closing overlay so the number lives in the
  // stylesheet with the transition it belongs to. The fallback covers the test
  // sandboxes, whose getComputedStyle answers with a bare object.
  function _closeMs(overlay) {
    var ms = NaN;
    if (typeof getComputedStyle === "function") {
      var style = getComputedStyle(overlay);
      if (style && typeof style.getPropertyValue === "function") ms = parseFloat(style.getPropertyValue("--modal-dur"));
    }
    return Number.isFinite(ms) ? ms : 150;
  }

  // Whether this environment can run the close at all. Same reason _setPageInert
  // guards per call: a test sandbox's element and its globals reach only as far
  // as the case under test needs, and with no class list to swap there is no
  // animation to wait out — the overlay goes at once instead.
  function _canAnimate(overlay) {
    var list = overlay.classList;
    return (
      typeof setTimeout === "function" &&
      typeof clearTimeout === "function" &&
      !!list &&
      typeof list.add === "function" &&
      typeof list.remove === "function"
    );
  }

  function _dropFading() {
    if (_fadingTimer) clearTimeout(_fadingTimer);
    _fadingTimer = null;
    if (_fading) _fading.remove();
    _fading = null;
  }

  /* Animate the overlay out, then take it off the page. */
  function _fadeOut(overlay) {
    _dropFading();
    if (typeof overlay.setAttribute === "function") overlay.setAttribute("inert", "");
    if (!_canAnimate(overlay)) {
      overlay.remove();
      return;
    }
    overlay.classList.remove("is-open");
    overlay.classList.add("is-closing");
    _fading = overlay;
    _fadingTimer = setTimeout(_dropFading, _closeMs(overlay));
  }

  /* Put the overlay on the page and open it a reflow later. Anything still
     fading goes now, or two scrims stack. The layout read (not rAF, which
     never fires in a background tab) is what makes the open animate. */
  function _fadeIn(overlay) {
    _dropFading();
    document.body.appendChild(overlay);
    void overlay.offsetWidth;
    if (_canAnimate(overlay)) overlay.classList.add("is-open");
  }

  /* Take the page behind the dialog out of the tab order and the accessibility
     tree while one is open, and put it back on close. Cleared before focus
     returns to the trigger: an element under `inert` cannot take focus. */
  function _setPageInert(inert) {
    // Guarded per call: the test sandboxes hand this module a document with
    // only the methods the case under test needs.
    var targets = [];
    var main = typeof document.getElementById === "function" ? document.getElementById("main") : null;
    if (main) targets.push(main);
    if (typeof document.querySelectorAll === "function") {
      document.querySelectorAll(".site-header, .site-footer").forEach(function (el) {
        targets.push(el);
      });
    }
    targets.forEach(function (el) {
      if (typeof el.setAttribute !== "function") return;
      if (inert) el.setAttribute("inert", "");
      else el.removeAttribute("inert");
    });
  }

  /* The `bodyHtml` half of GHD.dialog: the overlay and everything a modal owes
     its reader, with nothing to say about what is inside it. */
  function _mountCustomBody(overlay, opts, prevFocus, resolve) {
    _fadeIn(overlay);
    _setPageInert(true);

    var settled = false;
    var keyAC = new AbortController();
    var teardown = null;

    function close(result) {
      if (settled) return;
      settled = true;
      _closeActiveDialog = null;
      keyAC.abort();
      if (typeof teardown === "function") teardown();
      _fadeOut(overlay);
      _setPageInert(false);
      if (prevFocus && typeof prevFocus.focus === "function") prevFocus.focus();
      resolve(result === undefined ? false : result);
    }
    // Escape and the backdrop wait for whatever the body says is in flight;
    // close() and page teardown do not.
    function dismiss() {
      if (!opts.canDismiss || opts.canDismiss()) close(false);
    }
    _closeActiveDialog = function () {
      close(false);
    };

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) dismiss();
    });
    document.addEventListener(
      "keydown",
      function (e) {
        if (e.key !== "Escape" || e.defaultPrevented) return;
        e.preventDefault();
        dismiss();
      },
      { capture: true, signal: keyAC.signal },
    );

    if (opts.onMount) teardown = opts.onMount(overlay, close);

    var focusTarget = opts.initialFocus ? overlay.querySelector(opts.initialFocus) : null;
    if (focusTarget && typeof focusTarget.focus === "function") focusTarget.focus();
  }

  GHD.dialog = function (opts) {
    opts = opts || {};
    var field = opts.field || null;
    var esc = GHD.escapeHtml;

    return new Promise(function (resolve) {
      // Only ever one dialog on screen; a second call replaces the first.
      GHD.closeDialog();

      var prevFocus = document.activeElement;
      var overlay = document.createElement("div");
      overlay.id = opts.id || "ghdDialog";
      overlay.className = "ghd-dialog-overlay" + (opts.overlayClass ? " " + opts.overlayClass : "");
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      if (opts.title) overlay.setAttribute("aria-labelledby", "ghdDialogTitle");
      if (opts.labelledBy) overlay.setAttribute("aria-labelledby", opts.labelledBy);
      if (opts.describedBy) overlay.setAttribute("aria-describedby", opts.describedBy);

      if (opts.bodyHtml != null) {
        overlay.innerHTML = opts.bodyHtml;
        _mountCustomBody(overlay, opts, prevFocus, resolve);
        return;
      }

      var cardClass = "ghd-dialog" + (opts.dialogClass ? " " + opts.dialogClass : "");

      var body = opts.messageHtml || (opts.message ? esc(opts.message) : "");
      var subs = (Array.isArray(opts.subMessage) ? opts.subMessage : [opts.subMessage]).filter(Boolean);
      overlay.innerHTML =
        '<div class="' +
        cardClass +
        '">' +
        (opts.title ? '<h3 class="ghd-dialog-title" id="ghdDialogTitle">' + esc(opts.title) + "</h3>" : "") +
        (body ? '<p class="ghd-dialog-msg">' + body + "</p>" : "") +
        subs
          .map(function (line) {
            return '<p class="ghd-dialog-sub">' + esc(line) + "</p>";
          })
          .join("") +
        (field
          ? '<div class="field-group">' +
            (field.label ? '<label for="ghdDialogInput">' + esc(field.label) + "</label>" : "") +
            '<input type="text" id="ghdDialogInput" autocomplete="off" value="' +
            esc(field.value || "") +
            '"' +
            (field.placeholder ? ' placeholder="' + esc(field.placeholder) + '"' : "") +
            (field.maxLength ? ' maxlength="' + field.maxLength + '"' : "") +
            " />" +
            "</div>"
          : "") +
        '<p class="error ghd-dialog-error" id="ghdDialogError" hidden></p>' +
        '<div class="ghd-dialog-actions">' +
        '<button type="button" class="btn-outline btn-small" id="ghdDialogCancel">' +
        esc(opts.cancelLabel || "Cancel") +
        "</button>" +
        '<button type="button" class="' +
        (opts.destructive ? "btn-danger" : "btn-primary") +
        ' btn-small" id="ghdDialogConfirm">' +
        esc(opts.confirmLabel || "Confirm") +
        "</button>" +
        "</div>" +
        "</div>";
      _fadeIn(overlay);
      _setPageInert(true);

      var input = field ? overlay.querySelector("#ghdDialogInput") : null;
      var confirmBtn = overlay.querySelector("#ghdDialogConfirm");
      var errEl = overlay.querySelector("#ghdDialogError");
      var confirmLabel = confirmBtn.textContent;

      var settled = false;
      var busy = false;
      var keyAC = new AbortController();

      // A dialog can only close while it is the active one — opening another
      // force-closes this one first — so the handle is always ours to clear.
      function close(result) {
        if (settled) return;
        settled = true;
        _closeActiveDialog = null;
        keyAC.abort();
        _fadeOut(overlay);
        _setPageInert(false);
        if (prevFocus && typeof prevFocus.focus === "function") prevFocus.focus();
        resolve(result);
      }
      // Escape / overlay click / Cancel wait for an in-flight confirm; teardown
      // (GHD.closeDialog) does not.
      function dismiss() {
        if (!busy) close(false);
      }
      _closeActiveDialog = function () {
        close(false);
      };

      function showError(message) {
        errEl.textContent = message || "";
        errEl.hidden = !message;
      }

      async function confirm() {
        if (busy || settled) return;
        var value = input ? input.value.trim() : "";
        if (input && !value) {
          showError(field.requiredMessage || "");
          input.focus();
          return;
        }
        if (!opts.onConfirm) {
          close(input ? value : true);
          return;
        }
        busy = true;
        confirmBtn.disabled = true;
        if (opts.busyLabel) confirmBtn.textContent = opts.busyLabel;
        showError("");
        try {
          await opts.onConfirm(value);
          busy = false;
          close(input ? value : true);
        } catch (err) {
          busy = false;
          confirmBtn.disabled = false;
          confirmBtn.textContent = confirmLabel;
          showError(GHD.errorText(err));
        }
      }

      confirmBtn.addEventListener("click", confirm);
      overlay.querySelector("#ghdDialogCancel").addEventListener("click", dismiss);
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) dismiss();
      });
      if (input) {
        input.addEventListener("keydown", function (e) {
          if (e.key !== "Enter") return;
          // On a desktop IME this Enter is picking a candidate, not confirming
          // the dialog — a rename would be saved half-typed (js/platform.js).
          if (GHD.isComposingKey(e)) return;
          e.preventDefault();
          confirm();
        });
      }
      document.addEventListener(
        "keydown",
        function (e) {
          if (e.key !== "Escape") return;
          e.preventDefault();
          dismiss();
        },
        { capture: true, signal: keyAC.signal },
      );

      if (input) {
        input.focus();
        if (input.value) input.select();
      } else {
        confirmBtn.focus();
      }
    });
  };

  // In-app confirmation modal. Replaces native confirm(). Returns a Promise that
  // resolves to true (confirmed) or false (cancelled / dismissed). Thin wrapper
  // over GHD.dialog — kept as its own name because callers across the app use it.
  // opts: { message, confirmLabel?, cancelLabel?, destructive? (default true) }
  GHD.confirmDialog = function (opts) {
    opts = opts || {};
    return GHD.dialog({
      message: opts.message || "Are you sure?",
      confirmLabel: opts.confirmLabel || "Confirm",
      cancelLabel: opts.cancelLabel || "Cancel",
      destructive: opts.destructive !== false,
    }).then(function (result) {
      return result === true;
    });
  };
})();

;
/* dashboard/js/conversations.js */
/* The chat's two pieces of state that outlive the page it was on: the
   conversation list the sidebar and /chats page share, and the pending chart,
   a sessionStorage handoff from an unsaved person's card to the person page.
   Extends `window.GHD`; reads GHD.storage / GHD.KEYS. The app only. */
(function () {
  window.GHD = window.GHD || {};

  // Conversation list helpers — shared between Chat (the live conversation
  // sidebar) and Chats (the full-list page).
  GHD.conversations = {
    // Title used for brand-new conversations that haven't had any messages yet.
    DEFAULT_TITLE: "New conversation",
    // An empty "New conversation" row that's never been touched.
    isPlaceholder: function (conv) {
      return !!conv && conv.title === GHD.conversations.DEFAULT_TITLE && conv.created_at === conv.updated_at;
    },
    // Sort by updated_at (or created_at) descending, in place. Returns the array.
    sortByRecent: function (conversations) {
      conversations.sort(function (a, b) {
        var aStamp = (a && (a.updated_at || a.created_at)) || null;
        var bStamp = (b && (b.updated_at || b.created_at)) || null;
        var aTime = aStamp ? Date.parse(aStamp) : 0;
        var bTime = bStamp ? Date.parse(bStamp) : 0;
        return bTime - aTime;
      });
      return conversations;
    },
    // Insert/merge a summary into the list and re-sort. Returns the merged row or null.
    applySummary: function (conversations, summary) {
      var index = conversations.findIndex(function (c) {
        return c.id === summary.id;
      });
      if (index === -1) {
        conversations.push(summary);
      } else {
        conversations[index] = Object.assign({}, conversations[index], summary);
      }
      GHD.conversations.sortByRecent(conversations);
      return (
        conversations.find(function (c) {
          return c.id === summary.id;
        }) || null
      );
    },
  };

  // Read a pending temp-chart payload from sessionStorage (set when opening an
  // unsaved chart card before navigating). Returns { raw, data } or null.
  GHD.readTempChartPayload = function () {
    var raw = GHD.storage.session.get(GHD.KEYS.tempChart);
    if (!raw) return null;
    try {
      return { raw: raw, data: JSON.parse(raw) };
    } catch (_e) {
      GHD.storage.session.remove(GHD.KEYS.tempChart);
      return null;
    }
  };
})();

;
/* dashboard/js/api.js */
/*
 * API layer: raw fetch to Supabase REST for selected reads, the backend API for
 * writes, auth-sensitive user data and Stripe/account operations.
 *
 * Supabase queries use raw fetch() with App._session's access_token, bypassing
 * the Supabase JS SDK, whose async init blocks on token refresh and blanks the
 * screen on first load.
 */
// Mirrors backend/ratelimit.py PLAN_LIMITS (chart calculations per 30 days).
const PLAN_LIMITS = { free: 15, pro: 2000 };

// One refresh at a time, shared by the pre-expiry check and the 401 retry:
// refresh tokens rotate, and two refreshes spending the same one can revoke the
// whole session.
//
// Without the SDK on the page the refresh is a raw POST to GoTrue, written to
// the SDK's own storage key in the SDK's own shape, so an SDK that loads later
// (and every other tab) reads the same session. It runs under the SDK's lock
// name, so a tab whose SDK is refreshing at that moment is waited for, and the
// stored session is re-read first in case that tab already rotated it. Only
// when the raw refresh fails does the SDK get downloaded for its own try;
// with the SDK already here, it alone refreshes, as before.
function _sdkRefresh() {
  return App.ensureSupabase()
    .then((sb) => sb.auth.refreshSession())
    .then(({ data, error }) => (error || !data?.session ? null : data.session));
}

// Seconds of validity below which a token is refreshed before it is sent.
const _REFRESH_MARGIN_S = 60;

function _expiresSoon(session) {
  return !!session?.expires_at && session.expires_at < Date.now() / 1000 + _REFRESH_MARGIN_S;
}

function _rawRefresh() {
  const key = window.GHD_APP?.sessionKey();
  const mine = App._session;
  if (!key || !mine?.refresh_token) return Promise.resolve(null);
  // A failure of any kind (storage blocked, network, a bad body) is null: the
  // SDK fallback gets its turn.
  const run = async () => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || "null");
      if (!stored?.refresh_token || stored.user?.id !== mine.user?.id) return null;
      // Another tab already rotated the token this one holds: adopt its session.
      if (stored.refresh_token !== mine.refresh_token && !_expiresSoon(stored)) return (App._session = stored);
      const resp = await fetch(`${CONFIG.SUPABASE_URL}/auth/v1/token?grant_type=refresh_token`, {
        method: "POST",
        headers: { apikey: CONFIG.SUPABASE_ANON_KEY, "Content-Type": "application/json" },
        body: JSON.stringify({ refresh_token: stored.refresh_token }),
        signal: AbortSignal.timeout?.(10000),
      });
      if (!resp.ok) return null;
      const session = await resp.json();
      if (!session?.access_token || !session.refresh_token || session.user?.id !== mine.user?.id) return null;
      session.expires_at ||= Math.round(Date.now() / 1000) + session.expires_in;
      localStorage.setItem(key, JSON.stringify(session));
      return (App._session = session);
    } catch {
      return null;
    }
  };
  return navigator.locks ? navigator.locks.request(`lock:${key}`, run) : run();
}

let _refreshInFlight = null;
function _tryRefreshSession() {
  if (!_refreshInFlight) {
    _refreshInFlight = (App.supabase ? Promise.resolve(null) : _rawRefresh().catch(() => null))
      .then((s) => s || _sdkRefresh())
      .catch(() => null)
      .finally(() => {
        _refreshInFlight = null;
      });
  }
  return _refreshInFlight;
}

// Attribution the marketing origin stashes before signup, each {v, t} JSON kept
// for Google's 90-day click window and read once, at onboarding: the Google Ads
// click id (head-init.js), the share token a visitor arrived through (the share
// pages), the first page and the latest external arrival (arrival-touch.js), and
// the page whose signup form was used (landing.js). The try covers the unit-test
// VMs, which run api.js with neither localStorage nor GHD.KEYS defined.
const _ATTRIBUTION_TTL_MS = 90 * 24 * 3600 * 1000;
const _ATTRIBUTION_KEYS = ["gclid", "shareToken", "entryPage", "lastTouch", "signupPage"];

function _storedAttribution(name) {
  try {
    const a = JSON.parse(localStorage.getItem(GHD.KEYS[name]));
    return a && a.v && Date.now() - a.t < _ATTRIBUTION_TTL_MS ? a : {};
  } catch {
    return {};
  }
}

// The surface an onboarding call should claim, or "" for the caller's own.
//
// Read from storage rather than passed in, for the same reason the gclid above
// is: all three signup paths (the auto-complete, the onboarding form, a resumed
// signup) would otherwise each have to remember to forward it, and the one that
// forgot would look exactly like a signup that never came from MCP.
//
// NOT cleared by _clearStoredAttribution below — the flag also decides where the
// finished signup lands (App.afterSignupRoute), which happens after this call.
function _mcpSignupSurface() {
  try {
    return GHD.mcpSignup && GHD.mcpSignup.read() ? "mcp_website" : "";
  } catch {
    return "";
  }
}

// All single-use: once the backend has them on the profile, leaving them
// behind would re-attribute the *next* account created on this device to the
// same ad click, sharer or page.
function _clearStoredAttribution() {
  try {
    for (const name of _ATTRIBUTION_KEYS) localStorage.removeItem(GHD.KEYS[name]);
  } catch {
    /* private mode, or a VM without localStorage */
  }
}

// ── How long a request may take ─────────────────────────────────────────────
//
// `fetch` has no deadline of its own. A request the network swallows never
// settles, and neither does whatever the page was awaiting behind it: that is
// how one hung read left a Settings visit on its loading screen until the reader
// reloaded, and it was never Settings-specific — any page that awaits a request
// can be held the same way.
//
// 30 seconds, read off what the slow endpoints actually cost rather than picked.
// The dearest non-streaming work we have measured is a person save or an
// onboarding behind a cold geocode, and a birth-day sweep at roughly 9 s on
// production CPU. The geocode is the one leg that deliberately waits, and the
// backend bounds it at `_RESOLVE_MAX_WAIT_S` = 15 s (backend/engine/location.py);
// the Supabase read in front of it and the write behind it answer in well under
// a second, or nothing else in the app is working either. 30 s clears that with
// room for a slow phone on a slow network, and sits far inside the container's
// own 300 s ceiling (docs/internal/networking.md).
//
// Those two numbers are held together by test_geocode_client_deadline.py, which
// reads the one on this line. They have drifted apart once already: the backend
// bound went from 10 s to 15 s on 2026-08-31 and this comment kept saying 10, so
// the next person sizing a deadline would have derived it from a number that was
// no longer true. A deadline under the work is not a harmless mismatch — it
// turns a slow SUCCESS into an abort. The browser cancels while the server goes
// on to create the account, and the form then tells the reader the server did
// not answer, which is the one thing that did not happen.
//
// A budget under a legitimately slow endpoint would be a worse bug than no
// budget at all, so a caller that knows better passes its own `timeoutMs`; `0`
// means no deadline, which is what the SSE streams take (see streamFetch).
const _REQUEST_TIMEOUT_MS = 30000;

// The composed signal for one request, or null when the caller asked for none.
// Aborting *either* the caller's own signal or the timer aborts the fetch, and
// `expired` says which of the two it was — a reader pressing stop and a network
// going quiet must not arrive as the same event.
//
// AbortSignal.any() would be the composition in one line, and it is the young
// one: Safari only shipped it in 17.4, and the app also runs inside whatever
// WebView an Android device happens to carry. (app.js does call
// AbortSignal.timeout() for its /health probe — that half is older, and a probe
// that throws degrades to "status unknown" where a request that throws is a page
// that never loads.) AbortController is from 2018 and is everywhere.
function _deadline(ms, callerSignal) {
  if (!ms) return null;
  const controller = new AbortController();
  let expire = null;
  // Resolves rather than rejects: the one place that waits on it does so in a
  // Promise.race, and a rejection the race did not take would be an unhandled one.
  const expiry = new Promise((resolve) => {
    expire = resolve;
  });
  const state = { signal: controller.signal, expiry, expired: false, clear: null };
  const timer = setTimeout(() => {
    state.expired = true;
    controller.abort();
    expire();
  }, ms);
  const relay = () => controller.abort();
  if (callerSignal) {
    if (callerSignal.aborted) controller.abort();
    else callerSignal.addEventListener("abort", relay);
  }
  // Called on every exit, so a finished request leaves no timer and no listener
  // on a controller its caller may hold for the rest of the page's life.
  state.clear = () => {
    clearTimeout(timer);
    if (callerSignal) callerSignal.removeEventListener("abort", relay);
  };
  return state;
}

// What a caller catches when the deadline ran out.
//
// Deliberately not an AbortError: chat-stream-client reads that name as "the
// reader pressed stop", and a deadline nobody chose must not be mistaken for a
// choice. `TimeoutError` is the name AbortSignal.timeout() gives its own, so a
// caller branching on the name is right either way, and `err.status` stays
// unset — there was no answer to take a status from. That is also what keeps a
// slow network from reading as an expired session and bouncing someone to /login.
function _timeoutError(ms) {
  const error = new Error(`The server did not answer within ${Math.round(ms / 1000)} seconds`);
  error.name = "TimeoutError";
  error.timedOut = true;
  return error;
}

const Api = {
  // ── The one authenticated fetch ─────────────────────────────────────────
  //
  // Every request the app makes goes through here, so bearer injection, the
  // refresh-once-on-401 retry and the thrown error's shape are defined once.
  // What genuinely differs per surface — base URL and default headers — stays
  // with the thin wrappers below (_supabaseRest / _fetch / streamFetch).
  //
  //   surface    which default headers to send (see _defaultHeaders)
  //   raw        hand the Response back untouched, for callers that read the body
  //              as a stream (the SSE chat turns) instead of as JSON
  //   timeoutMs  the deadline for the whole call — both attempts and the body
  //              read — or 0 for none (see _REQUEST_TIMEOUT_MS)
  //
  // Authorization is applied last, so it can never be clobbered by a caller's
  // header bag.
  async _request(
    url,
    options = {},
    { surface = "backend", redirectOnAuthFailure = true, raw = false, timeoutMs = _REQUEST_TIMEOUT_MS } = {},
  ) {
    const token = App._session?.access_token;
    if (!token) {
      if (redirectOnAuthFailure) App.navigate("/login");
      throw new Error("Not authenticated");
    }

    // One deadline for the logical request, not one per attempt: a refresh and a
    // retry behind a 401 must not buy a hung request a second full budget.
    const deadline = _deadline(timeoutMs, options.signal);

    const doFetch = async (bearer) => {
      try {
        const resp = await fetch(url, {
          ...options,
          // Last, so it wins over the caller's — the caller's own signal is not
          // dropped, it is folded into this one by _deadline.
          ...(deadline ? { signal: deadline.signal } : {}),
          headers: {
            ...this._defaultHeaders(surface),
            ...(options.headers || {}),
            Authorization: `Bearer ${bearer}`,
          },
        });
        if (surface !== "supabase") this._noteApiAnswer(true);
        return resp;
      } catch (error) {
        if (surface !== "supabase") this._noteApiAnswer(false);
        throw error;
      }
    };

    // Take the token off the session _tryRefreshSession returns, not off
    // App._session — the auth listener that writes it back may not have run yet.
    //
    // Raced against the deadline by hand: the refresh is outside the fetch the
    // signal reaches, so a stalled one would otherwise hang the very request the
    // deadline is here to bound.
    const refresh = async () => {
      const refreshed = deadline
        ? await Promise.race([_tryRefreshSession(), deadline.expiry])
        : await _tryRefreshSession();
      if (deadline?.expired) throw _timeoutError(timeoutMs);
      return refreshed?.access_token;
    };

    try {
      // A token about to lapse is refreshed before it is sent: after an hour
      // away, every request of the page would otherwise 401 and wait on a retry.
      let resp = await doFetch((_expiresSoon(App._session) && (await refresh())) || token);
      if (resp.status === 401) {
        const bearer = await refresh();
        if (bearer) resp = await doFetch(bearer);
      }

      if (resp.status === 401) {
        if (redirectOnAuthFailure) App.navigate("/login");
        throw new Error("Session expired");
      }

      // Streams own their response: a non-401 failure is read off the stream
      // response by the caller, which needs the untouched body to do it.
      if (raw) return resp;

      if (!resp.ok) {
        const body = await resp.json().catch(() => ({}));
        // GHD.detailText (/js/api-error.js) reads both shapes a failed body can
        // carry: FastAPI's `detail` (a string, or Pydantic's list of objects) and
        // PostgREST's `message`.
        const err = new Error(
          GHD.detailText(body) || `${surface === "supabase" ? "Supabase" : "API"} error ${resp.status}`,
        );
        // Pages branch on this (compare.js on 400/404, cards.js on 403,
        // birth-time-explorer.js on 403/429). It used to be set on the backend
        // path only, so a failed Supabase read arrived indistinguishable from any
        // other error — no status, whatever the cause.
        err.status = resp.status;
        // …and the machine-readable half of the same body, where there is one.
        // A status says how it failed, not why: a 409 is "a conflict", while
        // its `code` is the branch a page needs (see GHD.detailCode). Left off
        // until 2026-09-15, so a page that wanted the reason had to read the
        // sentence — which is written for a human and translated.
        err.code = GHD.detailCode(body);
        // The rest of the body, for a refusal that names its subjects (the pair
        // transits 409 lists whose birth time is not exact).
        err.body = body;
        throw err;
      }

      if (resp.status === 204) return null;
      return await resp.json();
    } catch (error) {
      // The one place an expired deadline is named. Headers and body are both
      // behind the same signal, so either can be what the timer cut — and the
      // AbortError that comes back from it says nothing about who aborted.
      throw deadline?.expired ? _timeoutError(timeoutMs) : error;
    } finally {
      deadline?.clear();
    }
  },

  // ── Did the backend answer? ───────────────────────────────────────────────
  //
  // The footer's status dot and the offline banner both want to know whether
  // the API is reachable, and both used to ask /health for it on every page
  // load — a seventh request to a host the page was already talking to six
  // times in the same tick. Every ordinary request answers the same question,
  // so app.js listens here and keeps /health for the cases nothing else can
  // answer: a page that issues no request at all, and the moment the browser
  // says the connection changed.
  //
  // `ok` is "bytes came back", whatever their status — a 500 is the API's
  // problem, not the device's, and telling someone with a working connection
  // that they are offline sends them to reset a router that was never the
  // trouble (App._probeConnectivity says the rest). Supabase is left out: it is
  // a different host, so its answer is no evidence about ours.
  _apiAnswerListeners: [],

  onApiAnswer(listener) {
    this._apiAnswerListeners.push(listener);
  },

  _noteApiAnswer(ok) {
    for (const listener of this._apiAnswerListeners) {
      try {
        listener(ok);
      } catch (_error) {
        /* a listener is UI; it must never take a request down with it */
      }
    }
  },

  // Declared side by side so the request paths cannot silently drift apart again.
  //
  // Supabase deliberately gets neither X-Client-Surface nor Accept-Language:
  // PostgREST ignores both, and a non-safelisted custom header on a cross-origin
  // request only survives if Supabase's CORS allow-list happens to carry it —
  // production risk for no gain. Streams get nothing at all: each stream endpoint
  // sets its own Content-Type / X-Client-Surface / Accept-Language.
  _defaultHeaders(surface) {
    if (surface === "stream") return {};
    if (surface === "supabase") return { apikey: CONFIG.SUPABASE_ANON_KEY };
    return {
      "Content-Type": "application/json",
      // GHD.platform (platform.js) is always loaded before api.js in the app;
      // guard for the isolated unit-test VM where it isn't defined.
      ...(window.GHD?.platform ? { "X-Client-Surface": GHD.platform.surface } : {}),
      // The backend localizes error details off Accept-Language; send the app's
      // active UI language so in-app choice wins over the browser locale.
      ...(window.GHD_I18N ? { "Accept-Language": GHD_I18N.locale } : {}),
    };
  },

  // ── Helper: raw fetch to Supabase REST API (bypasses SDK init) ──

  _supabaseRest(path, options = {}, { timeoutMs = _REQUEST_TIMEOUT_MS } = {}) {
    return this._request(`${CONFIG.SUPABASE_URL}/rest/v1${path}`, options, { surface: "supabase", timeoutMs });
  },

  // ── Backend-backed user reads (ensures profile exists) ─────

  /* `details: false` skips the live Stripe read behind the renewal line, which
     only Settings shows; the answer then says `details: false`. */
  async getSubscription({ details = true } = {}) {
    return this._fetch(details ? "/v1/user/subscription" : "/v1/user/subscription?details=0");
  },

  /* The shell's first-load reads in one answer (backend routes/bootstrap.py);
     GHD.store asks for it once per cold load and seeds its keys from it. */
  getBootstrap() {
    return this._fetch("/v1/user/bootstrap");
  },

  async getChartQuota() {
    const rows = await this._supabaseRest("/chart_quota?select=remaining,reset_at,window_limit&limit=1");
    return rows[0] || null;
  },

  async getPeople() {
    return this._supabaseRest(
      "/people?select=id,name,birth_datetime,birth_place,birth_time_confidence,is_me,created_at,hd_type,profile,authority," +
        "derived_tiers,chart_facts,share_token&order=created_at.asc",
    );
  },

  // ── Direct Supabase reads/writes ────────────────────────────

  async completeOnboarding({
    name = "",
    birthDatetime = "",
    birthPlace = "",
    birthTimeConfidence = null,
    tosAccepted = false,
    // The signup checkbox, pre-ticked. Sent with onboarding rather than only as
    // the follow-up subscribeNewsletter call, so the answer is recorded by the
    // one request every signup surface makes — see backend user_routes.
    marketingConsent = true,
    signupSource = "direct",
    locale = window.GHD_I18N ? GHD_I18N.locale : "",
  } = {}) {
    const mcpSurface = _mcpSignupSurface();
    const entry = _storedAttribution("entryPage");
    const last = _storedAttribution("lastTouch");
    const send = (source, surface) =>
      this._fetch("/v1/user/onboarding", {
        method: "PATCH",
        headers: surface ? { "X-Client-Surface": surface } : {},
        body: JSON.stringify({
          // The one name a signup collects: it goes on the me-person, which is
          // where the account's name lives (backend/names.py).
          name,
          birth_datetime: birthDatetime,
          birth_place: birthPlace,
          // "I don't know my birth time" → 'unknown', anything else → 'exact'.
          // null only if a caller never asked, which no signup path does.
          birth_time_confidence: birthTimeConfidence || null,
          tos_accepted: tosAccepted,
          marketing_consent: marketingConsent,
          signup_source: source,
          // UI locale at signup → seeds profiles.ui_language so the welcome email, the
          // interface and the chat reply language all match the signup language.
          locale,
          gclid: _storedAttribution("gclid").v || "",
          referred_by_share_token: _storedAttribution("shareToken").v || "",
          entry_path: entry.v || "",
          entry_referrer: entry.r || "",
          entry_utm_source: entry.u || "",
          // Records from before `o` existed were all written on www.
          entry_origin: entry.v ? entry.o || "www" : "",
          last_touch_path: last.v || "",
          last_touch_referrer: last.r || "",
          last_touch_utm_source: last.u || "",
          last_touch_origin: last.o || "",
          last_touch_at: last.t || null,
          signup_page: _storedAttribution("signupPage").v || "",
        }),
      });

    let result;
    try {
      result = await send(mcpSurface || signupSource, mcpSurface);
    } catch (err) {
      // Attribution must never be the reason an account fails to exist. A 400 or
      // 422 is the backend refusing a *value* — the only way "mcp_website" can be
      // wrong is a vocabulary this client is ahead of — and neither status ever
      // half-succeeds, so retrying without it is safe and costs one request. Any
      // other failure is about the account itself and belongs to the caller.
      const rejectedTheSurface = mcpSurface && (err?.status === 400 || err?.status === 422);
      if (!rejectedTheSurface) throw err;
      result = await send(signupSource, "");
    }
    // Onboarding is the one and only consumer of both — drop them now that the
    // backend has them.
    _clearStoredAttribution();
    return result;
  },

  subscribeNewsletter(subscribe) {
    return this._fetch(
      "/v1/user/newsletter-subscribe",
      {
        method: "POST",
        body: JSON.stringify({ subscribe }),
      },
      { redirectOnAuthFailure: false },
    );
  },

  // Set the account holder's name on their own (is_me) person record.
  //
  // The read is not here: the name is on a person the store already holds, so
  // the shell and settings take it off `GHD.store.people()` rather than
  // spending a request on it. GET /v1/user/me-name exists for callers with no
  // roster in hand.
  setMeName(name) {
    return this._fetch("/v1/user/me-name", {
      method: "PATCH",
      body: JSON.stringify({ name }),
    });
  },

  /* Tell the backend the session has a new address, so Stripe's copy can follow
     it. Sends nothing: the backend reads the address from the profile. */
  emailChanged() {
    return this._fetch("/v1/user/email-changed", { method: "POST" });
  },

  async getLLMSettings() {
    return this._supabaseRest("/profiles?select=hd_experience,ui_language", {
      headers: { Accept: "application/vnd.pgrst.object+json" },
    });
  },

  // Settings writes go through the backend rather than straight to PostgREST so
  // each one emits event=setting_changed — otherwise a deliberate change is
  // indistinguishable from the value seeded at signup. Only the keys passed are
  // written; an explicit null clears a setting back to automatic.
  async _updateSettings(fields) {
    await this._fetch("/v1/user/settings", {
      method: "PATCH",
      body: JSON.stringify(fields),
    });
  },

  async updateHdExperience(level) {
    await this._updateSettings({ hd_experience: level });
  },

  // THE language setting (app, chat replies, emails), or null to follow the
  // device. Stored in profiles.ui_language — the column predates the merge.
  async updateLanguage(code) {
    await this._updateSettings({ ui_language: code });
  },

  // ── Backend API (Stripe, account deletion, people writes) ─────

  _fetch(path, options = {}, { redirectOnAuthFailure = true, timeoutMs = _REQUEST_TIMEOUT_MS } = {}) {
    return this._request(`${CONFIG.API_BASE_URL}${path}`, options, { redirectOnAuthFailure, timeoutMs });
  },

  // Authenticated fetch that hands back the raw Response so the caller can read
  // resp.body as a stream (the SSE chat turns) — _fetch can't be used there
  // because it consumes the body as JSON. Takes an absolute *url* (the chat
  // client builds its own) and passes the caller's headers through verbatim;
  // only Authorization is added, so each stream endpoint keeps its exact
  // Content-Type / X-Client-Surface / Accept-Language set. Non-401 failures are
  // returned as-is — the caller reads the error body off the stream response.
  //
  // `timeoutMs: 0` — no deadline, and this is the one place that asks for none.
  // A chat turn legitimately runs for minutes, and the deadline would still be
  // armed while it did: the signal it composes reaches the body, so a timer of
  // any fixed length would cut a reply that was arriving normally. That is the
  // exact failure the lost-reply plan was about
  // (`git show 8e92367e:docs/plans/keep-the-reply-generating.md`). The caller
  // has the bound that belongs here — its own AbortController, which the
  // reader drives with the stop button — and a stream that drops mid-reply is
  // finished by the server, which chat-stream-client waits for by polling
  // getChatMessages rather than by holding this request open.
  streamFetch(url, options = {}, { redirectOnAuthFailure = true } = {}) {
    return this._request(url, options, { surface: "stream", redirectOnAuthFailure, raw: true, timeoutMs: 0 });
  },

  // The sentence _request would have thrown, for the one caller that reads its
  // own failed response: a stream turn (see `raw` above). Kept as a name on Api
  // because that is what the chat client asks for; the reading itself is
  // GHD.detailText.
  errorText(body, fallback) {
    return GHD.detailText(body) || fallback;
  },

  /* `entry` names where the Upgrade button was (quota_card | pro_feature_card |
     pricing | settings); the backend stores it on the checkout and the upgrade. */
  createCheckout(billing = "yearly", entry = "other") {
    return this._fetch("/v1/user/checkout", {
      method: "POST",
      body: JSON.stringify({ billing, entry }),
    });
  },

  confirmCheckout(sessionId) {
    return this._fetch("/v1/user/checkout/confirm", {
      method: "POST",
      body: JSON.stringify({ session_id: sessionId }),
    });
  },

  /* Whether this account may buy Pro in the App Store now: {can_purchase,
     reason}. False for an account Pro already, whoever bills it. */
  getAppleEligibility() {
    return this._fetch("/v1/billing/apple/eligibility");
  },

  /* A signed App Store transaction from the iOS shell, bound to this account
     (backend: POST /v1/billing/apple/transactions). */
  postAppleTransaction(signedTransaction) {
    return this._fetch("/v1/billing/apple/transactions", {
      method: "POST",
      body: JSON.stringify({ signed_transaction: signedTransaction }),
    });
  },

  /* Whether this account may buy Pro from `provider` ("apple" |
     "google_play") now: {can_purchase, reason}, reason "stripe" | "apple" |
     "google_play" | "pro" | "unavailable" | null. */
  getBillingEligibility(provider) {
    return this._fetch(`/v1/billing/eligibility?provider=${encodeURIComponent(provider)}`);
  },

  /* A Google Play purchase token from the Android app, bound to this account
     and acknowledged (backend: POST /v1/billing/google-play/purchases).
     Idempotent, so a restore re-posts every token Play lists. */
  postGooglePlayPurchase(purchaseToken) {
    return this._fetch("/v1/billing/google-play/purchases", {
      method: "POST",
      body: JSON.stringify({ purchase_token: purchaseToken }),
    });
  },

  /* The native Sign in with Apple credential's one-time code. The backend
     trades it for Apple's refresh token, which account deletion must revoke. */
  registerAppleSignIn(authorizationCode) {
    return this._fetch("/v1/user/apple-signin", {
      method: "POST",
      body: JSON.stringify({ authorization_code: authorizationCode }),
    });
  },

  createBillingPortal() {
    return this._fetch("/v1/user/billing-portal", { method: "POST" });
  },

  // The exit survey travels with the deletion itself rather than in a call of
  // its own: answers stored before the account is gone would have to be keyed
  // to a live user, which is the personal-data record the anonymous churn
  // tombstone exists to avoid. `survey` is {reason, comment} — both optional,
  // and null (no body at all) when the user skipped it, which is the norm.
  deleteAccount(survey = null) {
    return this._fetch("/v1/user/account", {
      method: "DELETE",
      ...(survey ? { body: JSON.stringify(survey) } : {}),
    });
  },

  // The account's data as one ZIP, built in the background (Settings → Your
  // data). Each answers `{export}`; a refusal's `err.code` and `err.body.detail`
  // carry the export already in progress or the cooldown's `retry_at`.
  getDataExport() {
    return this._fetch("/v1/user/export");
  },

  requestDataExport() {
    return this._fetch("/v1/user/export", { method: "POST" });
  },

  // `{url, expires_in}`: a short-lived signed URL for the browser to follow.
  downloadDataExport() {
    return this._fetch("/v1/user/export/download", { method: "POST" });
  },

  sendFeedback(message) {
    return this._fetch("/v1/user/feedback", {
      method: "POST",
      body: JSON.stringify({ message }),
    });
  },

  reportReply({ reason, note, replyText, conversationId }) {
    return this._fetch("/v1/user/report-reply", {
      method: "POST",
      body: JSON.stringify({ reason, note, reply_text: replyText, conversation_id: conversationId }),
    });
  },

  /* Count one knowledge-base read (backend chat/kb_events.py). Fire-and-forget and
     never rejects: `keepalive` survives the navigation to the doc page, and
     `redirectOnAuthFailure: false` keeps a dead session from bouncing to /login. */
  reportKbOpened({ path, source, surface, conversationId = null }) {
    return this._fetch(
      "/v1/kb-opened",
      {
        method: "POST",
        keepalive: true,
        body: JSON.stringify({ path, source, surface, conversation_id: conversationId }),
      },
      { redirectOnAuthFailure: false },
    ).catch(() => {});
  },

  /* Count one arrival from a link we minted outside the app (backend routes/site.py). */
  reportInboundLink(ref) {
    return this._fetch(
      "/v1/inbound-link",
      { method: "POST", keepalive: true, body: JSON.stringify({ ref }) },
      { redirectOnAuthFailure: false },
    ).catch(() => {});
  },

  /* Say that the reader pressed Stop on this reply (backend routes/site.py): the
     server cannot tell a Stop from a dropped connection. `keepalive` because the
     abort follows at once; `redirectOnAuthFailure: false` so Stop never logs out. */
  reportChatStopped(conversationId, heldMs = null) {
    const body = { conversation_id: conversationId };
    // How long they had been waiting. Sent because the server cannot work it
    // out — the press arrives on its own request, so nothing there knows which
    // turn it ended or when that turn started. It is what separates a stray tap
    // on the send/stop button from a reader who read enough and wants it to end.
    if (Number.isFinite(heldMs)) body.held_ms = Math.max(0, Math.round(heldMs));
    return this._fetch(
      "/v1/chat-stopped",
      { method: "POST", keepalive: true, body: JSON.stringify(body) },
      { redirectOnAuthFailure: false },
    ).catch(() => {});
  },

  /* Say that a reply's stream went silent and was given up on (backend
     routes/site.py), and whether the tab had been frozen meanwhile: the server
     sees only a socket that closed. Fire-and-forget, like reportChatStopped. */
  reportChatStalled(conversationId, silentMs, frozen) {
    const body = { silent_ms: Math.max(0, Math.round(silentMs)), frozen: Boolean(frozen) };
    if (conversationId) body.conversation_id = conversationId;
    if (window.GHD?.replyTrace) body.release = GHD.replyTrace.release;
    return this._fetch(
      "/v1/chat-stalled",
      { method: "POST", keepalive: true, body: JSON.stringify(body) },
      { redirectOnAuthFailure: false },
    ).catch(() => {});
  },

  /* Say how a reply ended in this browser when it was not plain (js/chat-reply-trace.js,
     backend routes/site.py). `keepalive` because the page may be going away. */
  reportChatReplyEnd(report) {
    return this._fetch(
      "/v1/chat-reply-end",
      { method: "POST", keepalive: true, body: JSON.stringify(report) },
      { redirectOnAuthFailure: false },
    ).catch(() => {});
  },

  /* Record which Play Store build this account is launching
     (backend ops/android_build.py; called only by GHD.androidBuild.report).
     Fired at boot, so a 401 must not bounce to /login. */
  reportAndroidBuild(appVersion) {
    return this._fetch(
      "/v1/user/android-build",
      { method: "POST", body: JSON.stringify({ app_version: appVersion || "" }) },
      { redirectOnAuthFailure: false },
    );
  },

  /* When the Android app asks for a Play rating: replies to go, or due by launch-days (js/play-review.js). */
  getPlayReview() {
    return this._fetch("/v1/user/play-review", {}, { redirectOnAuthFailure: false });
  },

  /* The Android app just fired Play's review sheet. */
  recordPlayReviewAsk() {
    return this._fetch("/v1/user/play-review", { method: "POST" }, { redirectOnAuthFailure: false });
  },

  addPerson(name, birth_datetime, birth_place, is_me, birth_time_confidence = null) {
    return this._fetch("/v1/user/people", {
      method: "POST",
      body: JSON.stringify({ name, birth_datetime, birth_place, is_me, birth_time_confidence }),
    });
  },

  updatePerson(id, data) {
    return this._fetch(`/v1/user/people/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  },

  deletePerson(id) {
    return this._fetch(`/v1/user/people/${id}`, { method: "DELETE" });
  },

  getPersonChart(personId) {
    return this._fetch(`/v1/user/people/${personId}/chart`);
  },

  // Pro's complete birth-day precision ledger for a saved person. Loaded only
  // when its person-detail tab opens; the ordinary chart route stays lean.
  getPersonBirthTimeExploration(personId) {
    return this._fetch(`/v1/user/people/${personId}/birth-time-exploration`);
  },

  // Chart sensitivity to the exact birth time: every five-minute slot across
  // the complete local birth date. Feeds the Birth Time Explorer in person forms.
  getBirthTimeTimescale({ birthDatetime, birthPlace }) {
    return this._fetch("/v1/user/bodygraph/timescale", {
      method: "POST",
      body: JSON.stringify({
        birth_datetime: birthDatetime,
        birth_place: birthPlace,
        range_hours: 24,
      }),
    });
  },

  /* The sky right now (or at `at`), read against one saved person's chart.
     A 403 is the Pro wall and a 409 `transits_need_exact_birth_time` a state to
     draw; both arrive as `status`/`code` on the Error. `days` (1-14) adds the
     window's `events`/`bands`. `tz` is sent as a zone NAME, not an offset: a
     window can cross a DST change. */
  getPersonTransits(personId, { at = "", days = null } = {}) {
    const query = new URLSearchParams();
    if (at) query.set("at", at);
    if (days) query.set("days", String(days));
    const tz = GHD.readerTimezone();
    if (tz) query.set("tz", tz);
    const qs = query.toString();
    return this._fetch(`/v1/user/people/${personId}/transits${qs ? `?${qs}` : ""}`);
  },

  // The sky over a pair's composite, now or at `at` (Pro; both birth times
  // exact, else 409 naming whose is not). Ids are uuids or "me".
  getPairTransits(idA, idB, { at = "" } = {}) {
    const query = new URLSearchParams();
    if (at) query.set("at", at);
    const tz = GHD.readerTimezone();
    if (tz) query.set("tz", tz);
    const qs = query.toString();
    return this._fetch(
      `/v1/user/pairs/${encodeURIComponent(idA)}/${encodeURIComponent(idB)}/transits${qs ? `?${qs}` : ""}`,
    );
  },

  // Cycles and returns (Pro): the timeline of one saved person's Saturn, Uranus
  // opposition, Kiron and nodal returns, plus a Solar-return summary. `tz`
  // defaults to the browser's zone, the clock every instant comes back on.
  getPersonCycles(personId, { tz = "" } = {}) {
    const query = new URLSearchParams();
    const zone = tz || GHD.readerTimezone();
    if (zone) query.set("tz", zone);
    const qs = query.toString();
    return this._fetch(`/v1/user/people/${personId}/cycles${qs ? `?${qs}` : ""}`);
  },

  // One cycle's chart, cast at its exact pass and read against the natal chart.
  // `occurrence` for every cycle but `solar_return`, which takes `year`; `pass`
  // picks a later pass of a multi-pass return (default 1). A 409 with code
  // `transits_need_exact_birth_time` means the birth time is not exact.
  getPersonCycleChart(personId, cycle, { occurrence = null, year = null, pass = null, tz = "" } = {}) {
    const query = new URLSearchParams();
    if (occurrence) query.set("occurrence", String(occurrence));
    if (year) query.set("year", String(year));
    if (pass) query.set("pass", String(pass));
    const zone = tz || GHD.readerTimezone();
    if (zone) query.set("tz", zone);
    const qs = query.toString();
    return this._fetch(`/v1/user/people/${personId}/cycles/${encodeURIComponent(cycle)}${qs ? `?${qs}` : ""}`);
  },

  // Relationship comparison for the compare page. Ids are saved-person uuids
  // or the literal "me".
  comparePeople(idA, idB) {
    return this._fetch(`/v1/user/people/compare?a=${encodeURIComponent(idA)}&b=${encodeURIComponent(idB)}`);
  },

  sharePerson(id) {
    return this._fetch(`/v1/user/people/${id}/share`, { method: "POST" });
  },

  unsharePerson(id) {
    return this._fetch(`/v1/user/people/${id}/share`, { method: "DELETE" });
  },

  savePersonFromShare(token) {
    return this._fetch(`/v1/user/people/from-share/${encodeURIComponent(token)}`, { method: "POST" });
  },

  savePersonFromCard(name, birth_datetime, birth_place) {
    return this._fetch("/v1/user/people/from-card", {
      method: "POST",
      body: JSON.stringify({ name, birth_datetime, birth_place }),
    });
  },

  resolveLocation(place) {
    return this._fetch(`/v1/user/people/resolve-location?place=${encodeURIComponent(place)}`);
  },

  searchLocations(query) {
    return this._fetch(`/v1/user/people/search-locations?q=${encodeURIComponent(query)}`);
  },

  // ── Groups (Pro-only) ──────────────────────────────────────────

  getGroups() {
    return this._fetch("/v1/user/groups");
  },

  createGroup(name) {
    return this._fetch("/v1/user/groups", {
      method: "POST",
      body: JSON.stringify({ name }),
    });
  },

  deleteGroup(id) {
    return this._fetch(`/v1/user/groups/${id}`, { method: "DELETE" });
  },

  renameGroup(groupId, name) {
    return this._fetch(`/v1/user/groups/${groupId}`, {
      method: "PATCH",
      body: JSON.stringify({ name }),
    });
  },

  getGroupPenta(groupId) {
    return this._fetch(`/v1/user/groups/${groupId}/penta`);
  },

  // Save an ad-hoc analyse_group chat card as a real group. Members are given
  // as saved-person ids (the literal "me" allowed). Upsert by name: an existing
  // name replaces that group's members rather than conflicting.
  saveGroupFromCard(name, person_ids) {
    return this._fetch("/v1/user/groups/from-card", {
      method: "POST",
      body: JSON.stringify({ name, person_ids }),
    });
  },

  addGroupMember(groupId, personId) {
    return this._fetch(`/v1/user/groups/${groupId}/members`, {
      method: "POST",
      body: JSON.stringify({ person_id: personId }),
    });
  },

  removeGroupMember(groupId, personId) {
    return this._fetch(`/v1/user/groups/${groupId}/members/${personId}`, {
      method: "DELETE",
    });
  },

  // ── Chat ──────────────────────────────────────────────────────

  listChatConversations() {
    return this._fetch("/v1/chat/conversations");
  },

  /* The conversations whose messages hold every word of `q`: {results, more},
     each result a conversation's newest matching message cut to a snippet. */
  searchChats(q, { signal } = {}) {
    return this._fetch(`/v1/chat/search?q=${encodeURIComponent(q)}`, signal ? { signal } : {});
  },

  // No createChatConversation: a conversation is born with its first message
  // (POST /v1/chat/messages returns the id in its `conversation` SSE event), so
  // nothing here creates an empty one that a silent visit would leave behind.

  deleteChatConversation(id) {
    return this._fetch(`/v1/chat/conversations/${id}`, { method: "DELETE" });
  },

  // `content` is the question being deleted; the backend refuses if a newer one
  // has landed since. Answers {conversation_deleted}: deleting the only question
  // deletes the chat.
  deleteLastChatTurn(id, content) {
    return this._fetch(`/v1/chat/conversations/${id}/messages/last`, {
      method: "DELETE",
      body: JSON.stringify({ content }),
    });
  },

  renameChatConversation(id, title) {
    return this._fetch(`/v1/chat/conversations/${id}`, {
      method: "PATCH",
      body: JSON.stringify({ title }),
    });
  },

  // `redirectOnAuthFailure: false` is for the one caller that reads from behind
  // a pill: the wait for a reply the server is finishing after a dropped socket
  // (chat-stream-client `_awaitStoredReply`). A session that died while the
  // reply was being written must not turn that wait into a trip to /login.
  //
  // `onMentionBudget` asks for the conversation's mention budget in the same read
  // (`?with=mention_budget`) and is called with it — `null` if the server could
  // not build one. It is not called when the answer has no budget: the server
  // did not wait for it, or predates the parameter and answered the bare list.
  // A caller must then fetch the budget itself.
  //
  // `limit` asks for one page instead of the whole history: the newest `limit`
  // rows older than the `before` cursor, whole turns only. `onPage` hears
  // `{hasMore, before}`, `before` being the next older page's cursor; a backend
  // from before paging answers the whole list, which has nothing more.
  async getChatMessages(
    conversationId,
    { redirectOnAuthFailure = true, onMentionBudget = null, limit = 0, before = null, onPage = null } = {},
  ) {
    const query = [
      limit && `limit=${limit}`,
      before && `before=${encodeURIComponent(before)}`,
      onMentionBudget && "with=mention_budget",
    ].filter(Boolean);
    const path = `/v1/chat/conversations/${conversationId}/messages${query.length ? "?" + query.join("&") : ""}`;
    const answer = await this._fetch(path, {}, { redirectOnAuthFailure });
    const page = Array.isArray(answer) ? { messages: answer } : answer;
    if (onMentionBudget && "mention_budget" in page) onMentionBudget(page.mention_budget);
    onPage?.({ hasMore: Boolean(page.has_more), before: page.before || null });
    return page.messages;
  },

  /* What this conversation's charts budget still has room for, and whether a pair
     reading has taken the group slot (backend/chat/chart_budget.py). Not a
     GHD.store key: the same object rides on each turn's `done` event. */
  getMentionBudget(conversationId) {
    return this._fetch(`/v1/chat/conversations/${conversationId}/mention_budget`);
  },

  getChatQuota() {
    return this._fetch("/v1/chat/quota");
  },

  shareChatConversation(id) {
    return this._fetch(`/v1/chat/conversations/${id}/share`, { method: "POST" });
  },

  unshareChatConversation(id) {
    return this._fetch(`/v1/chat/conversations/${id}/share`, { method: "DELETE" });
  },
};

// The export convention (see the boot list in js/app.js): a top-level `const`
// is a lexical global and never a property of `window`, so every shared module
// publishes itself by name.
window.Api = Api;

;
/* dashboard/js/android-build.js */
/**
 * GHD.androidBuild — the Play Store app telling our own backend which build it is.
 *
 * The version only rides the cold-launch start URL (`/?platform=twa&app=<ver>`,
 * frontend_android/twa-manifest.json), so it is captured at load, before the router
 * navigates the query away, and kept in localStorage. The origin is read by the
 * backend off the Origin header, never sent from here. Reported once per launch-day
 * or on change; browsers and installed PWAs never report.
 *
 * Load after platform.js and api.js; app.js fires the report once there is a session.
 */
(function () {
  window.GHD = window.GHD || {};

  // Must match `startUrl` in frontend_android/twa-manifest.json and the pattern
  // backend/ops/android_build.py accepts: up to four dot-separated numeric groups.
  var VERSION_PARAM = "app";
  var VERSION_RE = /^\d{1,4}(?:\.\d{1,4}){0,3}$/;

  function _isTWA() {
    return !!(GHD.platform && GHD.platform.isTWA);
  }

  /* Today as the bucket the once-a-day ceiling counts in: the UTC date, the same
     day the backend counts profiles.android_app_days in. */
  function _today() {
    return new Date().toISOString().slice(0, 10);
  }

  /* The build this device runs: the version off the cold-launch start URL when
     there is one, otherwise whatever an earlier cold launch stored. Only written
     inside the app: the TWA shares localStorage with Chrome, so a pasted `?app=`
     in a browser tab must not poison it. */
  function _captureVersion() {
    // "" rather than null: the value is reported and joined into a fingerprint.
    var stored = GHD.storage.get(GHD.KEYS.androidAppVersion) || "";
    if (!_isTWA()) return stored;
    var fromUrl;
    try {
      var query = typeof location !== "undefined" ? location.search : "";
      fromUrl = (query ? new URLSearchParams(query).get(VERSION_PARAM) : "") || "";
    } catch (e) {
      fromUrl = ""; // no URL API (a headless test VM), or an unparseable query
    }
    if (!VERSION_RE.test(fromUrl) || fromUrl === stored) return stored;
    GHD.storage.set(GHD.KEYS.androidAppVersion, fromUrl);
    return fromUrl;
  }

  GHD.androidBuild = {
    /** The build number this device last announced, or "" (1.1.0 and older). */
    version: _captureVersion(),

    /* What a report would say, as one string. The account id is in it because
       two accounts on one device are two rows; the day, because a fresh
       timestamp is the reason to report again. */
    fingerprint: function (userId) {
      var host = typeof location !== "undefined" ? location.host : "";
      return [host, GHD.androidBuild.version, userId || "", _today()].join("|");
    },

    /* Tell the backend, unless it already knows. Resolves true when a report went
       out. Never throws or shows anything; a failure leaves the fingerprint
       untouched, so the next launch retries. */
    report: function (userId) {
      if (!_isTWA() || !userId) return Promise.resolve(false);
      var fingerprint = GHD.androidBuild.fingerprint(userId);
      if (GHD.storage.get(GHD.KEYS.androidBuildReported) === fingerprint) return Promise.resolve(false);
      return Promise.resolve(Api.reportAndroidBuild(GHD.androidBuild.version))
        .then(function () {
          GHD.storage.set(GHD.KEYS.androidBuildReported, fingerprint);
          return true;
        })
        .catch(function (err) {
          console.warn("Android build report failed:", err);
          return false;
        });
    },
  };
})();

;
/* dashboard/js/native-bridge.js */
/**
 * GHD.native — the bridge to the iOS shell, and the two jobs that must run on
 * every page inside it: handing off-origin links to Safari, and delivering App
 * Store transactions to the backend.
 *
 * Call: webkit.messageHandlers.ghd.postMessage({id, method, params}). The shell
 * answers with GHDNative._resolve(id, result, error) and pushes events with
 * GHDNative._event(name, payload). Outside the iOS app `available` is false,
 * every call rejects, and nothing is installed.
 *
 * Load after platform.js; reads Api only when a transaction arrives.
 */
(function () {
  window.GHD = window.GHD || {};

  var handler =
    (GHD.platform &&
      GHD.platform.isIOSApp &&
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.ghd) ||
    null;
  var pending = {};
  var nextId = 1;
  var listeners = {};
  var queued = {};

  /* `native` tells the shell's codes apart from the backend's, which an
     error from Api can carry too. */
  function bridgeError(code, message) {
    var err = new Error(message || code || "bridge error");
    err.code = code || "error";
    err.native = true;
    return err;
  }

  function call(method, params) {
    if (!handler) return Promise.reject(bridgeError("unavailable", "not in the iOS app"));
    return new Promise(function (resolve, reject) {
      var id = "n" + nextId++;
      pending[id] = { resolve: resolve, reject: reject };
      try {
        handler.postMessage({ id: id, method: method, params: params || {} });
      } catch (err) {
        delete pending[id];
        reject(err);
      }
    });
  }

  /* An event nobody listens to yet is kept, so a transaction the shell pushes at
     launch waits for the session instead of being dropped. */
  function on(name, fn) {
    (listeners[name] = listeners[name] || []).push(fn);
    var backlog = queued[name];
    if (backlog) {
      delete queued[name];
      backlog.forEach(fn);
    }
  }

  /* The App Store's id for a signed transaction, read from the JWS payload. The
     backend verifies the signature; this only names what to finish. */
  function transactionId(jws) {
    try {
      var part = String(jws).split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      while (part.length % 4) part += "=";
      var id = JSON.parse(atob(part)).transactionId;
      return id == null ? "" : String(id);
    } catch (err) {
      return "";
    }
  }

  /* Send one signed transaction to the backend, then let the shell finish it.
     Finishing only after the backend has it is what keeps a crash in between
     from losing a paid transaction: an unfinished one is pushed again on the
     next launch. Resolves with the backend's {plan, provider, expires_at}. */
  function deliver(signedTransaction) {
    return Api.postAppleTransaction(signedTransaction).then(function (res) {
      var id = transactionId(signedTransaction);
      var finished = id ? call("finish", { transactionId: id }) : Promise.resolve(null);
      return finished.then(
        function () {
          return res;
        },
        function (err) {
          console.warn("[native] finish failed", err);
          return res;
        },
      );
    });
  }

  var accountId = "";

  /* Renewals, Ask to Buy approvals and refunds, pushed by the shell. Held until
     a session exists, since the backend binds each to the signed-in account. */
  function attachAccount(userId) {
    if (!handler || !userId || accountId) return;
    accountId = userId;
    on("transaction", function (payload) {
      var signed = payload && payload.signedTransaction;
      if (!signed) return;
      deliver(signed)
        .then(function (res) {
          if (res && res.plan === "pro" && GHD.router && GHD.router.current().split("?")[0] === "/settings") {
            window.App?.route?.();
          }
        })
        .catch(function (err) {
          // Unfinished, so the shell pushes it again on the next launch.
          console.warn("[native] transaction delivery failed", err);
          // Bound to another account: the backend's answer, not a fault.
          if (err && err.status === 409) return;
          GHD.reportClientError?.("reported", (err && err.message) || String(err), err && err.stack, {
            context: "Deliver App Store transaction",
          });
        });
    });
  }

  /* One tap of feedback for a primary action ("light" | "success" | …). Never
     waits and never fails: outside the iOS app it does nothing. */
  function haptic(style) {
    if (handler) call("haptic", { style: style || "light" }).catch(function () {});
  }

  GHD.native = {
    available: !!handler,
    call: call,
    haptic: haptic,
    on: on,
    deliver: deliver,
    transactionId: transactionId,
    attachAccount: attachAccount,
  };

  if (!handler) return;

  window.GHDNative = {
    _resolve: function (id, result, error) {
      var job = pending[id];
      if (!job) return;
      delete pending[id];
      if (error) job.reject(bridgeError(error.code, error.message));
      else job.resolve(result === undefined ? null : result);
    },
    _event: function (name, payload) {
      var fns = listeners[name];
      if (!fns || !fns.length) {
        (queued[name] = queued[name] || []).push(payload);
        return;
      }
      fns.slice().forEach(function (fn) {
        try {
          fn(payload);
        } catch (err) {
          console.warn("[native] event handler failed", err);
        }
      });
    },
  };

  // A navigation off this origin would carry the whole app away inside the
  // webview, with no address bar or way back, so every link to the website, the
  // docs or a mail client goes to Safari. On `window`, after every document-level
  // handler: a link the app already handles (the knowledge-base panel) has been
  // prevented by then and is left alone.
  function externalUrl(href) {
    if (!href) return "";
    var url;
    try {
      url = new URL(href, location.href);
    } catch (err) {
      return "";
    }
    if (url.protocol === "mailto:" || url.protocol === "tel:") return url.href;
    if ((url.protocol === "http:" || url.protocol === "https:") && url.origin !== location.origin) return url.href;
    return "";
  }

  window.addEventListener("click", function (e) {
    if (e.defaultPrevented) return;
    var link = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    var url = link ? externalUrl(link.getAttribute("href")) : "";
    if (!url) return;
    e.preventDefault();
    call("openExternal", { url: url }).catch(function () {});
  });

  var nativeOpen = window.open;
  window.open = function (href) {
    var url = externalUrl(href);
    if (!url) return nativeOpen ? nativeOpen.apply(window, arguments) : null;
    call("openExternal", { url: url }).catch(function () {});
    return null;
  };
})();

;
/* dashboard/js/store.js */
/**
 * GHD.store — the one owner of the API resources more than one module needs:
 * people, groups, subscription, LLM settings, the conversation list, the chat
 * quota, a saved person's chart, and a group's Penta. A key caches the in-flight/settled promise,
 * so callers share one request. Wired by `GHD.store.init(Api)` from app.js's boot.
 *
 * Rules:
 *   1. Mutations invalidate, via the Api wrappers mapped in _INVALIDATES, so no
 *      call site can forget.
 *   2. A rejection is never cached (it would replay forever); except a 403 on a
 *      key in _EMPTY_ON_FORBIDDEN, which is a plan answer and settles to empty.
 *   3. The plan has ONE value, written by both endpoints that carry it; `isPro()`
 *      is the predicate, and nothing outside this file spells the plan string.
 *   4. Render paths read settled values synchronously (`peopleNow()`, `plan()`);
 *      `onChange(keys, fn)` says when one moved.
 *
 * Sign-out needs no hook (it reloads the page); _bucket()'s user-id check covers
 * an account switch inside one document.
 *
 * The first read of a cold load asks GET /v1/user/bootstrap for every shell key
 * at once; a field it could not answer falls back to that key's own read.
 *
 * The roster, the conversation list, groups, LLM settings and the plan are also
 * kept in localStorage per user (the snapshot), so the next cold load's sync
 * readers answer before any request lands; `stale(key)` says a value is still
 * that snapshot's. Reads always go to the network. The snapshot is wiped on
 * sign-out (`wipe()`), dropped for another user, and loses a key when it is
 * invalidated.
 *
 * A saved person's chart is kept on the device too, in the service worker's
 * API cache, under a fingerprint of the roster row it was cast from and the
 * plan it was stripped for: a read answers with that copy at once, asks the
 * network anyway, and records (and notifies) the fresh payload only when it
 * differs. js/api-cache.js holds that logic and installs it through
 * _setChartReader; it rides the route chunks that read charts, so the eager
 * bundle carries only the hook, and before a chunk loads a read is
 * network-only.
 */

(function () {
  window.GHD = window.GHD || {};

  const _cache = new Map(); // cache key → in-flight or fulfilled promise
  const _values = new Map(); // cache key → what the last read settled on
  const _readers = {}; // cache key → unwrapped Api read
  const _listeners = new Map(); // key → Set of callbacks
  let _cacheUserId = null;
  let _bootstrapped = false;

  // The plan is its own key: it has two writers (see rule 3) and, unlike the
  // payloads, it must survive an invalidate — a checkout confirm drops the
  // subscription, and blanking the shell badge until the refetch lands is a
  // worse answer than the plan we already know.
  const PLAN = "plan";

  // The API client, handed over by App's boot list rather than read off the
  // global scope as this file evaluates — which is what used to make the tag
  // order in dashboard/index.html the wiring, silently and invisibly. Empty
  // until init() runs, so evaluating this file on its own does nothing.
  let _api = {};

  // Bump SNAPSHOT_VERSION when a persisted payload changes shape.
  const SNAPSHOT_KEY = "ghd_store_snapshot";
  const SNAPSHOT_VERSION = 1;
  const _PERSISTED = ["people", "conversations", "groups", "llmSettings", PLAN];
  let _snapshot = {};
  const _stale = new Set(); // keys whose value is still the snapshot's

  function _loadSnapshot(userId) {
    _snapshot = {};
    try {
      const saved = JSON.parse(localStorage.getItem(SNAPSHOT_KEY));
      if (saved?.u === userId && saved.v === SNAPSHOT_VERSION) _snapshot = saved.d || {};
      else if (saved) localStorage.removeItem(SNAPSHOT_KEY);
    } catch {
      _snapshot = {};
    }
    Object.keys(_snapshot).forEach((key) => {
      _values.set(key, _snapshot[key]);
      _stale.add(key);
    });
  }

  function _saveSnapshot() {
    try {
      // A tab that outlived a sign-out in another one must not write the
      // roster back after that sign-out wiped it.
      if (!_cacheUserId || !localStorage.getItem(GHD_APP.sessionKey())) return;
      localStorage.setItem(SNAPSHOT_KEY, JSON.stringify({ u: _cacheUserId, v: SNAPSHOT_VERSION, d: _snapshot }));
    } catch {
      // A full quota must not leave an older snapshot behind a mutation.
      try {
        localStorage.removeItem(SNAPSHOT_KEY);
      } catch {}
    }
  }

  /** The cache holds one user's data; a different user starts empty. */
  function _bucket() {
    const userId = window.App?._session?.user?.id || null;
    if (userId !== _cacheUserId) {
      _cache.clear();
      _values.clear();
      _stale.clear();
      _cacheUserId = userId;
      _bootstrapped = false;
      if (userId) _loadSnapshot(userId);
    }
    return _cache;
  }

  /** A synchronous reader's value, for the current user. */
  function _now(key) {
    _bucket();
    return _values.get(key);
  }

  function _notify(key) {
    const listeners = _listeners.get(key);
    if (listeners) listeners.forEach((fn) => fn(key));
  }

  // Keys whose 403 is an answer rather than a failure, and the answer it is.
  //
  // Rule 2 is right about failures and wrong about this one: /v1/user/groups is
  // Pro-only, so a free plan's 403 is not a read that went wrong but the list
  // itself — empty, and staying empty until the plan moves, which is what
  // `_record` stales these keys on. Left as a rejection it is dropped from the
  // cache on every read, and the shell reads groups on every route (app-shell
  // `_loadUserName`), so a free account browsing the app re-asks forever: one
  // signup produced seven 403s in ten seconds in production on 2026-09-07,
  // fourteen over seven minutes.
  //
  // Only 403 — a 500 or a dropped socket is still a failure and still drops
  // out. And only the keys named here: a 403 anywhere else means something the
  // caller has not been told about, which is not for this file to answer.
  const _EMPTY_ON_FORBIDDEN = { groups: () => [] };

  /** The promise `_put` should cache: a named key's 403 settled into its answer. */
  function _answered(key, promise) {
    const empty = _EMPTY_ON_FORBIDDEN[key];
    if (!empty) return promise;
    return promise.catch((err) => {
      if (err?.status === 403) return empty();
      throw err;
    });
  }

  /**
   * Remember what a read landed on, so the sync readers below can answer
   * without another await, and tell whoever is listening.
   */
  function _persist(key) {
    if (!_PERSISTED.includes(key)) return;
    _stale.delete(key);
    _snapshot[key] = _values.get(key);
    _saveSnapshot();
  }

  function _record(key, value) {
    _bucket();
    _values.set(key, value);
    // Both plan-carrying endpoints land here; the badge only repaints when the
    // answer actually moved, so a five-second quota poll is silent.
    const carriesPlan = (key === "subscription" || key === "quota") && value && value.plan;
    if (carriesPlan) _stale.delete(PLAN);
    if (carriesPlan && _values.get(PLAN) !== value.plan) {
      const replaced = _values.get(PLAN);
      _values.set(PLAN, value.plan);
      // A plan-gated 403 was the OLD plan speaking, so the plan moving is what
      // makes it stale — and `confirmCheckout` is not the only way it moves.
      // settings-billing.js polls `Api.getSubscription()` straight through while
      // a slow Stripe webhook settles and writes the answer here (rule 3), which
      // is the ordinary way a checkout lands; a downgrade, another tab and the
      // reconcile backstop all arrive the same way. Without this the account
      // that just paid keeps the empty Groups page its free 403 cached, until it
      // reloads. Only the promise goes: `_values` stays, so a synchronous render
      // paints the old answer rather than nothing while the refetch is out
      // (rule 4).
      Object.keys(_EMPTY_ON_FORBIDDEN).forEach((forbidden) => _bucket().delete(forbidden));
      // A chart or Penta is stripped by the plan it was read under: a Pro
      // payload must not outlive a move to free, nor a free one a move to Pro.
      if (replaced != null) {
        [..._cache.keys(), ..._values.keys()].forEach((k) => {
          if (k.startsWith("chart:") || k.startsWith("penta:")) {
            _cache.delete(k);
            _values.delete(k);
          }
        });
      }
      _persist(PLAN);
      _notify(PLAN);
    }
    _persist(key);
    _notify(key);
  }

  function _put(key, promise) {
    const cache = _bucket();
    const owner = _cacheUserId;
    // The tracked promise is what everyone gets, so `await` cannot return
    // before the value is recorded — which is what makes the sync readers warm
    // the instant a read resolves.
    const tracked = _answered(key, promise).then((value) => {
      // A read that outlived an account switch must not land in the new account.
      _bucket();
      if (_cacheUserId === owner) _record(key, value);
      return value;
    });
    cache.set(key, tracked);
    tracked.catch(() => {
      if (cache.get(key) === tracked) cache.delete(key);
    });
    return tracked;
  }

  // The keys GET /v1/user/bootstrap answers, and the field each arrives in.
  const _BOOTSTRAP = {
    subscription: "subscription",
    quota: "quota",
    conversations: "conversations",
    people: "people",
    llmSettings: "llm_settings",
    groups: "groups",
  };

  /* One request for every shell key not already held. A field it could not
     answer (null, or no answer at all) is read from its own endpoint; a key
     invalidated while it was out takes the newer read instead of its answer. */
  function _bootstrap() {
    _bootstrapped = true;
    const answer = Promise.resolve()
      .then(() => _api.getBootstrap())
      .catch(() => null);
    Object.entries(_BOOTSTRAP).forEach(([key, field]) => {
      if (_cache.has(key) || !_readers[key]) return;
      const mine = _put(
        key,
        answer.then((body) =>
          _cache.get(key) !== mine
            ? _bucket().get(key) || _put(key, _readers[key]())
            : (body?.[field] ?? _readers[key]()),
        ),
      );
    });
  }

  // GHD.apiCache (js/api-cache.js, a route chunk) installs the device-first
  // chart read here; until then a chart read is network-only.
  let _chartReader = null;

  function _read(key, ...args) {
    const load = _readers[key.split(":")[0]];
    if (!load) return Promise.reject(new Error(`GHD.store: no reader for "${key}"`));
    const cache = _bucket();
    if (!_bootstrapped && key in _BOOTSTRAP && !cache.has(key) && _api.getBootstrap) _bootstrap();
    return cache.get(key) || _put(key, load(...args));
  }

  /* Replace `Api[method]` with a version that runs `onSettle` over its promise.
     Returns the original, or null when api.js no longer has the method. */
  function _wrapApi(method, onSettle) {
    const original = _api[method];
    if (typeof original !== "function") return null;
    _api[method] = function (...args) {
      return onSettle(Promise.resolve(original.apply(this, args)));
    };
    return original;
  }

  // ── Reads: cached here, primed by direct Api calls ──────────────────────

  const _READS = {
    getPeople: "people",
    getGroups: "groups",
    getSubscription: "subscription",
    getLLMSettings: "llmSettings",
    listChatConversations: "conversations",
    getChatQuota: "quota",
  };

  // A store read of the plan skips the Stripe details: only Settings shows them,
  // and it asks for them itself when the cached answer says `details: false`.
  const _READ_ARGS = { subscription: [{ details: false }] };

  // ── Mutations: which keys each one stales ───────────────────────────────

  const _ALL_KEYS = Object.values(_READS).concat("charts", "pentas", PLAN);

  const _INVALIDATES = {
    addPerson: ["people"],
    // A birth datetime, a place or a name that moved is a different chart —
    // and the me-card in an open chat is the one place that used to keep
    // showing the old one for the rest of the session.
    //
    // "groups" because a group row carries its members' birth_time_confidence,
    // and the groups overview keys its cached Penta glyph on it: a member moved
    // from exact to roughly keeps their clock, so without this the stale group
    // row still fingerprints as exact and the glyph keeps painting channels the
    // backend now refuses, with none of the warning that replaced them.
    updatePerson: ["people", "charts", "groups", "pentas"],
    deletePerson: ["people", "pentas"],
    savePersonFromCard: ["people"],
    savePersonFromShare: ["people"],
    // share_token is part of the people select, so (un)sharing changes the row.
    sharePerson: ["people"],
    unsharePerson: ["people"],
    // The account holder's name is the me-person's name, so a rename stales
    // the roster the greeting and the user card are painted from — without
    // this the app keeps calling them by their email address until the next
    // full page load. The chart payload carries the name as well.
    setMeName: ["people", "charts", "pentas"],
    createGroup: ["groups", "pentas"],
    deleteGroup: ["groups", "pentas"],
    renameGroup: ["groups", "pentas"],
    saveGroupFromCard: ["groups", "pentas"],
    addGroupMember: ["groups", "pentas"],
    removeGroupMember: ["groups", "pentas"],
    updateHdExperience: ["llmSettings"],
    updateLanguage: ["llmSettings"],
    // Every one of these rewrites the row the sidebar and the /chats page
    // render, title and share_token included.
    deleteChatConversation: ["conversations"],
    deleteLastChatTurn: ["conversations"],
    renameChatConversation: ["conversations"],
    shareChatConversation: ["conversations"],
    unshareChatConversation: ["conversations"],
    // Pro unlocks /v1/user/groups, which answers 403 on a free plan, moves the
    // message allowance the quota reports, and stops the chart payload being
    // stripped of its Pro fields (backend models.strip_pro_fields).
    confirmCheckout: ["subscription", "groups", "quota", "charts", "pentas"],
    postAppleTransaction: ["subscription", "groups", "quota", "charts", "pentas"],
    postGooglePlayPurchase: ["subscription", "groups", "quota", "charts", "pentas"],
    // Creates the me-person, sets the name, seeds ui_language, flips
    // onboarding_completed.
    completeOnboarding: _ALL_KEYS,
    deleteAccount: _ALL_KEYS,
  };

  function _drop(keys) {
    let unsaved = false;
    keys.forEach((key) => {
      if (key === "charts" || key === "pentas") {
        const prefix = key === "charts" ? "chart:" : "penta:";
        _drop([..._cache.keys()].filter((k) => k.startsWith(prefix)));
        // Until the roster is read again its row still fingerprints as the
        // old birth data, so the device copies have to go with the promises.
        if (key === "charts") GHD.apiCache?.drop(/\/v1\/user\/people\/[^/?#]+\/chart$/);
        return;
      }
      _cache.delete(key);
      // A reload before the refetch lands must not paint the pre-mutation copy.
      if (key in _snapshot) unsaved = delete _snapshot[key];
    });
    if (unsaved) _saveSnapshot();
  }

  // The roster names people on every page: a rename has to reach the cards and
  // the user card already painted, not only the next page that reads it.
  const _REREAD_WHEN_WATCHED = new Set(["people"]);

  // ── The wiring, done once when init() hands over the client ─────────────

  // One key per person, so a chart read carries its argument through both the
  // wrapper and the loader. Kept out here because _readers.chart resolves it
  // per call: a unit-test VM hands this module an Api that grows its
  // getPersonChart afterwards, and a reader taken at wire time would answer
  // every chart read with "no reader".
  let _originalPersonChart = null;
  let _originalGroupPenta = null;
  const PENTA_FRESH_MS = 60 * 1000;
  const _pentaReadAt = new Map(); // penta:<groupId> → when its request went out

  function _wireApi() {
    Object.entries(_READS).forEach(([method, key]) => {
      const original = _wrapApi(method, (promise) => _put(key, promise));
      // The store's own loader calls the original, so a store read doesn't
      // re-enter the wrapper.
      if (original) _readers[key] = () => original.call(_api, ...(_READ_ARGS[key] || []));
    });

    // The backend refuses groups to every plan but Pro, so a known non-Pro plan
    // is already the answer and asking would only fetch a 403. The plan is
    // waited on through a cached plan read, or the quota the shell reads on
    // every route: after a checkout both are dropped, and the plan still in
    // _values is the old one. A failed read leaves the last plan standing, and
    // with none the request goes out. The plan hint the app keeps for www
    // (App._publishPlanHint) lets a Pro account skip that wait on a cold load; a
    // hint gone stale costs one 403, which settles to [] like any other.
    const loadGroups = _readers.groups;
    if (loadGroups) {
      _readers.groups = async () => {
        if (!/(^|; )ghd_plan=pro/.test(globalThis.document?.cookie)) {
          await (_bucket().get("subscription") || _read("quota")).catch(() => {});
        }
        const plan = _values.get(PLAN);
        return plan && plan !== "pro" ? [] : loadGroups();
      };
    }

    _originalPersonChart = _api.getPersonChart;
    if (typeof _originalPersonChart === "function") {
      _api.getPersonChart = function (personId) {
        return _put(`chart:${personId}`, Promise.resolve(_originalPersonChart.call(this, personId)));
      };
    }
    // A group's Penta computes every member's chart server-side and bills one
    // usage row per chart, so the group page and the overview's glyphs share
    // one answer until a people or group write here stales it, or it ages out:
    // MCP and other tabs change members without telling this one.
    _originalGroupPenta = _api.getGroupPenta;
    if (typeof _originalGroupPenta === "function") {
      _api.getGroupPenta = function (groupId) {
        const key = `penta:${groupId}`;
        const held = _bucket().get(key);
        if (held && Date.now() - (_pentaReadAt.get(key) || 0) < PENTA_FRESH_MS) return held;
        _pentaReadAt.set(key, Date.now());
        return _put(key, Promise.resolve(_originalGroupPenta.call(this, groupId)));
      };
    }

    _readers.chart = (personId) => {
      const load = _originalPersonChart || _api.getPersonChart;
      if (typeof load !== "function") return Promise.reject(new Error('GHD.store: no reader for "chart"'));
      return load.call(_api, personId);
    };

    Object.entries(_INVALIDATES).forEach(([method, keys]) => {
      _wrapApi(method, (promise) =>
        promise.then((value) => {
          // A deleted account has nothing left to read again.
          if (method === "deleteAccount") _drop(keys);
          else GHD.store.invalidate(...keys);
          return value;
        }),
      );
    });
  }
  GHD.store = {
    /* Adopt the API client and wrap its methods. Must stay idempotent: wrapping
       twice would run every cache-write and invalidate twice per call. */
    init(api) {
      if (!api || api === _api) return;
      _api = api;
      _wireApi();
    },

    people: () => _read("people"),
    groups: () => _read("groups"),
    subscription: () => _read("subscription"),
    llmSettings: () => _read("llmSettings"),
    conversations: () => _read("conversations"),
    quota: () => _read("quota"),
    /** One saved person's chart, shared by the person page, the PDF export and
     *  every chat card that names them. Invalidated by any people write, which
     *  is what stops a card showing the chart from before a birth-time edit. */
    chart: (personId) => {
      const key = `chart:${personId}`;
      if (!_chartReader || _bucket().has(key)) return _read(key, personId);
      const owner = _cacheUserId;
      let tracked;
      const current = () => (_bucket(), _cacheUserId === owner && _cache.get(key) === tracked);
      tracked = _put(
        key,
        _chartReader(personId, {
          values: _values,
          load: () => _readers.chart(personId),
          current,
          // After the copy has been recorded: a network answer that beats the
          // Cache Storage read must not be overwritten by the copy it replaces.
          changed: (fresh) =>
            tracked.then(() => {
              if (!current()) return;
              _cache.set(key, Promise.resolve(fresh));
              _record(key, fresh);
            }),
        }),
      );
      return tracked;
    },
    _setChartReader(fn) {
      _chartReader = fn;
    },

    /* People and subscription together, as every list page needs them; a failure
       on either side is an empty roster / an unknown plan rather than a page
       that never renders. */
    peopleAndSub() {
      return Promise.allSettled([this.people(), this.subscription()]).then(([people, sub]) => ({
        people: people.status === "fulfilled" ? people.value || [] : [],
        sub: sub.status === "fulfilled" ? sub.value || null : null,
      }));
    },

    /** Is this account on Pro? The one predicate — see rule 3. Anchored on the
     *  entitlement mirror; a read that fails falls back to the last answer. */
    isPro() {
      return this.subscription().then(
        (sub) => sub?.plan === "pro",
        () => this.isProNow(),
      );
    },

    /** The same answer for a synchronous render path. False until the first
     *  subscription or quota read lands, which the shell does on every page. */
    isProNow: () => _now(PLAN) === "pro",

    /** The last known plan, or null while no read has landed yet. Callers that
     *  hand the plan to something else (the Advanced panel) need the string;
     *  everything that only asks "is this Pro" wants isPro/isProNow. */
    plan: () => _now(PLAN) || null,

    /** The two lists a synchronous render reads, empty until the first read
     *  lands. Both stay readable across an invalidate — see below. */
    peopleNow: () => _now("people") || [],
    conversationsNow: () => _now("conversations") || [],

    /* The account holder's own person row, or null. Their name lives only here.
       Null is ordinary: an MCP account without birth data has no me-person. */
    mePersonNow: () => (_now("people") || []).find((p) => p.is_me) || null,

    /* What the last read of `key` settled on, or null while none has landed. */
    settled: (key) => _now(key) ?? null,

    /** Whether `key`'s value is still the snapshot from an earlier visit. */
    stale: (key) => (_bucket(), _stale.has(key)),

    /** Forget the snapshot: sign-out, a dev preset, anything that ends this
     *  account's data on this device. */
    wipe() {
      _snapshot = {};
      try {
        localStorage.removeItem(SNAPSHOT_KEY);
      } catch {}
      // Inline rather than GHD.apiCache.clear(): the helper rides route chunks,
      // and a lapsed session can be wiped on a page that never loaded one.
      try {
        if (typeof caches !== "undefined") return caches.delete("ghd-api-v1").catch(() => {});
      } catch {}
    },

    /**
     * Seed a key with a value already in hand — a response fetched straight
     * through Api, or a test's fixture. The next read answers with it.
     */
    prime(key, value) {
      _record(key, value);
      _bucket().set(key, Promise.resolve(value));
      return value;
    },

    /* Drop the named keys; the next read refetches. "charts" drops every chart.
       Only the cached promise goes: the last value stays so a render between the
       mutation and the refetch still has something to paint. A key in
       _REREAD_WHEN_WATCHED that something is watching is read again at once, so
       its onChange fires without waiting for some page to ask. */
    invalidate(...keys) {
      _drop(keys);
      keys.forEach((key) => {
        if (_REREAD_WHEN_WATCHED.has(key) && _listeners.get(key)?.size) _read(key).catch(() => {});
      });
    },

    /* Call `fn` when one of `keys` gets a new value; returns the unsubscribe.
       "plan" fires only on an actual change of plan. */
    onChange(keys, fn) {
      const wanted = Array.isArray(keys) ? keys : [keys];
      wanted.forEach((key) => {
        if (!_listeners.has(key)) _listeners.set(key, new Set());
        _listeners.get(key).add(fn);
      });
      return () => wanted.forEach((key) => _listeners.get(key)?.delete(fn));
    },
  };
})();

;
/* dashboard/js/chat-turn.js */
/**
 * GHD.chatTurn — the assistant turn, held outside the page that started it.
 *
 * The chat page's markup is thrown away on every route change, and aborting the
 * request with it truncated replies mid-word. The model call is already paid
 * for and the backend saves the turn itself, so the turn lives here instead,
 * session-scoped like GHD.store. It holds the AbortController (Stop still
 * stops) and everything produced so far, which is the only copy until the turn
 * ends and is what the page replays when the reader comes back mid-answer.
 *
 * The page attaches a sink while mounted; a turn with no sink is unobserved,
 * not paused. A private chat never goes to the background (`background:
 * false`). A turn whose socket dropped keeps *finishing*: the stream client
 * polls the stored transcript (`Chat._awaitStoredReply`), and a returning
 * reader rejoins that too.
 *
 * Load order: after storage-keys.js (chatLastConv), before the chat modules.
 */
(function () {
  window.GHD = window.GHD || {};

  /** Turns whose stream is still running. Released the moment it ends. */
  const _live = new Set();
  /** The one turn the mounted chat view is showing, if any. */
  let _attached = null;
  /* Finished turns whose rows have not been seen in a transcript yet, by
   * conversation. The backend writes the turn only after `done`, so the record
   * is held until `forget` (a transcript read proves the rows landed); per
   * conversation, since two background turns can be waiting at once. */
  const _unconfirmed = new Map();
  // A session-length backstop for conversations the reader never opens again.
  // Nothing depends on the number; it only stops an unbounded hold.
  const MAX_UNCONFIRMED = 8;

  /* Ordering for "which chat does /chat open next" (GHD.KEYS.chatLastConv).
   * Every claim carries the tick it was made at and a later claim wins, so a
   * slow turn adopting its conversation late loses to anything done since. */
  let _tick = 0;
  let _claimedAt = 0;

  function _claimLastConversation(id, at) {
    if (at < _claimedAt) return;
    _claimedAt = at;
    // Storage denied — the sidebar and the URL still carry the id.
    GHD.storage.set(GHD.KEYS.chatLastConv, id);
  }

  function _emit(turn, name, payload) {
    const handler = turn.sink && turn.sink[name];
    if (typeof handler !== "function") return;
    try {
      handler(payload);
    } catch (error) {
      // A sink is view code. A view that throws must not take the stream down
      // with it — losing the reply is the whole failure this module exists to
      // prevent, and the turn is still being saved server-side either way.
      console.error("chatTurn: sink." + name + " failed", error);
    }
  }

  GHD.chatTurn = {
    /**
     * Start recording a turn. `controller` is the one aborting it; `question`
     * is the user's own text, which lives nowhere else until the turn ends.
     */
    begin(spec) {
      const turn = {
        question: spec.question || "",
        conversationId: spec.conversationId || null,
        background: spec.background !== false,
        controller: spec.controller || null,
        sink: null,
        /** When this turn started, for ordering claims on chatLastConv. */
        tick: ++_tick,
        /* The response headers are back, so the server has the message: quota
         * counted, a new chat's conversation created. Only from here may the
         * waiting pill say the message is saved. */
        received: false,

        // ── What the turn has produced ────────────────────────────────────
        // The first three are also the stream state the chat page reads once
        // the turn ends, which is why they keep those names.
        fullContent: spec.fullContent || "",
        privateHistory: null,
        /** The compaction state a private turn folded, off `done` — {summary,
         *  through, at}. Null on every persisted turn and on every private turn
         *  that did not fold, which means "keep the state you have". */
        privateSummary: null,
        completedCleanly: false,
        /** The server ended the turn with an `error` event: it dropped the turn
         *  itself, so there is nothing for it to keep generating. */
        failed: false,
        /* The socket dropped mid-reply and the backend is finishing it on
         * its own; the stream client is polling for it (`markFinishing`). Off
         * again once the poll ends, however it ends. */
        finishing: false,
        /* The whole stored transcript, once a poll found this turn's rows in it.
         * The view rebuilds from these, not from what it streamed. */
        storedRows: null,
        /** The name a first turn gave its chat, off `done`. Null on every other turn. */
        title: null,
        /** What the conversation still has room for once this turn is counted,
         *  off `done` — the same object GET …/mention_budget answers with, so
         *  the @-mention picker refreshes without a second request. Null on a
         *  private turn, which has no conversation to have a budget. */
        mentionBudget: null,
        /** Tool results in arrival order, as the SSE payloads came in. */
        toolResults: [],
        /** The tool running right now (`{tool, args}`), or null. */
        activeTool: null,
        /* The backend has content it will save for this turn: a token or a
         * tool round. Before that it persists nothing, so `release` does not
         * hold a turn that ends here. It does not decide whether to abort. */
        persisted: Boolean(spec.fullContent),
        finished: false,
        /* The first-journey card, drawn at the foot of the transcript
         * once a turn ends, has been drawn. It is not in the stored rows, so a
         * turn carries it until a transcript exists; this prevents a second draw. */
        cardsSettled: false,

        attach(sink) {
          // One view, one attached turn. Nothing should be able to attach a
          // second without releasing the first, but a stray sink writing into a
          // transcript that has moved on is the failure mode worth ruling out.
          if (_attached && _attached !== turn) _attached.detach();
          turn.sink = sink;
          _attached = turn;
        },

        /** Drop the view's hold on the turn and hand its sink back. */
        detach() {
          const sink = turn.sink;
          turn.sink = null;
          if (_attached === turn) _attached = null;
          return sink;
        },

        adoptConversation(conv) {
          turn.conversationId = conv.id;
          // Nothing has been written to it yet, so it is this turn's to lose:
          // if the turn ends with nothing saved the backend deletes the row,
          // and whoever cleans up needs the id to stop pointing at it.
          //
          // Recorded here rather than only on the page, because the page may
          // already have stopped watching — this event is the first thing the
          // stream sends, but a reader can leave before it lands, and a turn
          // whose id arrived after the detach used to file its question under a
          // conversation that no longer existed. Cleared by `_settle`.
          turn.unconfirmedConversationId = conv.id;
          // Claimed here rather than only in the view's handler: a conversation
          // the backend creates for a turn nobody is watching is still the chat
          // the reader comes back to, and this key is where /chat looks for it.
          // Under the turn's own tick, so a late adoption cannot pull them back
          // out of a chat they opened or started in the meantime.
          _claimLastConversation(conv.id, turn.tick);
          _emit(turn, "onConversation", conv);
        },

        /* The response headers are back: the server has the message. Set on
         * the turn, not the pill: the reader may have left and rejoined, and the
         * pill on screen now is a different one. */
        markReceived() {
          turn.received = true;
          _emit(turn, "onReceived");
        },

        /* The backend now has something it will save for this turn. */
        _settle() {
          turn.persisted = true;
          turn.unsentQuestion = null;
          turn.unconfirmedConversationId = null;
        },

        appendText(delta) {
          turn.fullContent += delta;
          turn._settle();
          _emit(turn, "onText", turn.fullContent);
        },

        startTool(call) {
          turn.activeTool = call;
          turn._settle();
          _emit(turn, "onToolStart", call);
        },

        addToolResult(result) {
          turn.activeTool = null;
          turn.toolResults.push(result);
          _emit(turn, "onToolResult", result);
        },

        /** A failure with a `code` ("provider_busy") is not a toast: the view
         *  reads `failCode` once the turn has ended and shows its own notice. */
        fail(message, code = null) {
          turn.failed = true;
          turn.failCode = code;
          if (!code) _emit(turn, "onError", message);
        },

        /** The socket went mid-reply; the backend is finishing the reply itself. */
        markFinishing() {
          turn.finishing = true;
          _emit(turn, "onFinishing");
        },

        /* The poll found this turn on file. `fullContent` is every assistant row
         * concatenated; `truncated` means the server gave up rather than
         * finished. Settles the turn like a token would, and emits the stored
         * text so a watching view shows what is on file. */
        settleStored({ fullContent, rows, truncated }) {
          turn.finishing = false;
          turn.fullContent = fullContent;
          turn.storedRows = rows;
          turn.completedCleanly = !truncated;
          turn._settle();
          _emit(turn, "onText", turn.fullContent);
        },

        /** The server's `done` receipt: the turn was persisted whole. */
        complete(payload) {
          turn.completedCleanly = true;
          // `done` is the receipt, so it settles the turn even when no token and
          // no tool round ever did. A reply that comes back empty still leaves
          // the backend holding an assistant row and the conversation it was
          // written to — so without this the turn would end owing a question it
          // does not owe, and a reader who had walked away would find it back in
          // the composer with `chatLastConv` cleared off a chat that still
          // exists.
          turn._settle();
          if (Array.isArray(payload.history)) turn.privateHistory = payload.history;
          // All three or none: the backend sends them together, and half a state
          // cannot say what it covers (backend PrivateChatRequest.compaction_state).
          if (typeof payload.summary === "string" && Number.isInteger(payload.summary_through)) {
            turn.privateSummary = {
              summary: payload.summary,
              through: payload.summary_through,
              at: payload.summary_at || null,
            };
          }
          // Present only on the turn that names a new chat. Kept on the turn
          // rather than handed straight to the sidebar: the reader may have
          // walked off the chat page, and the list refetch that needs this runs
          // after the turn ends either way.
          if (payload.title) turn.title = payload.title;
          // Absent rather than empty is "this backend does not send one", not
          // "there is no room left" — so a missing field leaves whatever the
          // picker already holds standing rather than greying on a guess.
          if (payload.mention_budget) turn.mentionBudget = payload.mention_budget;
          GHD.playReview?.noteReply(turn.fullContent, payload);
        },
      };
      if (turn.background) _live.add(turn);
      return turn;
    },

    /** The turn's stream has ended, cleanly or not. */
    release(turn) {
      turn.finished = true;
      _live.delete(turn);
      // Every turn ends here, whichever path wrote it: the install promo
      // (pwa.js) waits for this.
      try {
        if (typeof window !== "undefined" && window.__pwaOnTurnEnd) window.__pwaOnTurnEnd();
      } catch (_e) {
        /* the install promo is never worth the turn it rides on */
      }
      // A turn with nothing persisted is not held: the backend drops that one
      // outright — conversation row included — so there is nothing for a
      // transcript to be missing.
      if (!turn.background || !turn.persisted || !turn.conversationId) return;
      _unconfirmed.set(turn.conversationId, turn);
      if (_unconfirmed.size > MAX_UNCONFIRMED) {
        _unconfirmed.delete(_unconfirmed.keys().next().value);
      }
    },

    /** A finished turn for `conversationId` whose rows may not have landed yet. */
    lastFinished(conversationId) {
      return (conversationId && _unconfirmed.get(conversationId)) || null;
    },

    /** Its rows are in a transcript; the database is the copy of record now. */
    forget(turn) {
      if (_unconfirmed.get(turn.conversationId) === turn) _unconfirmed.delete(turn.conversationId);
    },

    /* The conversation is being deleted: stop writing to it, and let go.
     * Returns the aborted turn, if any, so the caller can restore its composer. */
    discard(conversationId) {
      const held = this.lastFinished(conversationId);
      if (held) this.forget(held);
      const turn = this.find(conversationId);
      if (!turn) return null;
      turn.detach();
      // The question goes with the conversation. Its stored draft has just been
      // pruned along with every other key for this chat, and the turn's ending
      // is still to come — without this it would run after the delete and file
      // the question straight back under an id nothing can open again.
      turn.unsentQuestion = null;
      turn.unconfirmedConversationId = null;
      turn.controller?.abort();
      this.release(turn);
      this.forget(turn);
      return turn;
    },

    /* The reader opened this conversation, so it is the one /chat opens next.
     * Through the tick, so it outranks a running turn's late adoption. */
    claimLastConversation(id) {
      _claimLastConversation(id, ++_tick);
    },

    /* The reader asked for a blank chat, so /chat opens one next. A tombstone
     * that takes a tick, not a bare remove, so an older turn cannot put its id
     * back afterwards. */
    forgetLastConversation() {
      _claimedAt = ++_tick;
      GHD.storage.remove(GHD.KEYS.chatLastConv);
    },

    /** The turn the mounted chat view is showing, or null. */
    attached() {
      return _attached;
    },

    /** The turn still being written for `conversationId`, or null. */
    find(conversationId) {
      if (!conversationId) return null;
      for (const turn of _live) {
        if (turn.conversationId === conversationId) return turn;
      }
      return null;
    },

    /* The conversation a turn of ours asking *question* has adopted, or null.
     * Used when the backend refuses a duplicate: matching on the question is
     * exact, where "a row that appeared after" could be another tab's chat.
     * Unconfirmed finished turns count; a turn with no conversation does not. */
    answeringConversation(question) {
      if (!question) return null;
      for (const turn of [..._live, ..._unconfirmed.values()]) {
        if (turn.conversationId && turn.question === question) return turn.conversationId;
      }
      return null;
    },

    /* Whether a turn is out there creating a conversation of its own. */
    isStartingConversation() {
      for (const turn of _live) {
        if (!turn.conversationId) return true;
      }
      return false;
    },

    /* Whether a reply is still being written — for `conversationId`, or
     * anywhere when called with no argument. Background turns only (never a
     * private chat); a turn being finished server-side counts until its poll ends. */
    isLive(conversationId) {
      if (conversationId === undefined) return _live.size > 0;
      return Boolean(this.find(conversationId));
    },

    /* Whether a reply is being written anywhere at all, background or not.
     * The SW update reload and the language switch ask before discarding the
     * document, which is the one thing that still kills a turn. */
    isSending() {
      return _live.size > 0 || Boolean(_attached && !_attached.finished);
    },
  };
})();

;
/* dashboard/js/app-shell.js */
/**
 * App shell — the chrome every signed-in page renders inside: rail, sidebar,
 * mobile header, tab bar and FAB. Pages use `AppShell.render(mainHtml, opts)`;
 * the chat page builds it with `_buildShellHtml` + `_initShell`.
 *
 * Values more than one surface renders (plan, conversation list, roster) live in
 * GHD.store and the shell subscribes to them. The only dependency on the chat
 * page is the conversation rows' open/rename/delete, reached via `_chatPage()`
 * so this file still loads on its own.
 *
 * Load order: BEFORE chat.js, which reads `AppShell` at render time.
 */

// Read by the shell only: the *desktop* column preference, deliberately not
// rewritten by mobile drawer gestures.
// The sidebar open/closed preference lives in GHD.KEYS.chatSidebar.
const CHAT_SIDEBAR_KEY = GHD.KEYS.chatSidebar;

// The hamburger, and the same glyph as the sidebar's close button. Declared
// here rather than in chat.js because the shell is what draws it in three
// places; the chat page's conversation header borrows it for its own toggle.
const _SIDEBAR_ICON =
  '<svg viewBox="0 0 24 24"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';

/* The chat page module, when it is loaded. Owns the conversation rows' actions
   and the quota footer; optional because a unit sandbox loads this file alone. */
function _chatPage() {
  return window.Chat || null;
}

const _SETTINGS_ICON =
  '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>';
const _ALL_CHATS_ICON =
  '<svg viewBox="0 0 24 24"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>';
/* The shared glyph without its search-box positioning class. */
const _SEARCH_ICON = GHD.icon("search", { class: null });

const _KB_ICON = GHD.icons.book;

const _FEEDBACK_ICON =
  '<svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></svg>';

/* Build mobile app header HTML for non-chat pages: a sticky 48px title bar. */
function _mobileAppHeader(title, { actionsHtml = "" } = {}) {
  // A page's one control can ride at the bar's right end (the transits page
  // puts its person picker there), so the page does not need a second title
  // row of its own under this one.
  const actions = actionsHtml ? `<div class="mobile-app-header-actions">${actionsHtml}</div>` : "";
  return `
    <div class="mobile-app-header" id="mobileAppHeader">
      <button class="mobile-app-header-btn" id="chatMobileToggle" title="${t("chat.conversations")}">${_SIDEBAR_ICON}</button>
      <h1 class="mobile-app-header-title">${title}</h1>${actions}
    </div>`;
}

// ── Mobile bottom tab bar (< 768px) ─────────────────────────────────────
//
// Four tabs — Chat, People, Transits, Settings — rendered by the shell on every page
// that passes an `activeRail`/`activeTab` to `AppShell.render`. The chat
// conversation page (/chat) deliberately has no tab bar: its composer is
// in-flow at the bottom of the viewport and already owns the safe area.

const _TAB_SETTINGS_ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/><line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/></svg>';
/** The FAB's plus is the shared one at the shell's 2px stroke; .mobile-fab svg
 *  sizes it. The rail and sidebar buttons take GHD.icons.plus unchanged — the
 *  "icon canon" block in css/shell.css sets their fill, stroke and box, and CSS
 *  beats every presentation attribute the glyph carries. */
const _FAB_PLUS_ICON = GHD.icon("plus", { "stroke-width": "2" });

/* Which tab lights up for a given shell `activeRail`. */
const MOBILE_TAB_BY_RAIL = {
  "/chat": "chat",
  "/chats": "chat",
  "/people": "people",
  "/transits": "transits",
  "/settings": "settings",
};

function _mobileTabBar(activeTab) {
  const tabs = [
    { key: "chat", href: GHD.router.href("/chat"), label: t("app.tab_chat"), icon: GHD.icons.messageCircle },
    { key: "people", href: GHD.router.href("/people"), label: t("app.tab_people"), icon: GHD.icons.users },
    { key: "transits", href: GHD.router.href("/transits"), label: t("app.tab_transits"), icon: GHD.icons.sun },
    { key: "settings", href: GHD.router.href("/settings"), label: t("app.tab_settings"), icon: _TAB_SETTINGS_ICON },
  ];
  const items = tabs
    .map(
      (tab) => `
      <a class="mobile-tab${tab.key === activeTab ? " mobile-tab-active" : ""}" href="${tab.href}"
         data-tab="${tab.key}"${tab.key === activeTab ? ' aria-current="page"' : ""}>
        ${tab.icon}
        <span class="mobile-tab-label">${tab.label}</span>
      </a>`,
    )
    .join("");
  return `<nav class="mobile-tabbar" id="mobileTabBar" aria-label="${t("app.tab_nav_label")}">${items}</nav>`;
}

/** Per-page floating action button, shown above the tab bar on mobile only. */
function _mobileFab(label) {
  return `<button class="mobile-fab" id="mobileFab" type="button" title="${label}" aria-label="${label}">${_FAB_PLUS_ICON}</button>`;
}

const AppShell = {
  /** The hamburger, for the chat page's own conversation-header toggle. */
  SIDEBAR_ICON: _SIDEBAR_ICON,

  /* The signed-in user's first name, or the local-part of their email. */
  _userName: null,
  /** The window-level keyboard handler installed by `_initShell`. */
  _keyHandler: null,
  /** Unsubscribes this shell from GHD.store; replaced on every render. */
  _storeUnsubscribe: null,
  /** What a click on a sidebar conversation row does — the chat page swaps in
   *  its own in-place select; every other page navigates. */
  _onConvClick: null,
  /** Resolves when the shell's own loads are in — see `_startShellData`. */
  _shellDataReady: null,

  /** The initial in the rail avatar and the user card. */
  _getUserInitial() {
    return (this._userName || App._session?.user?.email || "U").charAt(0).toUpperCase();
  },

  // ── Shell HTML builder (shared with Chats page) ─────────────────────────

  _buildShellHtml(mainHtml, { activeTab = null, fab = null } = {}) {
    // The stored value is the *desktop* column preference. On mobile the same
    // markup is a drawer over the page, so restoring it "open" would hand the
    // user a scrim-covered page on first paint — never restore it there.
    const sidebarOpen = GHD.storage.get(CHAT_SIDEBAR_KEY) === "open" && !GHD.platform.isPhoneLayout();
    // On a cold load the store may already hold last visit's roster.
    this._userName ||= GHD.names?.first(GHD.store.mePersonNow()?.name) || null;
    const userInitial = this._getUserInitial();
    // The name is app-lifetime state and the plan lives in GHD.store for the
    // session, so a second shell paints the user card complete instead of
    // letting the badge and the Pro ring pop in behind the loads below. Same
    // markup _paintPlan writes — on the first shell of a session the plan is
    // still unknown and that call fills it in.
    const plan = GHD.store.plan();
    const isPro = GHD.store.isProNow();
    const planLabel = plan ? (isPro ? t("chat.plan_pro") : t("chat.plan_free")) : "";
    const planClass = plan ? ` ${isPro ? "badge-pro" : "badge-free"}` : "";
    // Bottom-anchored chrome outside the shell (the toast) has to clear the
    // tab bar, so mark the document while it is on screen.
    document.body.classList.toggle("ghd-has-tabbar", Boolean(activeTab));
    // The rail's controls show nothing but a glyph: the tooltip is CSS over
    // `data-tip`, which a screen reader never sees, so the same sentence is the
    // accessible name too.
    const mod = GHD.modKey();
    const kbHref = GHD.kb.href("/docs/");
    const tips = {
      sidebar: t("chat.tip_sidebar", { mod }),
      newChat: t("chat.tip_new_chat", { mod }),
      searchChats: t("chat.tip_search_chats", { mod }),
      people: t("chat.tip_people_groups"),
      transits: t("chat.tip_transits"),
      kb: t("kb.title"),
      settings: t("chat.tip_settings"),
    };
    return `
      <div class="chat-page${sidebarOpen ? " sidebar-open" : ""}" id="chatPage">
        <div class="chat-rail" id="chatRail">
          <div class="chat-rail-top">
            <button class="chat-rail-btn chat-rail-tip" id="chatSidebarToggle" data-tip="${tips.sidebar}" aria-label="${tips.sidebar}">
              ${_SIDEBAR_ICON}
            </button>
            <button class="chat-rail-btn chat-rail-tip" id="chatNewBtn" data-tip="${tips.newChat}" aria-label="${tips.newChat}">
              ${GHD.icons.plus}
            </button>
            <a class="chat-rail-btn chat-rail-tip" href="${GHD.router.href("/chats?search")}" data-rail="/chats" data-tip="${tips.searchChats}" aria-label="${tips.searchChats}">${_SEARCH_ICON}</a>
            <a class="chat-rail-btn chat-rail-tip" href="${GHD.router.href("/people")}" data-tip="${tips.people}" aria-label="${tips.people}">
              ${GHD.icons.users}
            </a>
            <a class="chat-rail-btn chat-rail-tip" href="${GHD.router.href("/transits")}" data-tip="${tips.transits}" aria-label="${tips.transits}">
              ${GHD.icons.sun}
            </a>
            <a class="chat-rail-btn chat-rail-tip" href="${kbHref}" id="chatRailKb" data-tip="${tips.kb}" aria-label="${tips.kb}">${_KB_ICON}</a>
          </div>
          <div class="chat-rail-bottom">
            <a class="chat-rail-btn chat-rail-tip" href="${GHD.router.href("/settings")}" data-tip="${tips.settings}" aria-label="${tips.settings}">${_SETTINGS_ICON}</a>
            <button class="chat-rail-avatar${isPro ? " chat-user-pro" : ""}" id="chatAvatarBtn" title="${t("chat.menu")}">${userInitial}</button>
          </div>
        </div>
        <div class="chat-drawer-overlay${sidebarOpen ? "" : " hidden"}" id="chatDrawerOverlay"></div>
        <aside class="chat-sidebar" id="chatSidebar">
          <div class="chat-sidebar-header">
            <a href="${GHD.router.href("/")}" class="chat-sidebar-logo" title="${t("chat.home")}">
              ${typeof logoWithTextSVG === "function" ? logoWithTextSVG({ height: 34 }) : ""}
            </a>
            <button class="chat-sidebar-close" id="chatSidebarClose" title="${t("chat.close")}">
              ${_SIDEBAR_ICON}
            </button>
          </div>
          <nav class="chat-sidebar-menu chat-sidebar-nav">
            <button class="chat-sidebar-menu-item chat-sidebar-new" id="chatNewBtnSidebar">${GHD.icons.plus} ${t("chat.new_chat")}</button>
            <a class="chat-sidebar-menu-item" id="chatNewPersonSidebar" href="${GHD.router.href("/people/new")}">${GHD.icons.userPlus} ${t("people.add_person")}</a>
            <a class="chat-sidebar-menu-item" href="${GHD.router.href("/chats?search")}">${_SEARCH_ICON} ${t("chats.search_label")}</a>
          </nav>
          <div class="chat-conv-label">${t("chat.recent")}</div>
          <div class="chat-conv-list" id="chatConvList"></div>
          <div class="chat-sidebar-footer">
            <div class="chat-sidebar-menu">
              <a class="chat-sidebar-menu-item" href="${GHD.router.href("/people")}">${GHD.icons.users} ${t("chat.people_groups")}</a>
              <a class="chat-sidebar-menu-item" href="${GHD.router.href("/transits")}">${GHD.icons.sun} ${t("chat.transits")}</a>
              <a class="chat-sidebar-menu-item" href="${kbHref}" id="chatSidebarKb">${_KB_ICON} ${t("kb.title")}</a>
              <button class="chat-sidebar-menu-item" id="chatSidebarFeedback">${_FEEDBACK_ICON} ${t("chat.feedback")}</button>
            </div>
            <div class="chat-sidebar-user-card${isPro ? " chat-user-pro" : ""}" id="chatSidebarUserCard" role="button" tabindex="0" title="${t("chat.settings")}">
              <span class="chat-sidebar-user-avatar" id="chatSidebarAvatar">${userInitial}</span>
              <div class="chat-sidebar-user-info">
                <div class="chat-sidebar-user-name-row">
                  <span class="chat-sidebar-user-name" id="chatSidebarUserName">${GHD.escapeHtml(this._userName || "")}</span>
                  <span class="plan-badge${planClass}" id="chatSidebarBadge">${planLabel}</span>
                </div>
                <span class="chat-sidebar-user-email" id="chatSidebarUserEmail">${GHD.escapeHtml(App._session?.user?.email || "")}</span>
              </div>
              ${
                // Only in a browser tab: inside the Play Store app (TWA) or an
                // installed PWA there is nothing left to download.
                GHD.platform.surface === "web"
                  ? `<button class="chat-sidebar-user-dl" id="chatSidebarDownload" title="${t("chat.download_app")}" aria-label="${t("chat.download_app")}">
                <svg viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              </button>`
                  : ""
              }
            </div>
          </div>
        </aside>
        <div class="chat-main" id="chatMain">
          ${mainHtml}
        </div>
        ${fab ? _mobileFab(fab.label) : ""}
        ${activeTab ? _mobileTabBar(activeTab) : ""}
      </div>
    `;
  },

  // ── Shell init (shared with Chats page) ────────────────────────────────

  _initShell(onNewChat) {
    // One subscription per shell, replacing the last one: all three of these can
    // move while a page is open — a checkout settling, a dev preset, a reply
    // finishing in the background, the shell's own group read landing — and
    // every signal below belongs to markup this call has just replaced.
    this._storeUnsubscribe?.();
    this._storeUnsubscribe = GHD.store.onChange(["plan", "conversations", "groups", "people"], (key) => {
      if (key === "plan") this._paintPlan();
      // The user card says the me-person's first name, which a rename moves.
      else if (key === "people") this._paintUserName();
      // A transcript can finish rebuilding before the Pro-only group list has,
      // leaving an ad-hoc group card offering to save a group that already
      // exists — the same race the upgrade card runs with the plan.
      else if (key === "groups") _chatPage()?._resolveTranscriptGroupCards?.();
      else this._renderConversationList();
    });

    const toggleSidebar = () => {
      const page = document.getElementById("chatPage");
      const opening = !page.classList.contains("sidebar-open");
      page.classList.toggle("sidebar-open", opening);
      document.getElementById("chatDrawerOverlay").classList.toggle("hidden", !opening);
      // Persist the desktop column state only: opening/closing the mobile
      // drawer is a per-view gesture and must not rewrite the preference the
      // desktop shell restores from (see _buildShellHtml).
      if (!GHD.platform.isPhoneLayout()) GHD.storage.set(CHAT_SIDEBAR_KEY, opening ? "open" : "closed");
    };

    document.getElementById("chatNewBtn").addEventListener("click", onNewChat);
    document.getElementById("chatNewBtnSidebar").addEventListener("click", () => {
      this._closeSidebarOnMobile();
      onNewChat();
    });

    // The knowledge base's front page, in the panel every other KB link opens.
    // The panel is a route chunk the current page may not have loaded, so the
    // click waits for it; any failure falls through to the page itself.
    for (const link of [document.getElementById("chatRailKb"), document.getElementById("chatSidebarKb")]) {
      link.addEventListener("click", (e) => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        const go = () => (window.location.href = link.href);
        GHD.loadRoute("kb").then(() => {
          if (!window.KbPanel || !KbPanel.open(link.href, { source: "nav" })) go();
        }, go);
      });
    }

    document
      .getElementById("chatSidebarFeedback")
      .addEventListener("click", () =>
        GHD.loadRoute("feedback").then(() => this._openFeedbackModal(), GHD.reportError),
      );

    // Absent inside the TWA / installed PWA (not rendered — see the shell
    // template); on desktop it opens a QR code that sends the user to their phone.
    // Sits inside the user card, whose own click goes to settings — stop the bubble.
    const dlBtn = document.getElementById("chatSidebarDownload");
    dlBtn?.addEventListener("click", (e) => {
      e.stopPropagation();
      this._closeSidebarOnMobile();
      if (!GHD.platform.isPhoneLayout() && window.__pwaShowQrModal) {
        window.__pwaShowQrModal();
      } else if (window.__pwaShowBanner) {
        window.__pwaShowBanner({ force: true });
      } else {
        let msg;
        if (GHD.platform.isIOS && window.GHD_APP?.APP_STORE_LIVE && GHD_APP.APP_STORE_URL) {
          window.open(GHD_APP.APP_STORE_URL, "_blank", "noopener");
          return;
        } else if (GHD.platform.isIOS) {
          // Until the App Store launch (GHD_APP.APP_STORE_LIVE): Add to Home Screen.
          msg = t("chat.install_ios");
        } else if (GHD.platform.isFirefox) {
          msg = t("chat.install_firefox");
        } else {
          msg = t("chat.install_other");
        }
        GHD.toast(msg, "status");
      }
    });

    document.getElementById("chatSidebarToggle").addEventListener("click", toggleSidebar);
    document.getElementById("chatMobileToggle")?.addEventListener("click", toggleSidebar);
    document.getElementById("chatSidebarClose").addEventListener("click", () => this._closeSidebar());
    document.getElementById("chatDrawerOverlay").addEventListener("click", () => this._closeSidebar());

    // Close the mobile drawer when any navigation link inside it is clicked;
    // on desktop the sidebar is an in-flow column and stays open across pages.
    document.getElementById("chatSidebar").addEventListener("click", (e) => {
      if (e.target.closest("a[href]")) this._closeSidebarOnMobile();
    });
    // The user card is the door to settings (keyboard-operable: role=button).
    const userCard = document.getElementById("chatSidebarUserCard");
    const openSettings = () => {
      this._closeSidebarOnMobile();
      App.navigate("/settings");
    };
    userCard.addEventListener("click", openSettings);
    userCard.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openSettings();
      }
    });
    document.getElementById("chatAvatarBtn").addEventListener("click", toggleSidebar);
    document.getElementById("chatRail").addEventListener("click", (e) => {
      if (e.target === e.currentTarget) toggleSidebar();
    });

    // The previous shell's handler first: this file installs one per render and
    // only the chat page ever used to take one back down, so navigating between
    // the list pages stacked a fresh handler on every visit and one Cmd+. then
    // toggled the sidebar as many times as the reader had been there.
    this._removeKeyHandler();
    this._keyHandler = (e) => {
      // Escape dismisses only the topmost UI layer. The knowledge-base panel
      // handles the event at document level first and prevents its default;
      // respect that signal so one press does not close both sidebars.
      if (e.key === "Escape") {
        const page = document.getElementById("chatPage");
        if (!e.defaultPrevented && !GHD.platform.isPhoneLayout() && page?.classList.contains("sidebar-open")) {
          e.preventDefault();
          this._closeSidebar();
        }
        return;
      }

      const mod = GHD.platform.isApple ? e.metaKey : e.ctrlKey;
      if (!mod) return;
      if (e.key === ".") {
        e.preventDefault();
        document.getElementById("chatSidebarToggle")?.click();
      }
      if (e.shiftKey && e.key.toLowerCase() === "o") {
        e.preventDefault();
        onNewChat();
      }
      if (e.key.toLowerCase() === "k" && !e.shiftKey) {
        e.preventDefault();
        const box = document.getElementById("chatsSearch");
        if (box) box.select();
        else App.navigate("/chats?search");
      }
      if (e.key === "c" && !e.shiftKey && window.getSelection()?.toString() === "") {
        e.preventDefault();
        App.navigate("/chats");
      }
    };
    window.addEventListener("keydown", this._keyHandler);

    if (GHD.store.settled("conversations")) this._renderConversationList();
  },

  // ── Shell render for a page ───────────────────────────────────────────

  /**
   * Render the shell (rail + sidebar + mobile tab bar) around a page's markup.
   *
   * opts: activeRail, activeTab (defaults via MOBILE_TAB_BY_RAIL), tabBar
   * (false drops the tab bar for a page that is a step, not a place), fab
   * ({ label, onClick }), conversations (an already-fetched list to adopt).
   *
   * Replaces all of `#main` unconditionally. A page that awaits anything before
   * calling it must first check its visit is still the one on screen (a counter
   * bumped in `cleanup()`, as `Compare._renderToken`), or a late fetch paints
   * over the route the reader moved to.
   */
  async render(mainHtml, opts = {}) {
    const main = document.getElementById("main");
    App._busy?.(false);
    main.classList.add("chat-active");
    this._onConvClick = opts.onConvClick || ((id) => App.navigate("/chat?conv=" + encodeURIComponent(id)));
    const activeTab = opts.tabBar === false ? null : opts.activeTab || MOBILE_TAB_BY_RAIL[opts.activeRail] || null;
    main.innerHTML = this._buildShellHtml(mainHtml, { activeTab, fab: opts.fab || null });
    this._initShell(opts.onNewChat || (() => App.navigate("/chat?new")));

    // Highlight active rail button
    if (opts.activeRail) {
      document
        .querySelector(
          `a.chat-rail-btn[data-rail="${opts.activeRail}"], a.chat-rail-btn[href="${GHD.router.href(opts.activeRail)}"]`,
        )
        ?.classList.add("chat-rail-active");
    }

    if (opts.fab?.onClick) {
      document.getElementById("mobileFab")?.addEventListener("click", opts.fab.onClick);
    }

    // Started, not awaited: the shell is already on screen and every page
    // renders its own content behind this call. Pages that need a shell value
    // await `AppShell._shellDataReady` (or the GHD.store key directly — the
    // shell shares its requests through the store).
    this._startShellData({ conversations: opts.conversations });
  },

  /** The same call under the name the page modules used to spell. */
  renderFor(mainHtml, opts) {
    return this.render(mainHtml, opts);
  },

  /* Every signal the plan drives, in both shell states plus the composer. */
  _paintPlan() {
    const isPro = GHD.store.isProNow();

    // A transcript can finish rebuilding before the plan is known, so an
    // upgrade card the AI showed back when they were free may be on screen
    // selling Pro to someone who now has it.
    if (isPro) _chatPage()?._resolveTranscriptUpgradeCards?.();

    const badge = document.getElementById("chatSidebarBadge");
    if (badge) {
      badge.textContent = isPro ? t("chat.plan_pro") : t("chat.plan_free");
      badge.className = `plan-badge ${isPro ? "badge-pro" : "badge-free"}`;
    }
    const userCard = document.getElementById("chatSidebarUserCard");
    if (userCard) userCard.classList.toggle("chat-user-pro", isPro);
    const railAvatar = document.getElementById("chatAvatarBtn");
    if (railAvatar) railAvatar.classList.toggle("chat-user-pro", isPro);

    // Pro composer: gilded bottom rule + the "Pro" mark stamped into it.
    const inputWrap = document.getElementById("chatInputWrap");
    if (inputWrap) inputWrap.classList.toggle("chat-input-pro", isPro);
    const inputMark = document.getElementById("chatInputMark");
    if (inputMark) inputMark.hidden = !isPro;
  },

  /* Kick the shell's own loads, all through GHD.store so a page asking for the
     same resources joins these requests. The Chats page hands its own list in.
     Resolves once the conversation list, the plan and the roster are in — what
     a page decides by; `_shellDataReady` also waits for the groups and the LLM
     settings behind the name. */
  _startShellData({ conversations = null } = {}) {
    const decisive = [
      conversations ? this._adoptConversations(conversations) : this._loadConversations(),
      this._loadQuota(),
      GHD.store.people().catch(() => {}),
    ];
    this._shellDataReady = Promise.all([...decisive, this._loadUserName()]);
    return Promise.all(decisive);
  },

  // ── The shell's own loads ─────────────────────────────────────────────

  /* The conversation list, from GHD.store. */
  async _loadConversations() {
    try {
      await GHD.store.conversations();
    } catch (e) {
      /* the sidebar shows what the store has, which is nothing */
    }
    this._renderConversationList();
  },

  /** A list the page already fetched (the /chats page), adopted rather than
   *  re-requested. Priming is the whole job: it is a new value, so the store's
   *  change event brings the sidebar along. */
  async _adoptConversations(conversations) {
    GHD.store.prime("conversations", conversations);
  },

  /* The sidebar's recents. */
  _renderConversationList() {
    // This rewrites the list's innerHTML — on select, on adopt, on remove and
    // on every mid-stream title update — so a menu opened from a row would be
    // left pointing at a node that no longer exists. Scroll-dismiss doesn't
    // catch that; only closing here does.
    GHD.closeContextMenu();

    const list = document.getElementById("chatConvList");
    if (!list) return;

    const page = _chatPage();
    const activeId = page?.activeConversationId?.() || null;
    // Hide only untouched placeholder conversations; renamed chats may still use the default title.
    const visible = GHD.store.conversationsNow().filter((c) => !GHD.conversations.isPlaceholder(c));
    const recent = visible.slice(0, 20);

    if (visible.length === 0) {
      list.innerHTML = `<p style="padding:0.5rem 0.75rem;font-size:0.82rem;color:var(--text-quiet)">${t("chat.no_conversations")}</p>`;
      return;
    }

    // "All chats" closes the recents list (the claude.ai pattern) rather than
    // sitting in the footer menu with the app-level destinations.
    list.innerHTML =
      recent
        .map(
          (c) => `
      <div class="chat-conv-item${c.id === activeId ? " active" : ""}" data-id="${c.id}">
        <span class="chat-conv-title">${GHD.escapeHtml(c.title)}</span>
        ${c.share_token ? GHD.icons.globe : ""}
        <button type="button" class="chat-conv-more" data-id="${c.id}" aria-haspopup="menu" aria-expanded="false"
          aria-label="${GHD.escapeHtml(t("chats.more_actions", { title: c.title }))}">${GHD.icons.moreVertical}</button>
      </div>
    `,
        )
        .join("") +
      `<a class="chat-conv-item chat-conv-all" href="${GHD.router.href("/chats")}">${_ALL_CHATS_ICON}<span class="chat-conv-title">${t("chat.all_chats")}</span></a>`;

    list.querySelectorAll(".chat-conv-item[data-id]").forEach((el) => {
      // Per row, not per list: the rows are rebuilt on every render, and a
      // shared flag would let one row's long-press swallow another's tap.
      let swallowClick = false;

      el.addEventListener("click", (e) => {
        if (e.target.closest(".chat-conv-more")) return; // its own handler below
        if (swallowClick) {
          swallowClick = false;
          return;
        }
        this._onConvClick?.(el.dataset.id);
      });

      // The same menu as the ⋮ button, for a finger that holds the row.
      GHD.attachLongPress(el, async (x, y) => {
        swallowClick = true;
        (await this._convActions())?._openConvMenu(el.dataset.id, { x, y });
      });
    });

    list.querySelectorAll(".chat-conv-more").forEach((btn) => {
      btn.addEventListener("click", async (e) => {
        e.stopPropagation();
        (await this._convActions())?._toggleConvMenu(btn, btn.dataset.id);
      });
    });
  },

  /* The rows' actions live on Chat (chat-conv-actions.js), part of the chat
     route chunk — which a sidebar on any other page may not have loaded yet. */
  async _convActions() {
    if (!_chatPage()) {
      try {
        await GHD.loadRoute("chat");
      } catch {
        return null;
      }
    }
    return _chatPage();
  },

  /* The chat allowance, which is also where the plan is re-read. */
  async _loadQuota() {
    try {
      const quota = await GHD.store.quota();
      // Badge, Pro ring and the composer's gilded rule, in both shell states.
      this._paintPlan();
      _chatPage()?._paintQuotaFooter?.(quota, GHD.store.isProNow());
    } catch {
      // silent
    }
  },

  /* The user's name, and the three reads it comes out of (through GHD.store, so
     the page joins them). The language reconcile lives here so the saved app
     language is honoured on every route. */
  async _loadUserName() {
    const [peopleResult, , llmResult] = await Promise.allSettled([
      GHD.store.people(),
      // A free plan's groups are [] from the store, without a request.
      GHD.store.groups(),
      GHD.store.llmSettings(),
    ]);

    if (llmResult.status === "fulfilled" && llmResult.value && window.GHD_I18N) {
      // Align the dashboard UI with the saved app-language preference (reloads
      // once if it maps to a different supported UI locale).
      GHD_I18N.reconcile(llmResult.value.ui_language ?? null);
    }

    // The name is the me-person's, which the roster above already carries — so
    // this costs no request of its own. Assigned on every successful read, not
    // only a non-empty one: _userName survives a route change, so a name the
    // user has just cleared must fall back to the email local-part instead of
    // lingering. A failed read keeps the name we already had.
    if (peopleResult.status === "fulfilled") this._paintUserName();
    else this._paintUserCard();
  },

  /* The user card and the rail avatar, from the roster's me-person. */
  _paintUserName() {
    this._userName = GHD.names.first(GHD.store.mePersonNow()?.name) || null;
    this._paintUserCard();
  },

  _paintUserCard() {
    if (!this._userName) {
      const email = App._session?.user?.email || "";
      this._userName = email.split("@")[0] || null;
    }

    const initial = this._getUserInitial();
    document.querySelectorAll(".chat-rail-avatar, .chat-sidebar-user-avatar").forEach((el) => {
      el.textContent = initial;
    });
    const sidebarName = document.getElementById("chatSidebarUserName");
    if (sidebarName && this._userName) sidebarName.textContent = this._userName;
  },

  // ── Teardown ──────────────────────────────────────────────────────────

  _removeKeyHandler() {
    if (!this._keyHandler) return;
    window.removeEventListener("keydown", this._keyHandler);
    this._keyHandler = null;
  },

  /** Let go of everything this shell bound outside its own markup. Called by
   *  the chat page's cleanup; a shell that is only being re-rendered does not
   *  need it, because `_initShell` replaces both bindings itself. */
  teardown() {
    this._removeKeyHandler();
    this._storeUnsubscribe?.();
    this._storeUnsubscribe = null;
  },

  _closeSidebar() {
    const page = document.getElementById("chatPage");
    if (page) page.classList.remove("sidebar-open");
    const overlay = document.getElementById("chatDrawerOverlay");
    if (overlay) overlay.classList.add("hidden");
    // The stored value means "desktop column open" — closing the mobile drawer
    // (scrim tap, X, in-sidebar link) must not wipe the desktop preference.
    if (!GHD.platform.isPhoneLayout()) GHD.storage.set(CHAT_SIDEBAR_KEY, "closed");
  },

  // Navigation-triggered closes: a drawer covers the page so it must get out of
  // the way, but the desktop sidebar is an in-flow column that stays open —
  // only the explicit toggles ever close it there. The scrim is in play exactly
  // when it is a drawer: on a phone, and on a touch tablet (shell.css).
  _closeSidebarOnMobile() {
    const overlay = document.getElementById("chatDrawerOverlay");
    if (overlay && getComputedStyle(overlay).display !== "none") this._closeSidebar();
  },
};

// The export convention — see the boot list in js/app.js.
window.AppShell = AppShell;

;
/* dashboard/js/app.js */
/** SPA initialization; router.js owns path and history handling. */

// How long boot waits for one of the page's own API requests to answer before
// asking /health itself. Comfortably longer than a first read on a slow phone,
// short enough that a page which makes no request at all still gets a verdict
// while the reader is looking at it.
const API_ANSWER_WAIT_MS = 4000;

// While the offline banner is up, how often /health is asked again. Nothing
// else may come along to take it down: a WKWebView woken from a suspended web
// content process can miss the `online` event entirely.
const OFFLINE_RECHECK_MS = 15000;

// A request that failed outright is asked once more after this long before the
// banner goes up: the first request after a wake often dies with "the network
// connection was lost" on a connection that is fine a moment later.
const PROBE_RETRY_MS = 1500;

// Away at least this long, a page asks /health when it comes back.
const RESUME_RECHECK_AFTER_MS = 60000;

// What the tab is called with no page in front of it — the shell's own <title>.
const APP_TITLE = "gethumandesign";

// The letters that link back with ?token_hash= (supabase/templates/src).
const EMAIL_LINK_TYPES = ["recovery", "email_change"];

// Arrival records both origins write (js/arrival-touch.js): of the app's own and
// the one www hands over, the earlier first touch and the later last touch win.
const ARRIVAL_TOUCH_KEEP = { ghd_entry: -1, ghd_last_touch: 1 };

/** Whether a handed-over arrival record should replace this origin's own. */
function _handedTouchWins(key, handed, local) {
  try {
    const a = JSON.parse(handed)?.t;
    const b = JSON.parse(local)?.t;
    if (typeof a !== "number") return false;
    return typeof b !== "number" || Math.sign(a - b) === ARRIVAL_TOUCH_KEEP[key];
  } catch (e) {
    return false;
  }
}

// The storage keys a #ghd_handoff may write: go.js's CARRIED_KEYS, kept equal by
// tests/signup-seed-handoff.test.js.
const HANDOFF_KEYS = [
  "ghd_signup_birth_data",
  "ghd_signup_email",
  "ghd_gclid",
  "ghd_share",
  "ghd_entry",
  "ghd_last_touch",
  "ghd_signup_page",
  "ghd_ui_lang",
  "ghd_ui_lang_seed",
  "hd-theme",
  "fx_selected_currency",
  "ghd_device_id",
];

const App = {
  supabase: null,
  _session: null,
  // True once boot has finished, alongside the `ghd:app-ready` event on the
  // document. Both exist for the dev-only scripts, which are injected after the
  // deferred chain and so can miss the event.
  ready: false,

  /**
   * Adopt state handed over from www (site/go/), if this load carries any.
   *
   * Carried keys ride in the URL fragment, but the SESSION never touches a URL
   * (URLs land in Android logcat and history): go.js sends only a flag and the
   * session crosses via _fetchSessionFromSite. Any `s` in the fragment is refused.
   * Existing local values win over a stale handoff. The URL is always rewritten.
   * Gated on the referrer being the site origin (login-CSRF); unreadable = refused.
   *
   * @returns a promise while the session is being fetched from the site (init
   *   waits for it before first render), null when there is nothing to wait on.
   */
  _takeSessionHandoff() {
    if (!window.location.hash.startsWith("#ghd_handoff=")) return null;

    const encoded = window.location.hash.slice("#ghd_handoff=".length);

    // Strip first, unconditionally: whether or not we accept it below, the payload
    // must not outlive this statement in the address bar. The destination is the
    // path go.js redirected to, so only the fragment goes.
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    let raw;
    try {
      raw = decodeURIComponent(encoded);
    } catch (e) {
      // A malformed percent escape must not keep a fragment in the address bar
      // or prevent the app from reaching its ordinary startup.
      return null;
    }

    const site = (window.GHD_APP && window.GHD_APP.SITE_ORIGIN) || "";
    let referrerOrigin;
    try {
      referrerOrigin = document.referrer ? new URL(document.referrer).origin : "";
    } catch (e) {
      referrerOrigin = "";
    }
    if (!site || referrerOrigin !== site) return null;

    try {
      const payload = JSON.parse(raw);
      // Deliberately no payload.s branch: a session in a URL is the leak this
      // design exists to close, so one presented in a URL is never adopted —
      // not even a real one from an out-of-date cached go.js.
      // Only the keys go.js carries: the referrer check admits any link on www,
      // including one in a shared chat, so the payload is not trusted to name
      // its own keys (a planted session key would sign the reader in as someone else).
      for (const [key, value] of Object.entries(payload?.k || {})) {
        if (!HANDOFF_KEYS.includes(key)) continue;
        if (typeof value !== "string") continue;
        const local = localStorage.getItem(key);
        if (!local || (key in ARRIVAL_TOUCH_KEEP && _handedTouchWins(key, value, local))) {
          localStorage.setItem(key, value);
        }
      }
      if (payload?.sc && !localStorage.getItem(GHD_APP.sessionKey())) {
        return this._fetchSessionFromSite(site);
      }
    } catch (e) {
      // A malformed handoff is not worth failing the load over — the user simply
      // arrives signed out and can sign in, which is the pre-handoff behaviour.
    }
    return null;
  },

  /* Fetch the site origin's session over postMessage, never over a URL.
     Only a message from the site origin AND the bridge frame counts; the bridge
     pins its targetOrigin too. Always resolves (timeout included): arriving
     signed out is the fallback, never an error. */
  _fetchSessionFromSite(site) {
    return new Promise((resolve) => {
      const frame = document.createElement("iframe");
      frame.hidden = true;
      let timer = null;
      let onMessage = null;

      const done = () => {
        window.removeEventListener("message", onMessage);
        clearTimeout(timer);
        try {
          frame.remove();
        } catch (e) {}
        resolve();
      };

      onMessage = (event) => {
        if (event.origin !== site || event.source !== frame.contentWindow) return;
        const data = event.data;
        if (!data || data.type !== "ghd:session") return;
        try {
          if (typeof data.s === "string") {
            const parsed = JSON.parse(data.s);
            const sessionKey = GHD_APP.sessionKey();
            // Verbatim, and only if this origin still has no session of its
            // own: same object, same refresh-token family as on www — nothing
            // is re-minted, so GoTrue's reuse detection is not in play.
            if (parsed?.access_token && parsed?.refresh_token && !localStorage.getItem(sessionKey)) {
              localStorage.setItem(sessionKey, data.s);
            }
          }
        } catch (e) {
          /* a malformed session is simply not adopted */
        }
        done();
      };

      window.addEventListener("message", onMessage);
      // Generous for a tiny page on a slow connection, short enough that a
      // blocked frame does not strand the user staring at an empty shell.
      timer = setTimeout(done, 4000);
      frame.src = site + "/go/bridge/";
      document.body.appendChild(frame);
    });
  },

  /* The boot sequence, written down: side effects run here in a stated order,
     not in <script> order. Deliberately left out: js/router.js (must wire at eval,
     before anything reads the URL or a link is clicked) and js/android-build.js
     (reads `?app=` at eval, before the router navigates it away). Modules are
     reached through `window` so a sandbox loading app.js alone no-ops, not throws. */
  _boot() {
    // First: the store wraps the API client, and every read below it — every
    // page, the shell — goes through the wrapped methods. A call that beat this
    // would bypass the cache and the invalidation map.
    GHD.store?.init(window.Api);

    // Unsent text, flushed on pagehide and visibilitychange. Before the service
    // worker, whose update reload fires on exactly those events and relies on
    // these listeners already being on the document.
    GHD.drafts?.init();

    // The service worker: the ?q= deep-link stash, the update-reload hook
    // (window.__maybeAppUpdateReload, which route() calls) and registration.
    // Before the first route() below.
    GHD.swRegister?.init();

    // The knowledge-base panel's Back handling, before the chat page's link
    // delegation, which is what hands the panel its clicks.
    window.KbPanel?.init();
    window.Chat?.initDocLinks?.();

    // The install and store promos, a chunk of their own: no page needs them to
    // route. GHD.platform has settled by now (platform.js reads the launch
    // signal as it evaluates). A failed fetch costs a promo, nothing else.
    GHD.loadRoute("pwa").then(
      () => GHD.pwa?.init(),
      () => {},
    );

    // A Play purchase whose post was lost must reach the backend before Play's
    // 3-day acknowledgement deadline refunds it, whichever page a launch opens.
    // The chunk restores as it loads, and decides whether this build bills.
    if (GHD.platform?.isTWA) GHD.loadRoute("playbilling").catch(() => {});

    // A device that opted into the Advanced tab's preview while the tab was
    // hidden (`?advanced=on`, retired 2026-08-28 when the tab went live for
    // everyone) still carries the flag it wrote. Nothing reads it; sweep it.
    GHD.storage?.remove(GHD.KEYS?.advancedTabPreviewRetired);

    // Analytics last — nothing waits on it.
    GHD.cfBeacon?.init();
  },

  init() {
    this._boot();

    // Before anything reads the URL or localStorage: adopt the state handed
    // over from the marketing origin. When the handoff says a session exists
    // over there, startup waits for the bridge to deliver it (or give up)
    // before the first render — otherwise a guarded route would bounce the
    // freshly signed-up user to /login in the very moment their session is in
    // flight. Every load without a handoff stays fully synchronous.
    const pendingSession = this._takeSessionHandoff();
    if (pendingSession) {
      void pendingSession.then(() => this._start());
      return;
    }
    this._start();
  },

  _start() {
    // Remember that this signup started at the MCP consent screen, before
    // anything can navigate the params away. Here and not in Auth.renderSignup()
    // because the flag has to be caught on whatever URL it arrives on: an OAuth
    // callback load never calls route() at all (the SDK owns the URL until
    // INITIAL_SESSION), and a route that happens to match today is exactly what
    // silently stopped matching when the signup funnel last changed its target.
    // Optional, like every other line in this function that is not the app
    // itself: a device with no storage still gets an ordinary signup.
    GHD.mcpSignup?.capture(GHD.router.query());
    this._captureProIntent();

    // The status dot and the offline banner ask one question between them, and
    // the page's own requests usually answer it — see _settleInitialConnectivity.
    this._initOfflineBanner();

    GHD.router.subscribe(() => this.route());
    this._followPlanHint();

    // Sessions only ever arrive as a PKCE ?code=, which only the browser that
    // started the sign-in can exchange. A #access_token= fragment can carry any
    // account's tokens, so it is dropped unread (the SDK refuses it too).
    if (/(^#|&)access_token=/.test(window.location.hash)) {
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
    const emailLink = this._takeEmailLink();
    if (emailLink) {
      // Its own route file (js/email-link.js), off the eager bundle. Should
      // that not arrive, the link goes back into the address bar before the
      // failure screen's reload, so the link is not spent on a failed download.
      GHD.loadRoute("auth").then(
        () => this._verifyEmailLink(emailLink),
        (err) => {
          const url = new URL(window.location.href);
          url.searchParams.set("token_hash", emailLink.tokenHash);
          url.searchParams.set("type", emailLink.type);
          window.history.replaceState(null, "", url.pathname + url.search);
          this._renderChunkFailure(err, "auth");
        },
      );
      return;
    }

    // Detect OAuth callback before touching the URL.
    this._isOAuthCallback =
      window.location.search.includes("code=") ||
      new URLSearchParams(window.location.search).has("error_description") ||
      window.location.hash.startsWith("#error=");

    if (!this._isOAuthCallback) {
      // Normal page load: read session synchronously from localStorage — instant, no SDK wait.
      // Stale access_tokens are OK here: api.js refreshes one before sending it
      // and again on a 401. Bouncing to
      // /login on expiry would race the SDK's async refresh and wrongly log out users
      // returning from long redirects (e.g. Stripe Checkout).
      try {
        const raw = localStorage.getItem(GHD_APP.sessionKey());
        const stored = raw ? JSON.parse(raw) : null;
        if (stored?.access_token && stored?.user) {
          this._session = stored;
          this._updateNav(stored);
          // Which build of the Play Store app this account launches, so a
          // rollout can be watched in our own data (js/android-build.js). Used
          // to ride INITIAL_SESSION, which no longer fires on an ordinary load
          // — the SDK is not there to fire it. A no-op in a browser, and at
          // most one request per launch-day in the app.
          GHD.androidBuild?.report(stored.user.id);
          // App Store transactions the iOS shell pushed wait for an account.
          GHD.native?.attachAccount(stored.user.id);
        }
      } catch (e) {}

      // Render immediately with whatever session state we have — unless this
      // session still has an unfinished signup attached to it, in which case
      // that decides where the load belongs and _finishPendingSignup renders.
      //
      // Either/or, so exactly one of the two owns the first paint and neither
      // can navigate on top of the other. Only a seed in storage takes this
      // branch, so every ordinary load behaves exactly as it did.
      if (this._session && this._readSignupSeed()) void this._finishPendingSignup();
      else this.route();
    } else {
      // An OAuth callback is the one load that cannot render without the SDK:
      // the tokens are in the URL and only the SDK can exchange them. Nothing
      // else touches the URL until it has — onAuthStateChange navigates.
      void this.ensureSupabase().catch((err) => {
        GHD.reportError?.(err, { context: "Supabase SDK (OAuth callback)" });
        this.navigate("/login");
      });
    }
  },

  /* The Supabase client, fetching the SDK the first time somebody needs it.
     Most loads never do: sessions come from localStorage and data calls are raw
     fetches (js/api.js), whose own refresh stands in for the SDK's.
     A failed fetch rejects and can be retried. */
  _supabaseReady: null,

  ensureSupabase() {
    if (!this._supabaseReady) {
      // Already on the page? Then this is only about creating the client. The
      // shell no longer carries a <script> for the SDK, but a page that does
      // (the OAuth consent screen) shares these modules.
      const sdk = typeof supabase !== "undefined" ? Promise.resolve() : GHD.loadSupabase();
      this._supabaseReady = sdk
        .then(() => {
          this.supabase = supabase.createClient(CONFIG.SUPABASE_URL, CONFIG.SUPABASE_ANON_KEY, {
            auth: { flowType: "pkce" },
          });
          this._subscribeToAuthEvents();
          return this.supabase;
        })
        .catch((err) => {
          this._supabaseReady = null;
          throw err;
        });
    }
    return this._supabaseReady;
  },

  /* The ?token_hash= a password-reset or email-change letter links to, taken
     out of the address bar, or null. */
  _takeEmailLink() {
    const params = new URLSearchParams(window.location.search);
    const tokenHash = params.get("token_hash");
    const type = params.get("type");
    if (!tokenHash || !EMAIL_LINK_TYPES.includes(type)) return null;
    params.delete("token_hash");
    params.delete("type");
    const rest = params.toString();
    window.history.replaceState(null, "", window.location.pathname + (rest ? "?" + rest : ""));
    return { tokenHash, type };
  },

  /* Finish an email change the moment its new address turns up on the session.
     The confirmation link arrives with no event of its own; a session carrying the
     pending address is the signal. Api.emailChanged (Stripe's copy) is
     fire-and-forget on purpose: a failure is not worth an error toast. */
  async _settleEmailChange(session) {
    const pending = GHD.storage.get(GHD.KEYS.pendingEmailChange);
    if (!pending) return;
    const current = session?.user?.email || "";
    if (current.toLowerCase() !== pending.toLowerCase()) return;
    GHD.storage.remove(GHD.KEYS.pendingEmailChange);
    GHD.toast(t("settings.email.changed_toast", { email: current }), "status");
    try {
      await Api.emailChanged();
    } catch (e) {
      /* see above: the address itself already changed */
    }
  },

  _subscribeToAuthEvents() {
    const isOAuthCallback = this._isOAuthCallback;
    // Listen for SDK auth events (token refresh, sign-in, sign-out).
    this.supabase.auth.onAuthStateChange(async (event, session) => {
      // An emailed link is being verified: _verifyEmailLink decides what the
      // resulting session means and where it lands.
      if (this._holdAuthEvents) return;
      const hadSession = !!this._session;
      this._session = session;
      this._updateNav(session);

      // Which build of the Play Store app this account launches, so a rollout
      // can be watched in our own data (js/android-build.js). Fired from here
      // because INITIAL_SESSION arrives on every page load, cold launch
      // included; it is a no-op in a browser and at most one request per
      // launch-day in the app, so calling it on every auth event is free.
      // Optional: this handler is the sign-in path, and no telemetry line is
      // worth a TypeError that strands someone on a blank shell.
      GHD.androidBuild?.report(session?.user?.id);
      GHD.native?.attachAccount(session?.user?.id);
      // Loaded after boot in the Play app; a sign-in after that is a new account.
      GHD.playBilling?.restoreOnce();

      // A confirmed email change arrives as an ordinary session — the same
      // events as any other sign-in — so it is recognised by the address rather
      // than by an event. Runs before the branches below because those return.
      void this._settleEmailChange(session);

      // INITIAL_SESSION fires on every page load (after SDK init + any PKCE exchange).
      // If we already had a session from localStorage, skip (already rendered).
      // If we got a session now without one from localStorage, it's an OAuth callback.
      // If it's an OAuth callback with no session, something failed — go to login.
      if (event === "INITIAL_SESSION") {
        if (session && !hadSession) {
          await this._navigateAfterSignIn();
        } else if (isOAuthCallback && !session) {
          GHD.reportClientError?.("reported", "no session", null, { context: "Auth callback" });
          this.navigate("/login");
        }
        return;
      }

      if (event === "PASSWORD_RECOVERY") {
        this.navigate("/set-password");
        return;
      }

      if (event === "SIGNED_IN") {
        // Cached API responses are per-user and the Cache API keys on URL alone, so
        // a session that ended without a SIGNED_OUT event (offline expiry, a crashed
        // sign-out) could otherwise let this account read the previous one's cached
        // roster while offline. Drop the cache on sign-in too — belt-and-braces with
        // the SIGNED_OUT branch. Network-first means this only costs a re-fetch.
        if ("caches" in window) await caches.delete("ghd-api-v1").catch(() => {});
        const currentPath = GHD.router.current().split("?")[0];
        if (currentPath === "/" || ["/login", "/signup"].includes(currentPath)) {
          await this._navigateAfterSignIn();
          return;
        }
        // If we didn't have a session before (e.g. token refresh resolved late),
        // re-route to pick up the authenticated state.
        if (!hadSession) this.route();
      }

      if (event === "SIGNED_OUT") {
        console.warn("[auth] SIGNED_OUT", { hadSession, url: window.location.href });
        // Cached API responses are per-user — drop them so the service
        // worker's offline fallback can never serve them to the next user.
        if ("caches" in window) await caches.delete("ghd-api-v1").catch(() => {});
        // The roster and chat list kept for the next load go with them.
        GHD.store?.wipe();
        // Keep the language of the visible auth journey in sessionStorage before
        // removing the account-owned persistent copy. The next account's profile
        // reconciliation consumes this handoff instead of inheriting it.
        GHD_I18N.rememberSignedOutAuthLocale();
        // Same reasoning for the localStorage that holds an account's *choices*: it is
        // keyed per device, so the next account to sign in on this browser would boot
        // into this one's UI language and never be asked to confirm its own name. The
        // language comes back from profiles.ui_language on the next sign-in (i18n.js
        // reconcile), or from the device when that is null.
        GHD.storage.remove(GHD.KEYS.uiLang);
        GHD.storage.remove(GHD.KEYS.uiLangSeed);
        GHD.storage.remove(GHD.KEYS.nameConfirmed);
        GHD.storage.remove(GHD.KEYS.firstJourney);
        // An address this account asked to move to is this account's business:
        // left behind, it would congratulate whoever signs in next on a change
        // they never made, the first time they happen to use that address.
        GHD.storage.remove(GHD.KEYS.pendingEmailChange);
        GHD.storage.remove(GHD.KEYS.proIntent);
        // A hard load, not a route change: it is the one reliable way to drop every
        // module's in-memory copy of the signed-out account's data. Base-aware, so
        // signing out lands on the app's own login screen rather than — on the
        // legacy www base — the marketing homepage.
        window.location.href = GHD.router.href("/login");
      }
    });
  },

  /* Where a session that has just become the app's belongs, and go there. */
  async _navigateAfterSignIn() {
    // If returning from Stripe checkout, go to settings (not chat)
    if (new URLSearchParams(window.location.search).get("checkout") === "success") {
      this.navigate("/settings");
      return;
    }
    let returnTo = GHD.storage.session.get(GHD.KEYS.returnTo);
    GHD.storage.session.remove(GHD.KEYS.returnTo);

    // Consume a pending share-save (set by the /shared-person/ CTA → ?next=shared-person/<token>).
    // Save the shared person to the new account; route the user to that person's chart afterwards.
    const pendingShareToken = GHD.storage.session.get(GHD.KEYS.pendingShareToken);
    GHD.storage.session.remove(GHD.KEYS.pendingShareToken);
    if (pendingShareToken) {
      try {
        const result = await Api.savePersonFromShare(pendingShareToken);
        if (result?.person?.id) returnTo = `/people/${result.person.id}`;
      } catch (e) {
        // Routing carries on either way. A refusal is still said, though: the
        // reader signed up to keep this person, and a 409 means the name is
        // already on their list for somebody else — something only they can
        // settle, and which nothing on the next page would explain.
        if (e?.status === 409 && e.message) GHD.toast(e.message);
      }
    }

    const outcome = await this._settleOnboarding();
    if (outcome === "completed") {
      this.navigate(this.afterSignupRoute());
      return;
    }
    if (outcome === "needs_onboarding") {
      this.navigate("/onboarding");
      return;
    }
    // "onboarded" — nothing outstanding — or "unknown", where the check itself
    // failed and guessing "not onboarded" would push an existing user through
    // the form again. Both send them on to where they were headed.
    this.navigate(this._takeProCheckout() || returnTo || "/chat");
  },

  /* Finish a signup that was started before this app session existed.
     The session already exists at boot, so the sign-in branch never runs
     _settleOnboarding. The trigger is the seed in storage, never the landing route
     (redirect targets change). Holds the first paint so a new account never sees a
     chart-less chat, bounded so it never becomes a blank page. A stale seed must not
     drag someone off the deep link they opened. */
  async _finishPendingSignup() {
    if (!this._session || !this._readSignupSeed()) return;

    let painted = false;
    const paintRequestedRoute = () => {
      if (painted) return;
      painted = true;
      this.route();
    };
    const giveUp = setTimeout(paintRequestedRoute, this._PENDING_SIGNUP_PAINT_MS);

    try {
      const outcome = await this._settleOnboarding();
      if (outcome === "completed") {
        painted = true;
        this.navigate(this.afterSignupRoute());
      } else if (outcome === "needs_onboarding") {
        painted = true;
        this.navigate("/onboarding");
      } else {
        // "onboarded" (the stale seed is dropped) or "unknown" (the check
        // failed, so the seed survives for the next load): this session is not
        // mid-signup after all, so render what was actually asked for.
        paintRequestedRoute();
      }
    } finally {
      clearTimeout(giveUp);
    }
  },

  /* How long the first paint waits on a pending signup before rendering the
     route the user asked for instead. A late answer still lands them correctly. */
  _PENDING_SIGNUP_PAINT_MS: 8000,

  /* Whether this account still needs onboarding, with the signup seed spent if
     that was all it was waiting for: "onboarded", "completed", "needs_onboarding",
     or "unknown" (check failed: decide nothing, keep the seed). One run at a time,
     because it mutates the account. */
  _settling: null,

  _settleOnboarding() {
    if (!this._settling) {
      this._settling = this._runSettleOnboarding().finally(() => {
        this._settling = null;
      });
    }
    return this._settling;
  },

  async _runSettleOnboarding() {
    try {
      const sub = await Api.getSubscription({ details: false });
      if (sub.onboarding_completed) {
        // Existing user — drop any abandoned homepage seed so it can't poison
        // the next signup on this device. Same for a `from=mcp` flag: this
        // account is not the signup it was armed for, and a flag left behind
        // would send the device's *next* signup to a screen about connecting an
        // assistant nobody asked about.
        this._clearSignupSeed();
        GHD.mcpSignup?.clear();
        return "onboarded";
      }
      return (await this._tryAutoCompleteOnboarding()) ? "completed" : "needs_onboarding";
    } catch (e) {
      // Never rejects: both callers navigate on the answer, and an unhandled
      // rejection here would strand the user on whatever is on screen. An
      // account we could not read is not an account we may assume needs the
      // onboarding form again.
      return "unknown";
    }
  },

  /* The half-finished signup this device is carrying, or null. */
  _readSignupSeed() {
    return GHD.signupSeed.read();
  },

  _clearSignupSeed() {
    GHD.signupSeed.clear();
  },

  /* A "Get Pro" click on the pricing page arrives as /signup?billing=…. It is
     kept in localStorage to survive the OAuth round trip and a confirmation mail
     opened in a new tab, and expires so a much later sign-in on this device is
     not sent to Checkout. Only /signup arms it: /checkout carries the same
     parameter and has its own way back through returnTo. A /signup without a
     period disarms it: that signup is a free one, whatever an abandoned click
     earlier today said. */
  _PRO_INTENT_TTL_MS: 24 * 60 * 60 * 1000,

  _captureProIntent() {
    if (GHD.router.current().split("?")[0] !== "/signup") return;
    const billing = GHD.router.query().get("billing");
    if (billing !== "monthly" && billing !== "yearly") {
      GHD.storage.remove(GHD.KEYS.proIntent);
      return;
    }
    GHD.storage.set(GHD.KEYS.proIntent, JSON.stringify({ billing, savedAt: Date.now() }));
  },

  /* The Checkout route a pending "Get Pro" asks for, spent; or null. */
  _takeProCheckout() {
    let stored = null;
    try {
      stored = JSON.parse(GHD.storage.get(GHD.KEYS.proIntent) || "null");
    } catch {}
    GHD.storage.remove(GHD.KEYS.proIntent);
    if (!stored || typeof stored.savedAt !== "number" || Date.now() - stored.savedAt > this._PRO_INTENT_TTL_MS) {
      return null;
    }
    return "/checkout?billing=" + (stored.billing === "yearly" ? "yearly" : "monthly");
  },

  /* Where a signup that has just finished belongs. */
  afterSignupRoute() {
    const SEEDED_CHAT = "/chat?seed=explain_my_design";
    const mcp = GHD.mcpSignup?.read();
    if (!mcp) return this._takeProCheckout() || SEEDED_CHAT;
    GHD.mcpSignup.clear();
    // The client name travels in the URL so the screen survives a reload, and it
    // is untrusted, so it is encoded going in and re-sanitised coming out.
    return "/connected" + (mcp.client ? "?client=" + encodeURIComponent(mcp.client) : "");
  },

  /* The name Apple's sheet gave on this sign-in, or "". */
  appleName: "",

  /* What to call this new user, best source first: what they typed on the
     homepage, then whatever the identity provider told Supabase about them.
     Never written back. Shared with js/onboarding.js (a route chunk; this file is
     eager, so only that direction is safe). */
  nameFromSignup(seed) {
    const userMeta = this._session?.user?.user_metadata || {};
    const providerName = [
      (userMeta.first_name || userMeta.given_name || "").trim(),
      (userMeta.last_name || userMeta.family_name || "").trim(),
    ]
      .filter(Boolean)
      .join(" ");
    return (
      (seed?.firstName || "").trim() ||
      providerName ||
      (userMeta.name || userMeta.full_name || "").trim() ||
      // Native Sign in with Apple names the person outside the session
      // (js/auth.js), and only on their first sign-in.
      this.appleName ||
      ""
    );
  },

  // Homepage signup writes birth details to localStorage before triggering Supabase
  // auth. When the new user lands here, finish onboarding programmatically so they
  // skip the onboarding form entirely.
  async _tryAutoCompleteOnboarding() {
    const seed = this._readSignupSeed();
    if (!seed) return false;

    const birthTime = seed.birthTime || "12:00";
    const birthDatetime = `${seed.birthDate}T${birthTime}:00`;
    const name = this.nameFromSignup(seed);
    // Apple names a person once, and on the web often not at all, and its
    // address may be a private relay, so the backend's fallback to the email's
    // first half would name them "Xk7q2b9mzp". The onboarding form asks instead,
    // its birth fields already filled from the seed.
    if (!name && this._session?.user?.app_metadata?.providers?.includes("apple")) return false;
    // In the iOS app, only a seed from its own signup carries the AI-data
    // consent (Auth.aiConsentHTML); any other is asked on the onboarding form.
    if (GHD.platform?.isIOSApp && !seed.aiConsent) return false;

    try {
      await Api.completeOnboarding({
        name,
        birthDatetime,
        birthPlace: seed.birthPlace,
        // Same mapping as the onboarding form's checkbox: the homepage's "I
        // don't know my birth time" is the noon above, and nothing else here
        // implies a guess.
        birthTimeConfidence: seed.noTime ? "unknown" : "exact",
        tosAccepted: true,
        signupSource: "homepage_direct",
      });
    } catch (err) {
      console.warn("Auto-onboarding failed; falling back to onboarding form", err);
      return false;
    }

    // Subscribe to the newsletter by default — the homepage/direct signup form
    // has no consent checkbox, matching the onboarding form's default-on consent.
    void Api.subscribeNewsletter(true).catch((newsletterErr) => {
      console.warn("Newsletter subscription sync failed after auto-onboarding", newsletterErr);
    });

    this._clearSignupSeed();

    // No client-side signup conversion here either: like the onboarding path, the
    // Google Ads signup conversion is uploaded server-side from the stored gclid.
    return true;
  },

  navigate(path) {
    GHD.router.go(path);
  },

  /* Count an arrival from a link minted outside the app, once, then forget it. */
  _reportInboundLink() {
    const params = GHD.router.query();
    const ref = params.get("ref");
    if (!ref) return;
    params.delete("ref");
    const basePath = GHD.router.current().split("?")[0];
    GHD.router.replace(basePath + (params.toString() ? "?" + params.toString() : ""));
    Api.reportInboundLink(ref);
  },

  // Which navigation is current. Bumped once per route() dispatch, so a chunk
  // that lands after the user has moved on renders nothing.
  _routeSeq: 0,

  // The two chunks whose pages talk to Supabase: the auth screens sign in and
  // reset passwords, settings signs out and lists OAuth grants.
  _SDK_CHUNKS: ["auth", "settings"],

  /* Fetch what a page is made of, then render it.
     `token` drops a chunk that arrives after the user navigated elsewhere; a chunk
     that never arrives leaves a message and a retry. The SDK download starts here
     but is not awaited: every call site awaits ensureSupabase() itself. */
  _openRoute(token, chunk, render) {
    if (this._SDK_CHUNKS.includes(chunk)) this.ensureSupabase().catch(() => {});
    // The person page's Advanced (Variable) tab is its own chunk, fetched
    // alongside the people chunk — and never allowed to fail the person page:
    // people.js renders the panel only when the module is there, so a chunk
    // that does not arrive costs one tab, not the page.
    const chunks = chunk === "people" ? [chunk, "advanced"] : [chunk];

    if (chunks.every((name) => GHD.routeLoaded(name))) return render();

    const wanted = chunks.map((name) =>
      name === "advanced" ? GHD.loadRoute(name).catch(() => {}) : GHD.loadRoute(name),
    );
    // A script that never answers (a phone back from the background on a dead
    // connection) would leave the page dimmed for good, and since chunks run
    // in insertion order it holds every later chunk too. The load itself keeps
    // going: abandoning it here re-requests nothing.
    let timer;
    const stalled = new Promise((_, reject) => {
      timer = setTimeout(() => reject(new Error("stalled")), this._CHUNK_DEADLINE_MS);
    });
    return Promise.race([Promise.all(wanted), stalled])
      .finally(() => clearTimeout(timer))
      .then(
        () => {
          if (token === this._routeSeq) render();
        },
        (err) => {
          if (token === this._routeSeq) this._renderChunkFailure(err, chunk);
        },
      );
  },

  /* Dim <main> after a short delay (so a quick navigation never flickers), or
     restore it. Inline, not a class: the eager stylesheet has no room. */
  _busy(on) {
    const style = document.getElementById("main")?.style;
    if (!style) return;
    style.transition = on ? "opacity .2s .15s" : "";
    style.opacity = on ? ".6" : "";
  },

  _CHUNK_DEADLINE_MS: 20000,

  _renderChunkFailure(err, chunk) {
    this._busy(false);
    console.warn(`[route] the ${chunk} chunk did not load:`, err);
    const reason = err?.message || "";
    const what = /^(stalled|incomplete|without \S+)$/.test(reason) ? reason : "did not load";
    GHD.reportClientError?.("reported", `${chunk} ${what}`, null, { context: "Route chunk" });
    const main = document.getElementById("main");
    if (!main) return;
    main.innerHTML = GHD.emptyStateHtml({
      title: t("app.page_load_failed"),
      sub: t("app.page_load_failed_sub"),
      actionHtml: `<button type="button" class="btn-primary" id="route-retry">${GHD.escapeHtml(
        t("app.page_load_retry"),
      )}</button>`,
    });
    // A reload, not route(): a stale release asks again for the file that is
    // gone, and a stalled script still blocks every chunk queued behind it.
    // The shell is served no-cache, so a reload is the one retry that fixes both.
    document.getElementById("route-retry")?.addEventListener("click", () => {
      GHD.drafts?.flush();
      location.reload();
    });
  },

  route() {
    const path = GHD.router.current();
    // Every dispatch is a new navigation, the eager ones (/chat, /chats)
    // included: a chunk still in flight for the previous route must find its
    // token stale whatever the user moved on to, or it paints over them.
    const token = ++this._routeSeq;

    // Navigation guard — lets pages block route changes (e.g. unsaved edits)
    if (this._navigationGuard) {
      if (!this._navigationGuard()) {
        GHD.router.replace(this._lastRoute || "/");
        return;
      }
      this._navigationGuard = null;
    }
    this._lastRoute = path;

    // A route change is the safe moment to pick up a deployed update, but it
    // has to happen *before* the outgoing page is torn down — reloading after
    // the cleanups would leave a visibly broken page on screen for the rest of
    // the (async) navigation. Runs after the navigation guard so a page with
    // unsaved edits still gets to block the change first.
    if (window.__maybeAppUpdateReload?.()) return;

    // Clean up previous page state — every page module the table names, not
    // just the one being left: most of them live in a route chunk this visit
    // may never have loaded, so "which page was that" is a question with no
    // cheaper answer. Each is wrapped because a failing cleanup must never
    // block routing.
    GHD.router.PAGES.forEach((name) => {
      try {
        window[name]?.cleanup?.();
      } catch {}
    });

    const hit = GHD.router.match(path);
    this._applyChrome(hit ? hit.route.chrome : "document");

    // Protected routes. The auth screens are the only rows that opt out, and
    // they return above this without ever asking about the session.
    if (!hit || hit.route.guarded !== false) {
      if (!this._session) {
        // A session that lapsed without a sign-out leaves no account's data behind.
        GHD.store?.wipe();
        // The fragment comes too: a letter's /settings#email must still open on
        // that section once the reader has signed in.
        GHD.storage.session.set(GHD.KEYS.returnTo, path + GHD.router.fragment());
        // replace(), not go(): the guarded route was never a page the user saw,
        // so the back button should leave the app rather than bounce off this
        // redirect.
        GHD.router.replace("/login");
        const login = GHD.router.match("/login");
        // The chrome applied above was the bounced route's: "/" (where the
        // Android app opens) gets the document chrome and its header.
        this._applyChrome(login.route.chrome);
        return this._openRoute(token, login.route.chunk, () => this._paint(login.route, () => Auth.renderLogin()));
      }

      // Deliberately below the guard: an inbound link that arrives signed out is
      // parked in returnTo above, query and fragment, and comes back through here once
      // the session exists — which is also the only moment the report can be made,
      // since the endpoint needs the JWT.
      this._reportInboundLink();
    }

    // Empty/unknown path — the app root, or anything mistyped. There is nothing
    // to render, so decide where this session belongs instead: returnTo, a
    // Stripe checkout return, onboarding, or the chat.
    //
    // This is no longer what finishes a homepage signup. _finishPendingSignup
    // does that from init(), on whatever route the funnel lands on. It used to
    // be this line, and that was the bug: the funnel changed its redirect target
    // and the trigger silently stopped matching.
    if (!hit) return this._navigateAfterSignIn();

    if (hit.route.redirect) {
      // An alias is never a page the reader saw, so it leaves no history entry.
      GHD.router.replace(hit.route.redirect(path));
      return this.route();
    }

    // Never allowed to cost the navigation itself.
    try {
      if (hit.route.chrome === "shell") this._prefetch(hit);
    } catch {}
    // The page being left dims while the next one's code and data are on the
    // way, so a tap always shows an answer; the next page's shell render, or
    // its render settling, lifts it.
    if (this._painted) this._busy(true);
    const paint = () => {
      const { page, call, chunk } = hit.route;
      // Its chunk said it loaded and the page is still not there: the failure
      // screen and its reload, not a TypeError on a blank page.
      if (typeof window[page]?.[call] !== "function") {
        return this._renderChunkFailure(new Error(`without ${page}.${call}`), chunk || "core");
      }
      const done = () => token === this._routeSeq && this._busy(false);
      const result = this._paint(hit.route, () => window[page][call](...hit.params));
      Promise.resolve(result).then(done, done);
      return result;
    };
    // A page in the eager chain paints at once; one in a route chunk waits for
    // it, and renders only if the reader is still on this navigation — see
    // _openRoute.
    if (!hit.route.chunk) return paint();
    return this._openRoute(token, hit.route.chunk, paint);
  },

  /* Start a shell page's reads alongside its chunk instead of after it. All go
     through GHD.store (Api.getGroupPenta is its wrapper), so the render the
     chunk runs joins these requests rather than making its own. */
  _prefetch({ route: { page, call }, params: [id] }) {
    const quiet = () => {};
    AppShell._startShellData();
    if (/^(People|Groups?)$/.test(page) || call === "renderPicker") GHD.store.subscription().catch(quiet);
    if (call === "renderChartDetail") GHD.store.chart(id).catch(quiet);
    if (page === "Group") Api.getGroupPenta(id).catch(quiet);
  },

  /* The page title per route, from the same strings the mobile app header
     shows. A detail page keeps its section's heading. */
  _TITLE_KEYS: {
    "Auth.renderLogin": "auth.login.title",
    "Auth.renderSignup": "auth.signup.title",
    "Auth.renderResetPassword": "auth.reset.title",
    "Auth.renderSetPassword": "auth.set_password.title",
    "Settings.render": "settings.title",
    "Settings.renderCheckout": "settings.upgrade.to_pro",
    "People.render": "people.people_heading",
    "People.renderChartDetail": "people.people_heading",
    "People.renderTempChartDetail": "people.people_heading",
    "People.renderNewPerson": "people.add_person",
    "Groups.render": "people.groups_heading",
    "Group.render": "people.groups_heading",
    "Compare.render": "people.pairs_heading",
    "Compare.renderPicker": "people.pairs_heading",
    "Transits.render": "app.title_transits",
    "Cycles.render": "cycles.title",
    "Chat.render": "layout.nav_chat",
    "Chats.render": "chats.title",
    "Onboarding.render": "onboarding.title",
    "McpConnected.render": "mcp.connected.title",
  },

  // Whether a page has been painted into this document yet — see _paint.
  _painted: false,

  /* Call a page's render, then name the page in the tab and move focus to the
     start of the new content (`<main>`, without scrolling) for screen readers.
     Focus is left alone on the load's first paint, when the page moved focus
     itself, and when the markup has an `autofocus` field. */
  _paint(route, render) {
    const main = document.getElementById("main");
    const before = document.activeElement;
    const result = render();

    const key = this._TITLE_KEYS[`${route.page}.${route.call}`];
    document.title = key ? `${t(key)} · ${APP_TITLE}` : APP_TITLE;

    const first = !this._painted;
    this._painted = true;
    if (first || !main) return result;
    const active = document.activeElement;
    const pageMovedFocus = active && active !== before && active !== document.body && main.contains(active);
    if (pageMovedFocus || main.querySelector("[autofocus]")) return result;
    main.tabIndex = -1;
    main.focus({ preventScroll: true });
    return result;
  },

  /* Show or hide the page chrome for the kind of page being opened.
     Chrome boots hidden (dashboard.css), so showing it is an explicit class. Shell
     classes are stripped only when leaving the shell: shell to shell must keep
     them, or the outgoing page reflows while the next one awaits its data. */
  _applyChrome(kind) {
    document.querySelector(".site-header").classList.toggle("chrome-visible", kind === "document");
    document.querySelector(".site-footer").classList.toggle("chrome-visible", kind === "document" || kind === "auth");
    if (kind !== "shell") {
      document.getElementById("main").classList.remove("chat-active");
      document.body.classList.remove("ghd-has-tabbar");
    }
  },

  _offlineBanner: null,
  _offlineBannerDismissTimer: null,
  _connectivityState: "unknown",
  _connectivityCheckToken: 0,
  // What the last API answer said, or null before there has been one.
  _apiOk: null,

  _initOfflineBanner() {
    const banner = document.createElement("div");
    banner.id = "offline-banner";
    banner.textContent = t("app.offline_banner");
    document.body.appendChild(banner);

    this._offlineBanner = banner;

    const recheck = () => {
      // Force a fresh probe: connectivity just changed, so a shared in-flight
      // result (possibly from before the change) would be stale. This is what
      // /health is for now — the browser has just told us something changed,
      // and no page request may be in flight to say what it changed to.
      this._probeApiStatus({ fresh: true, announceRecovery: true });
    };

    window.addEventListener("offline", recheck);
    window.addEventListener("online", recheck);
    // Back from the background or the back/forward cache: whatever the banner
    // said may be days old, and the browser may never say what changed. A
    // glance at another tab is not worth a /health of its own.
    let hiddenAt = 0;
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        hiddenAt = Date.now();
        return;
      }
      if (this._connectivityState === "offline" || Date.now() - hiddenAt > RESUME_RECHECK_AFTER_MS) recheck();
    });
    window.addEventListener("pageshow", (e) => {
      if (e.persisted) recheck();
    });
    banner.addEventListener("click", recheck);

    this._settleInitialConnectivity();
  },

  /* Boot's answer to "is the API there". */
  _settleInitialConnectivity() {
    // Nothing to listen to: app.js is running without api.js (the vm sandboxes).
    if (typeof window.Api?.onApiAnswer !== "function") {
      this._probeApiStatus();
      return;
    }

    let settled = false;
    const waited = setTimeout(() => {
      if (settled) return;
      settled = true;
      this._probeApiStatus();
    }, API_ANSWER_WAIT_MS);

    Api.onApiAnswer((ok) => {
      if (settled) {
        // Later answers keep the dot current — cheaply, since only a change
        // reaches the DOM. An answer is also proof of a connection, so it takes
        // the banner down; a failure leaves the banner to the probe, since one
        // request can fail for reasons of its own (a timeout, a stop).
        if (ok && this._connectivityState === "offline") {
          // Outranks any probe still in flight, which may predate this answer.
          this._connectivityCheckToken += 1;
          this._setOfflineBannerState(true);
          this._connectivityState = "online";
        }
        if (ok !== this._apiOk) {
          this._apiOk = ok;
          this._paintApiStatus(ok);
        }
        return;
      }
      settled = true;
      clearTimeout(waited);
      if (!ok) {
        this._probeApiStatus({ fresh: true });
        return;
      }
      this._connectivityState = "online";
      this._setOfflineBannerState(true, { announceRecovery: false });
      this._apiOk = true;
      this._paintApiStatus(true);
    });
  },

  _setOfflineBannerState(isOnline, { announceRecovery = true } = {}) {
    const banner = this._offlineBanner;
    if (!banner) return;

    clearTimeout(this._offlineBannerDismissTimer);
    this._offlineBannerDismissTimer = null;
    clearTimeout(this._offlineRecheckTimer);
    this._offlineRecheckTimer = null;

    if (!isOnline) {
      banner.classList.remove("back-online");
      banner.textContent = t("app.offline_banner");
      banner.classList.add("visible");
      return;
    }

    const wasOffline = this._connectivityState === "offline";
    banner.classList.remove("back-online");

    if (wasOffline && announceRecovery) {
      banner.textContent = t("app.back_online");
      banner.classList.add("visible", "back-online");
      this._offlineBannerDismissTimer = setTimeout(() => {
        banner.classList.remove("visible", "back-online");
      }, 2000);
      return;
    }

    banner.classList.remove("visible");
  },

  _offlineRecheckTimer: null,

  /* Ask again while the banner is up, so it can never outstay the outage. A
     hidden page skips its turn; becoming visible asks anyway. */
  _scheduleOfflineRecheck() {
    clearTimeout(this._offlineRecheckTimer);
    this._offlineRecheckTimer = setTimeout(() => {
      this._offlineRecheckTimer = null;
      if (this._connectivityState !== "offline") return;
      if (document.visibilityState === "hidden") {
        this._scheduleOfflineRecheck();
        return;
      }
      this._probeApiStatus({ fresh: true, announceRecovery: true });
    }, OFFLINE_RECHECK_MS);
  },

  /* One request to /health, answering the two different questions its callers ask.
     `connectivity`: "online" if any bytes came back (even a 5xx or 530: that is the
     API's problem, not the network), "offline" if nothing could leave the device,
     "unknown" on timeout (decides nothing). `apiOk`: false on non-2xx or timeout. */
  async _probeConnectivity({ fresh = false } = {}) {
    // Concurrent callers share one probe (boot fires _checkApiStatus and
    // _initOfflineBanner back-to-back — no need for two /health requests).
    // `fresh` bypasses the shared probe for connectivity-change rechecks,
    // where an in-flight result may predate the change.
    if (this._probeInFlight && !fresh) return this._probeInFlight;
    const probe = (async () => {
      // The deadline is set up inside `ask`, called from the try, not beside
      // this declaration: everything the /health call needs belongs where a
      // browser that lacks it lands in the catch and the probe still answers.
      let timer = null;
      const ask = async () => {
        clearTimeout(timer);
        // A controller and a timer, not AbortSignal.timeout(): that one is the
        // young half of this call — Safari shipped it in 16, and the app also
        // runs inside whatever WebView an Android device happens to carry.
        // api.js gives the same reasoning for AbortSignal.any(); this is the
        // other half of it. AbortController is from 2018 and is everywhere.
        // The abort then arrives as AbortError rather than TimeoutError, which
        // the catch below already reads as the same thing.
        const deadline = new AbortController();
        timer = setTimeout(() => deadline.abort(), 5000);
        return fetch(`${CONFIG.API_BASE_URL}/health`, {
          cache: "no-store",
          signal: deadline.signal,
        });
      };
      try {
        let res;
        try {
          res = await ask();
        } catch (err) {
          // fetch() reports a request that got no answer as a TypeError.
          if (err?.name !== "TypeError" || navigator.onLine === false) throw err;
          await new Promise((resolve) => setTimeout(resolve, PROBE_RETRY_MS));
          res = await ask();
        }
        return { connectivity: "online", apiOk: res.ok };
      } catch (err) {
        // The browser's own verdict outranks anything we can infer from one
        // failed request, including a deadline this device never had a chance
        // of meeting.
        if (navigator.onLine === false) return { connectivity: "offline", apiOk: false };
        const timedOut = err?.name === "TimeoutError" || err?.name === "AbortError";
        return { connectivity: timedOut ? "unknown" : "offline", apiOk: false };
      } finally {
        clearTimeout(timer);
      }
    })();
    this._probeInFlight = probe;
    // Released when the probe settles, and from out here rather than from a
    // `finally` inside it. Inside, the release reads `probe` — the binding this
    // very statement is still initialising — and a body that finishes without
    // ever reaching an await runs that `finally` synchronously, before the
    // binding exists. Whatever the try threw was then replaced by "Cannot
    // access 'n' before initialization", raised as a rejection nobody caught:
    // the one shape that both hides the fault and reports itself. It was the
    // most-reported browser error in app_errors in the two days after browser
    // errors started being recorded, every one of them from /login, and not
    // one of them named what had actually thrown.
    const release = () => {
      if (this._probeInFlight === probe) this._probeInFlight = null;
    };
    probe.then(release, release);
    return probe;
  },

  async _refreshConnectivity(options = {}) {
    const token = ++this._connectivityCheckToken;
    const result = await this._probeConnectivity({ fresh: options.fresh });
    // Overtaken by a newer probe or by an API answer: it decides nothing.
    if (token !== this._connectivityCheckToken) return { ...result, stale: true };

    // "unknown" means the probe learned nothing, so it changes nothing: a banner
    // that is up stays up, and one that is down stays down.
    if (result.connectivity !== "unknown") {
      this._setOfflineBannerState(result.connectivity === "online", options);
      this._connectivityState = result.connectivity;
    }
    if (this._connectivityState === "offline") this._scheduleOfflineRecheck();
    return result;
  },

  /** Ask /health, and paint the dot with what it says. */
  async _probeApiStatus({ fresh = false, announceRecovery = false } = {}) {
    const { apiOk, stale } = await this._refreshConnectivity({ fresh, announceRecovery });
    if (stale) return apiOk;
    this._apiOk = apiOk;
    this._paintApiStatus(apiOk);
    return apiOk;
  },

  _paintApiStatus(apiOk) {
    document.querySelectorAll("#api-status-dot, #settings-api-dot").forEach((dot) => {
      dot.classList.toggle("status-ok", apiOk);
      dot.classList.toggle("status-err", !apiOk);
    });
  },

  /* Paint a dot that has just been rendered — the Settings page draws its own. */
  async _checkApiStatus() {
    const dots = document.querySelectorAll("#api-status-dot, #settings-api-dot");
    if (!dots.length) return;
    if (this._apiOk !== null) {
      this._paintApiStatus(this._apiOk);
      return;
    }
    await this._probeApiStatus();
  },

  /* Tell the marketing site whether this person is signed in.
     A parent-domain cookie is the only thing both origins can read. It is a flag,
     never a session or identity. Not `Secure` on localhost (plain HTTP in dev). */
  _publishSignedInHint(signedIn) {
    this._publishSiteHint("ghd_signed_in", signedIn ? "1" : "");
    // Signed out, the plan hint is the last account's and goes with it.
    if (!signedIn) this._publishSiteHint("ghd_plan", "");
  },

  /* The plan the pricing page should greet this account with ("free" | "pro"),
     under the same rules as the flag above: a hint for what it shows, never a
     grant — every button it changes leads somewhere that checks the real plan. */
  _publishPlanHint(plan) {
    if ((plan === "pro" || plan === "free") && !`; ${document.cookie};`.includes(`; ghd_plan=${plan};`))
      this._publishSiteHint("ghd_plan", plan);
  },

  /* Every shell page reads the plan, so the hint follows each answer. Not the
     "plan" key alone: that fires only on a change, and a plan the saved
     snapshot already held never changes, so its hint was never written. */
  _followPlanHint() {
    GHD.store?.onChange(["plan", "subscription", "quota"], () => this._publishPlanHint(GHD.store.plan()));
  },

  /* One parent-domain cookie; an empty value deletes it. */
  _publishSiteHint(name, value) {
    try {
      const isLocal = location.hostname === "localhost" || location.hostname === "127.0.0.1";
      const domain = isLocal ? "" : "; Domain=.gethumandesign.com";
      const secure = isLocal ? "" : "; Secure";
      const age = value ? "; Max-Age=" + 60 * 60 * 24 * 365 : "; Max-Age=0";
      document.cookie = name + "=" + value + "; Path=/" + domain + "; SameSite=Lax" + secure + age;
    } catch (e) {
      /* cookies disabled — the site just keeps showing signed-out chrome */
    }
  },

  _updateNav(session) {
    this._publishSignedInHint(!!session);
    const nav = document.getElementById("nav-actions");
    const mobileActions = document.getElementById("mobile-nav-actions");
    if (!nav) return;

    const signOut = async () => {
      // Signing out is the one thing this nav does that needs the SDK, and it
      // is a click, not a page load — so the fetch happens here rather than on
      // every boot.
      const sb = await this.ensureSupabase();
      await sb.auth.signOut();
    };

    if (session) {
      nav.innerHTML = `
        <span class="nav-email"></span>
        <button class="btn-signout" id="signout-btn">${t("app.sign_out")}</button>
      `;
      document.getElementById("signout-btn").addEventListener("click", signOut);
      nav.querySelector(".nav-email").textContent = session.user.email;
      if (mobileActions) {
        mobileActions.innerHTML = `
          <span class="nav-email"></span>
          <button class="btn-signout" id="mobile-signout-btn">${t("app.sign_out")}</button>
        `;
        document.getElementById("mobile-signout-btn").addEventListener("click", signOut);
        mobileActions.querySelector(".nav-email").textContent = session.user.email;
      }
    } else {
      nav.innerHTML = `<a href="${GHD.router.href("/login")}" class="btn-signin">${t("app.sign_in")}</a>`;
      if (mobileActions) {
        mobileActions.innerHTML = `<a href="${GHD.router.href("/login")}" class="btn-signin">${t("app.sign_in")}</a>`;
      }
    }
  },
};

// The export convention — see the boot list above. Two dev-only scripts
// (js/dev-autologin.js, js/dev-bar.js) are injected after the deferred chain
// and used to poll `typeof App` because a top-level `const` is invisible on
// `window`; they wait for the `ghd:app-ready` event below instead.
window.App = App;

document.addEventListener("DOMContentLoaded", () => {
  const start = () => {
    App.init();
    // Boot is done and App.supabase can be asked for. Fired on the document, not
    // on window, so a script injected into <body> after the deferred chain can
    // still catch it — and re-readable afterwards through App.ready, since a
    // listener added late would otherwise wait forever.
    App.ready = true;
    // Guarded like router.js's own dispatch: several vm sandboxes boot app.js
    // with a document but no event constructors, and App.ready alone answers the
    // same question for anything already running.
    if (typeof window.CustomEvent === "function") document.dispatchEvent(new window.CustomEvent("ghd:app-ready"));
  };
  // The locale bundle is fetched by i18n/bundles-loader.js off the parser's
  // critical path, so on a cold cache it can still be in flight here. The first
  // paint waits for it: a page drawn on the message keys and redrawn a moment
  // later is worse than the wait, which the shell's preload keeps short. The
  // sandboxes that boot this file without the runtime take the direct path.
  const i18n = window.GHD_I18N;
  if (i18n && typeof i18n.isReady === "function" && !i18n.isReady()) i18n.ready.then(start);
  else start();
});

;
/* dashboard/js/sw-register.js */
// The service worker: registration, the silent update reload, and the ?q= deep
// link stashed so it survives one.
//
// Nothing here happens as this file evaluates. `GHD.swRegister.init()` — the
// boot list in js/app.js — is what registers the worker, wires the reload and
// reads the query, so the order of the <script> tags in dashboard/index.html no
// longer decides when a page reload can happen.
(function () {
  window.GHD = window.GHD || {};

  var appVersion = "dev";
  var isLocalhost = false;
  var hasServiceWorker = false;
  var ignoreNextControllerChange = false;
  var swRefreshPendingKey = null;
  var swReloadAttemptedKey = null;
  var wired = false;

  function clearStaleRefreshState() {
    var pendingVersion = GHD.storage.session.get(swRefreshPendingKey);
    if (pendingVersion && pendingVersion !== appVersion) {
      GHD.storage.session.remove(swRefreshPendingKey);
    }

    var attemptedVersion = GHD.storage.session.get(swReloadAttemptedKey);
    if (attemptedVersion && attemptedVersion !== appVersion) {
      GHD.storage.session.remove(swReloadAttemptedKey);
    }
  }

  function isRefreshPending() {
    return GHD.storage.session.get(swRefreshPendingKey) === appVersion;
  }

  // A new release was deployed while this page was open. Instead of nagging
  // with a banner, silently reload at a safe moment: while the app is hidden
  // (invisible to the user) or on the next SPA route change (the page is
  // re-rendering anyway; chat drafts persist in localStorage). Never reload
  // mid chat response, and at most once per version so a reload that lands
  // on stale HTML (e.g. offline fallback) cannot loop.
  //
  // Nor while there is unsent text in the composer. Drafts do survive a reload,
  // but a page that empties and refills itself under someone mid-sentence still
  // costs them their cursor, their scroll position and — on a phone — the
  // keyboard; and in a private chat, where nothing is written down, it costs the
  // message itself. There is no urgency to trade that against: the update
  // applies at the next route change, the next time the app is hidden with the
  // composer empty, or the next cold start.
  // Returns true when a reload was initiated, so the caller can stop touching
  // the DOM — location.reload() only takes effect after the current task.
  function maybeReloadForUpdate() {
    if (!isRefreshPending()) return false;
    if (GHD.storage.session.get(swReloadAttemptedKey) === appVersion) return false;
    // The turn module, not the chat page: a reply now keeps generating after
    // the reader has navigated away from the chat page, and a route change is
    // exactly when this runs. Reloading then would be the one thing that still
    // kills it — the document goes, and the stream with it. What is left for
    // the page to answer is the text in its composer and a private transcript
    // that only exists in this document.
    if (GHD.chatTurn?.isSending()) return false;
    if (window.Chat && !Chat.canReloadNow()) return false;

    // The queued draft write is owed to storage before the page goes. The
    // listeners in drafts.js already run ahead of this one on the hidden path,
    // so this is the belt to their braces — and the only cover on the route-change
    // path, which fires no lifecycle event at all.
    GHD.drafts?.flush();
    // Only reload once the attempt is on the record. This flag is the sole
    // thing that stops the reload repeating, and a device that cannot write
    // sessionStorage reads it back absent every time — so a blind reload here
    // would loop the page forever. Not reloading costs the user a stale
    // release until they navigate; the alternative costs them the app.
    if (!GHD.storage.session.set(swReloadAttemptedKey, appVersion)) return false;
    location.reload();
    return true;
  }

  /* A newer release is live, proven by a file this release's /v/ tree no longer
     serves (js/lazy-libs.js, on a chunk that fails to load). Same guards and
     one attempt per version as a worker takeover; a refused reload keeps the
     pending flag. Returns true when the page is reloading. */
  function reloadForNewRelease() {
    if (!wired) return false;
    GHD.storage.session.set(swRefreshPendingKey, appVersion);
    return maybeReloadForUpdate();
  }

  // Local dev must never run a service worker. We skip *registration* on
  // localhost, but a SW registered in a past session (e.g. when the dev server
  // was reached via a LAN host where the guard above was false) keeps
  // controlling the page and serves stale precached HTML/JS — silently breaking
  // new features (e.g. an index.html that predates a new <script> tag). Tear any
  // down, drop its caches, and reload once if one was still controlling us.
  function purgeLocalWorker() {
    if (!isLocalhost || !("serviceWorker" in navigator)) return;
    Promise.all([
      navigator.serviceWorker.getRegistrations().then(function (regs) {
        return Promise.all(
          regs.map(function (r) {
            return r.unregister();
          }),
        );
      }),
      window.caches && caches.keys
        ? caches.keys().then(function (keys) {
            return Promise.all(
              keys.map(function (k) {
                return caches.delete(k);
              }),
            );
          })
        : null,
    ])
      .then(function () {
        // Same one-shot rule as the update reload above: the flag has to land
        // before the page goes, or an unwritable sessionStorage turns this
        // into a reload loop.
        if (navigator.serviceWorker.controller && !GHD.storage.session.get(GHD.KEYS.swPurged)) {
          if (GHD.storage.session.set(GHD.KEYS.swPurged, "1")) location.reload();
        }
      })
      .catch(function () {});
  }

  // Stashed before the service worker can swap the page out from under a
  // ?q= deep link. router.js has already turned a legacy "/chat?q=…" into a
  // path by the time this runs, so the query is the one place to look.
  function stashSeedQuery() {
    var seedParams = GHD.router.query();
    if (seedParams.get("q")) GHD.storage.session.set(GHD.KEYS.chatSeedQuery, seedParams.get("q"));
    if (seedParams.get("starter")) GHD.storage.session.set(GHD.KEYS.chatSeedStarter, seedParams.get("starter"));
  }

  function registerWorker() {
    if (!hasServiceWorker) return;
    var swRegistration = null;

    navigator.serviceWorker.addEventListener("controllerchange", function () {
      if (ignoreNextControllerChange) {
        ignoreNextControllerChange = false;
        return;
      }
      GHD.storage.session.set(swRefreshPendingKey, appVersion);
      if (document.visibilityState === "hidden") maybeReloadForUpdate();
    });

    // Hidden: apply a pending update invisibly. Visible: check for a new
    // release, so a long-lived PWA picks up deploys on every resume instead
    // of waiting for the browser's daily update check or a cold start.
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") {
        maybeReloadForUpdate();
      } else if (swRegistration) {
        swRegistration.update().catch(function () {});
      }
    });

    // Once this page has loaded and gone idle, ask the worker to cache the
    // route chunks and the locale bundles this page runs (sw.js WARM_ASSETS):
    // off the install, so a first visit and a new release are not held by them.
    var warm = function () {
      var locales = [];
      document.querySelectorAll('script[src*="/i18n/bundles."]').forEach(function (el) {
        var m = /\/i18n\/bundles\.([a-z]+)\.js/.exec(el.src);
        if (m) locales.push(m[1]);
      });
      navigator.serviceWorker.ready.then(function (registration) {
        registration.active?.postMessage({ type: "ghd:warm", locales: locales });
      });
    };
    var idle = function () {
      (window.requestIdleCallback || setTimeout)(warm, { timeout: 5000 });
    };
    if (document.readyState === "complete") idle();
    else window.addEventListener("load", idle, { once: true });

    navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .then(function (registration) {
        swRegistration = registration;
        return registration.update();
      })
      .catch(function (err) {
        console.warn("Service worker registration failed", err);
      });
  }

  /* Register the worker and wire everything that can reload the page.
     Must run after GHD.drafts.init(), whose flush listeners have to exist before
     an update reload can fire. Idempotent. */
  function init() {
    if (wired) return;
    wired = true;

    var appVersionMeta = document.querySelector('meta[name="version"]');
    appVersion = appVersionMeta ? appVersionMeta.content : "dev";
    isLocalhost = location.hostname === "localhost" || location.hostname === "127.0.0.1";
    hasServiceWorker = "serviceWorker" in navigator && !isLocalhost;
    ignoreNextControllerChange = hasServiceWorker && !navigator.serviceWorker.controller;
    swRefreshPendingKey = GHD.KEYS.swRefreshPending;
    swReloadAttemptedKey = GHD.KEYS.swReloadAttempted;

    clearStaleRefreshState();
    window.__maybeAppUpdateReload = maybeReloadForUpdate;
    purgeLocalWorker();
    stashSeedQuery();
    registerWorker();
  }

  GHD.swRegister = { init: init, reloadForNewRelease: reloadForNewRelease };
})();

;
/* dashboard/js/cf-beacon.js */
// Cloudflare Web Analytics (production only; skipped in local dev).
//
// An external file rather than an inline <script> because our CSP is
// `script-src 'self' …` with no 'unsafe-inline' — inline, the browser refused to
// run it and the app origin reported no analytics at all. static.cloudflareinsights.com
// is named in script-src, so the beacon it injects is fine; only the injector had
// to move out of the document.
//
// IIFE: build_site.py concatenates the dashboard's deferred scripts into one
// bundle, where a bare top-level `var` shares scope with 50 other files.
//
// The beacon goes in from `GHD.cfBeacon.init()` — last in App's boot list, the
// one entry nothing else waits for.
(function () {
  window.GHD = window.GHD || {};
  var injected = false;

  GHD.cfBeacon = {
    init: function () {
      if (injected) return;
      var host = location.hostname;
      if (host === "localhost" || host === "127.0.0.1") return;
      injected = true;
      var beacon = document.createElement("script");
      beacon.defer = true;
      beacon.src = "https://static.cloudflareinsights.com/beacon.min.js";
      beacon.setAttribute("data-cf-beacon", '{"token": "4b81e21a652c4a06a15c6fab5f369208"}');
      document.body.appendChild(beacon);
    },
  };
})();

